import { defineComponent as q, openBlock as c, createElementBlock as w, renderSlot as se, ref as I, watch as le, onMounted as de, computed as b, normalizeClass as U, unref as S, createBlock as O, resolveDynamicComponent as Tt, withCtx as H, createElementVNode as M, createCommentVNode as P, createVNode as z, onBeforeUnmount as Ve, createTextVNode as K, toDisplayString as W, mergeProps as me, Fragment as ne, withModifiers as We, normalizeStyle as ge, renderList as ue, Transition as Ue, getCurrentScope as Va, onScopeDispose as qa, isRef as ja, nextTick as Qe, getCurrentInstance as ea, reactive as en, withDirectives as ve, vShow as pe, useAttrs as ta, onUnmounted as na, Teleport as aa, watchEffect as ln, inject as ee, provide as fe, normalizeProps as Wa, guardReactiveProps as Ua, mergeDefaults as ra, useSlots as Ka, toRefs as Ga, toRef as Ya } from "vue";
const Qa = { class: "ds-accordion" }, sd = /* @__PURE__ */ q({
  __name: "ds-accordion",
  setup(n) {
    return (e, t) => (c(), w("div", Qa, [
      se(e.$slots, "default")
    ]));
  }
}), Nn = "6.3.2", bt = /* @__PURE__ */ new Map();
function sa(n, e, t, a, r) {
  const s = I(""), i = `${n}-version`, o = async (m) => {
    if (bt.has(m))
      return bt.get(m);
    const p = fetch(m).then(async (L) => {
      if (L.ok) {
        const x = await L.text();
        return bt.delete(m), x;
      } else
        throw new Error("Failed to load icon");
    }).catch(() => {
      throw bt.delete(m), new Error("Failed to load icon");
    });
    return bt.set(m, p), p;
  }, u = async () => {
    const m = `${f()}/${r.value}.svg`, L = m.split("/").slice(-2).join("/"), x = `${n}|${Nn}|${L}`, D = localStorage.getItem(x), E = D == null ? void 0 : D.startsWith("<svg");
    if (D && E)
      s.value = D;
    else {
      localStorage.removeItem(x);
      let T;
      try {
        T = await o(m), T && (s.value = T, localStorage.setItem(x, T));
      } catch (g) {
        console.error(g);
      }
    }
  }, l = () => window.dsConfig ? n === "ds-brand-icon" ? window.dsConfig.brandIconBasePath : window.dsConfig.iconBasePath : null, f = () => {
    const m = l();
    let p = t;
    return m && t === e && (p = m), p;
  }, v = () => {
    const m = Nn;
    localStorage.getItem(i) !== m && (Object.keys(localStorage).forEach((L) => {
      const x = L.startsWith("icon-"), D = L.startsWith("brand-icon-"), E = L.startsWith(`${n}|`) && !L.includes(`|${m}|`);
      (x || E || D) && localStorage.removeItem(L);
    }), localStorage.setItem(i, m));
  }, d = async () => {
    try {
      await u();
    } catch (m) {
      console.error(m);
    }
  };
  return le(
    () => r.value,
    async () => {
      await d();
    }
  ), de(async () => {
    v(), await d(), a("iconLoaded");
  }), { loadIcon: u, svgContents: s };
}
const Xa = ["aria-hidden", "aria-label", "role", "innerHTML", "data-icon-name"], Za = "ds-icon", Ja = "/dist/shared/images/design-system-icons", ae = /* @__PURE__ */ q({
  __name: "ds-icon",
  props: {
    /** Location of the icon files (no trailing slash) */
    basePath: {
      default: "/dist/shared/images/design-system-icons",
      type: String
    },
    /** Accessibility label: set if you want a screenreader to know what this icon represents */
    label: {
      default: null,
      type: String
    },
    /** Icon name: these correspond to the icon file names, e.g. {name}.svg  */
    iconName: {
      required: !0,
      type: String
    },
    /** Size option for the icon */
    size: {
      default: "md",
      type: String
    }
  },
  emits: ["iconLoaded"],
  setup(n, { expose: e, emit: t }) {
    const a = n, r = b(() => a.iconName), s = t, { loadIcon: i, svgContents: o } = sa(
      Za,
      Ja,
      a.basePath,
      s,
      r
    );
    return e({ loadIcon: i }), (u, l) => (c(), w("span", {
      "aria-hidden": n.label ? void 0 : !0,
      "aria-label": n.label ? n.label : void 0,
      role: n.label ? "img" : void 0,
      class: U(["ds-icon", `ds-icon--${n.size}`]),
      innerHTML: S(o),
      "data-icon-name": r.value,
      "data-testid": "ds-banner-icon"
    }, null, 10, Xa));
  }
}), Y = /* @__PURE__ */ q({
  __name: "ds-text",
  props: {
    htmlElement: { default: "p" },
    textStyle: { default: "default" },
    textType: { default: "body-md" }
  },
  setup(n) {
    const e = n, t = b(
      () => `ds-text-${e.textType.toLowerCase().replace("_", "-")}`
    ), a = b(
      () => ` ds-text--${e.textStyle.toLowerCase()}`
    ), r = b(
      () => `${t.value}${a.value}`
    );
    return (s, i) => (c(), O(Tt(s.htmlElement), {
      class: U(r.value)
    }, {
      default: H(() => [
        se(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), er = { class: "ds-accordion-item__summary" }, tr = ["innerHTML"], od = /* @__PURE__ */ q({
  __name: "ds-accordion-item",
  props: {
    iconName: {},
    title: {}
  },
  setup(n) {
    const e = n, t = b(() => e.iconName ? "ds-accordion-item--has-icon" : null);
    return (a, r) => (c(), w("details", {
      class: U(["ds-accordion-item", t.value])
    }, [
      M("summary", er, [
        a.iconName ? (c(), O(ae, {
          key: 0,
          class: "ds-accordion-item__icon",
          "icon-name": a.iconName
        }, null, 8, ["icon-name"])) : P("", !0),
        z(Y, {
          "html-element": "span",
          "text-type": "heading-lg",
          "text-style": "medium",
          class: "ds-accordion-item__title"
        }, {
          default: H(() => [
            M("span", {
              class: "ds-accordion-item__title-text",
              innerHTML: a.title
            }, null, 8, tr)
          ]),
          _: 1
        }),
        z(ae, {
          class: "ds-accordion-item__expand-icon",
          "icon-name": "chevron-down",
          size: "lg"
        })
      ]),
      z(Y, {
        class: "ds-accordion-item__content",
        "html-element": "div",
        "text-type": "body-md"
      }, {
        default: H(() => [
          se(a.$slots, "default")
        ]),
        _: 3
      })
    ], 2));
  }
}), Ie = (n = 768) => {
  const e = I(!1);
  let t = null;
  const a = (r) => {
    e.value = !r.matches;
  };
  return de(() => {
    t = window.matchMedia(`(min-width: ${n}px)`), t.addEventListener("change", a), e.value = !t.matches;
  }), Ve(() => {
    t && t.removeEventListener("change", a);
  }), { isMobile: e };
}, nr = ["role"], ar = { class: "ds-alert__content" }, rr = ["innerHTML"], sr = ["aria-label"], or = /* @__PURE__ */ q({
  __name: "ds-alert",
  props: {
    appearance: { default: "neutral" },
    title: {},
    text: {},
    showIcon: { type: Boolean, default: !0 },
    dismissible: { type: Boolean, default: !1 },
    dismissLabel: { default: "Close" }
  },
  setup(n) {
    const e = n, { isMobile: t } = Ie(), a = b(() => t.value ? "md" : "lg"), r = b(
      () => `ds-alert--${e.appearance} ${e.showIcon ? "ds-alert--icon" : ""} ${e.dismissible ? "ds-alert--dismissable" : ""}`
    ), s = b(() => e.appearance === "attention" ? "warning-circle" : e.appearance === "danger" ? "danger-circle" : "information-circle"), i = b(() => e.appearance === "attention" || e.appearance === "danger" ? "alert" : "status"), o = I(!1), u = () => {
      o.value = !0;
    };
    return (l, f) => o.value ? P("", !0) : (c(), w("div", {
      key: 0,
      role: i.value,
      class: U(["ds-alert", r.value])
    }, [
      l.showIcon ? (c(), O(ae, {
        key: 0,
        size: a.value,
        "icon-name": s.value,
        class: "ds-alert__icon"
      }, null, 8, ["size", "icon-name"])) : P("", !0),
      M("div", ar, [
        l.title ? (c(), O(Y, {
          key: 0,
          "html-element": "h3",
          "text-type": "body-md",
          "text-style": "bold",
          class: "ds-alert__title"
        }, {
          default: H(() => [
            K(W(l.title), 1)
          ]),
          _: 1
        })) : P("", !0),
        z(Y, {
          "html-element": "div",
          "text-type": "body-md",
          "text-style": "regular",
          class: "ds-alert__text"
        }, {
          default: H(() => [
            M("div", { innerHTML: l.text }, null, 8, rr)
          ]),
          _: 1
        })
      ]),
      l.dismissible ? (c(), w("button", {
        key: 1,
        "aria-label": l.dismissLabel,
        class: "ds-alert__dismiss",
        onClick: u
      }, [
        z(ae, {
          "icon-name": "button-close",
          size: "sm",
          class: "ds-alert__dismiss-icon"
        })
      ], 8, sr)) : P("", !0)
    ], 10, nr));
  }
}), lr = /* @__PURE__ */ q({
  __name: "ds-badge",
  props: {
    text: {},
    variant: { default: "neutral" }
  },
  setup(n) {
    const t = `ds-badge--${n.variant}`;
    return (a, r) => (c(), w("span", {
      class: U(["ds-badge", t])
    }, W(a.text), 1));
  }
}), An = I(0);
function Ze(n) {
  return An.value++, `${n}-${An.value}`;
}
const ir = ["aria-labelledby"], ur = { class: "ds-banner__inner" }, cr = { class: "ds-banner__content" }, dr = ["innerHTML", "id"], ld = /* @__PURE__ */ q({
  __name: "ds-banner-sm",
  props: {
    iconName: { default: "information-circle" },
    text: {},
    showIcon: { type: Boolean, default: !0 }
  },
  setup(n) {
    const e = n, { isMobile: t } = Ie(), a = b(() => t.value ? "md" : "lg"), r = `${e.showIcon ? "ds-banner--icon" : ""}`, s = Ze("banner-content");
    return (i, o) => (c(), w("section", me({
      "aria-labelledby": S(s),
      class: ["ds-banner", r]
    }, i.$attrs), [
      M("div", ur, [
        i.showIcon ? (c(), O(ae, {
          key: 0,
          size: a.value,
          "icon-name": i.iconName,
          class: "ds-banner__icon"
        }, null, 8, ["size", "icon-name"])) : P("", !0),
        M("div", cr, [
          z(Y, {
            "html-element": "div",
            "text-type": "body-md",
            "text-style": "regular",
            class: "ds-banner__text"
          }, {
            default: H(() => [
              M("div", {
                innerHTML: i.text,
                id: S(s)
              }, null, 8, dr)
            ]),
            _: 1
          })
        ])
      ])
    ], 16, ir));
  }
}), fr = { class: "ds-spinner-animation" }, mr = /* @__PURE__ */ M("svg", {
  width: "56",
  height: "56",
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ M("rect", {
    class: "ds-spinner-animation__track",
    x: "3",
    y: "3",
    width: "50",
    height: "50",
    rx: "25",
    "stroke-width": "6"
  }),
  /* @__PURE__ */ M("path", {
    class: "ds-spinner-animation__snake",
    d: "M4.50674 36.5508C2.95033 37.1173 1.21245 36.3169 0.815599 34.7089C-0.175426 30.6933 -0.26744 26.4951 0.562107 22.4177C1.59161 17.3575 4.00037 12.6806 7.52209 8.90405C11.0438 5.12747 15.5413 2.39833 20.5173 1.01835C24.5269 -0.0935997 28.7213 -0.294665 32.7962 0.413827C34.428 0.697543 35.3477 2.37535 34.8912 3.96749V3.96749C34.4347 5.55962 32.7738 6.45833 31.1344 6.22238C28.1328 5.79039 25.0632 5.98204 22.1202 6.79819C18.2101 7.88256 14.6761 10.0271 11.9087 12.9947C9.14142 15.9623 7.24865 19.6373 6.43968 23.6135C5.83081 26.6062 5.85375 29.6818 6.49408 32.6459C6.84381 34.2648 6.06315 35.9844 4.50674 36.5508V36.5508Z"
  })
], -1), vr = [
  mr
], oa = /* @__PURE__ */ q({
  __name: "ds-spinner-animation",
  setup(n) {
    return (e, t) => (c(), w("div", fr, vr));
  }
}), pr = [
  "button-add",
  "button-chevron-down",
  "button-chevron-left",
  "button-chevron-right",
  "button-chevron-up",
  "button-close",
  "button-delete",
  "button-document",
  "button-download",
  "button-external-link",
  "button-filter",
  "button-information",
  "button-information-circle",
  "button-menu",
  "button-more",
  "button-navigate-back",
  "button-navigate-down",
  "button-navigate-forward",
  "button-navigate-up",
  "button-pause",
  "button-play",
  "button-print",
  "button-question",
  "button-question-circle",
  "button-search",
  "button-share-ios",
  "button-shopping-basket",
  "button-zoom-in",
  "button-zoom-out"
], un = ({
  variant: n,
  size: e,
  selected: t = b(() => !1),
  padding: a = null,
  isValidLoadingState: r = b(() => !1)
}, s) => b(() => {
  let i = [];
  return i = yt(i, s, n.value), i = yt(i, s, e.value), i = yt(
    i,
    s,
    t.value ? "selected" : void 0
  ), i = yt(
    i,
    s,
    a,
    a !== "padding-normal"
  ), i = yt(
    i,
    s,
    "loading",
    r.value
  ), i;
}), yt = (n, e, t, a = !0) => (t && a && n.push(`${e}--${t}`), n), tn = (n) => {
  if (!n.startsWith("button-")) {
    const e = `button-${n}`;
    if (hr(e))
      return e;
  }
  return n;
}, hr = (n, e = !1) => n ? pr.includes(n) ? !0 : (e && console.warn(
  `Icon "${n}" is not part of the button icon subset. Ensure you're using a "button-" prefixed icon name or reach out to the DS team.`
), !1) : !0, gr = ["aria-disabled", "disabled", "form", "name", "selected", "type", "value"], br = ["aria-disabled", "download", "href", "selected", "target"], be = /* @__PURE__ */ q({
  __name: "ds-button",
  props: {
    clickHandler: { type: Function, default: () => {
    } },
    disabled: { type: Boolean, default: !1 },
    download: { type: [Boolean, String, null], default: null },
    form: {},
    href: {},
    iconStart: {},
    iconEnd: {},
    labelLoading: { default: void 0 },
    name: {},
    padding: { default: void 0 },
    selected: { type: Boolean, default: !1 },
    size: { default: "md" },
    state: { default: "default" },
    target: {},
    type: { default: "button" },
    value: {},
    variant: { default: "secondary-neutral" }
  },
  emits: ["click"],
  setup(n, { emit: e }) {
    const t = n, a = e, r = b(() => t.size === "sm" ? "xs" : "sm"), s = b(() => t.selected), i = b(() => t.size), o = b(() => {
      if (t.iconStart)
        return tn(t.iconStart);
    }), u = b(() => {
      if (t.iconEnd)
        return tn(t.iconEnd);
    }), l = I(t.padding), f = b(() => t.variant);
    (t.variant === "link" || t.variant === "link-neutral" || t.variant === "link-inverted") && !t.padding && (l.value = "padding-none");
    const d = (L) => {
      t.state !== "loading" && (t.clickHandler(L), a("click", L));
    }, m = b(() => (t.variant === "primary" || t.variant === "primary-inverted") && t.state === "loading" && t.labelLoading !== void 0), p = un(
      {
        variant: f,
        size: i,
        padding: l.value,
        selected: s,
        isValidLoadingState: m
      },
      "ds-button"
    );
    return (L, x) => (c(), w(ne, null, [
      L.href ? P("", !0) : (c(), w("button", me({ key: 0 }, L.$attrs, {
        "aria-disabled": m.value || void 0,
        onClick: We(d, ["stop"]),
        class: ["ds-button", S(p)],
        disabled: L.disabled || void 0,
        form: L.form,
        name: L.name,
        selected: L.selected || void 0,
        type: L.type,
        value: L.value
      }), [
        m.value ? P("", !0) : (c(), w(ne, { key: 0 }, [
          o.value ? (c(), O(ae, {
            key: 0,
            class: "ds-button__icon-start",
            "icon-name": o.value,
            size: r.value
          }, null, 8, ["icon-name", "size"])) : P("", !0),
          z(Y, {
            "text-type": "label-md",
            "text-style": "medium",
            "html-element": "span"
          }, {
            default: H(() => [
              se(L.$slots, "default")
            ]),
            _: 3
          }),
          u.value ? (c(), O(ae, {
            key: 1,
            class: "ds-button__icon-end",
            "icon-name": u.value,
            size: r.value
          }, null, 8, ["icon-name", "size"])) : P("", !0)
        ], 64)),
        m.value ? (c(), w(ne, { key: 1 }, [
          z(oa),
          z(Y, {
            "text-type": "label-md",
            "text-style": "medium",
            "html-element": "span"
          }, {
            default: H(() => [
              K(W(L.labelLoading), 1)
            ]),
            _: 1
          })
        ], 64)) : P("", !0)
      ], 16, gr)),
      L.href ? (c(), w("a", me({ key: 1 }, L.$attrs, {
        onClick: d,
        class: ["ds-button", S(p)],
        "aria-disabled": L.disabled || void 0,
        download: L.download === !0 ? "" : L.download,
        href: L.href,
        selected: L.selected || void 0,
        target: L.target
      }), [
        o.value ? (c(), O(ae, {
          key: 0,
          class: "ds-button__icon-start",
          "icon-name": o.value,
          size: r.value
        }, null, 8, ["icon-name", "size"])) : P("", !0),
        z(Y, {
          "text-type": "label-md",
          "text-style": "medium",
          "html-element": "span"
        }, {
          default: H(() => [
            se(L.$slots, "default")
          ]),
          _: 3
        }),
        u.value ? (c(), O(ae, {
          key: 1,
          class: "ds-button__icon-end",
          "icon-name": u.value,
          size: r.value
        }, null, 8, ["icon-name", "size"])) : P("", !0)
      ], 16, br)) : P("", !0)
    ], 64));
  }
}), yr = ["aria-label", "role", "data-icon-name"], _r = ["innerHTML"], kr = "ds-brand-icon", wr = "/dist/shared/images/design-system-brand-icons", la = /* @__PURE__ */ q({
  __name: "ds-brand-icon",
  props: {
    altText: {},
    basePath: { default: "/dist/shared/images/design-system-brand-icons" },
    iconName: {},
    mode: { default: "default" },
    size: { default: "md" },
    type: { default: "line" }
  },
  emits: ["iconLoaded"],
  setup(n, { expose: e, emit: t }) {
    const a = n, r = b(() => a.iconName), s = t, { loadIcon: i, svgContents: o } = sa(
      kr,
      wr,
      a.basePath,
      s,
      r
    ), u = b(() => {
      const l = [];
      return l.push(`ds-brand-icon--${a.size}`), l.push(`ds-brand-icon--${a.type}`), a.mode !== "default" && l.push(`ds-brand-icon--mode-${a.mode}`), l;
    });
    return e({ loadIcon: i }), (l, f) => (c(), w("div", {
      "aria-label": l.altText ? l.altText : void 0,
      role: l.altText ? "img" : void 0,
      class: U(["ds-brand-icon", u.value]),
      "data-icon-name": r.value
    }, [
      M("span", {
        class: "ds-brand-icon__svg",
        "aria-hidden": "true",
        innerHTML: S(o)
      }, null, 8, _r)
    ], 10, yr));
  }
}), $r = ["aria-labelledby"], Ir = {
  key: 1,
  class: "ds-banner-md__content"
}, Tr = { class: "ds-banner-md__icon-slot" }, id = /* @__PURE__ */ q({
  __name: "ds-banner-md",
  props: {
    background: { default: "brand-muted" },
    buttonClickHandler: {},
    buttonHref: {},
    buttonText: {},
    iconName: {},
    iconAltText: {},
    text: {},
    textHtmlElement: { default: "h3" },
    textWrapMode: { default: "balance" }
  },
  setup(n) {
    const e = n, t = I(!1);
    de(() => {
      t.value = !0;
    });
    const a = Ze("banner-md"), { isMobile: r } = Ie(), s = b(() => r.value ? "heading-md" : "heading-3xl"), i = b(() => e.background === "brand-muted" ? "default" : "on-color"), o = b(() => {
      const u = [];
      return u.push(`ds-banner-md--bg-${e.background}`), u.push(`ds-banner-md--tw-${e.textWrapMode}`), u;
    });
    return (u, l) => (c(), w("section", me({
      "aria-labelledby": S(a),
      class: ["ds-banner-md", o.value]
    }, u.$attrs), [
      t.value ? P("", !0) : se(u.$slots, "default", { key: 0 }),
      t.value ? (c(), w("div", Ir, [
        z(Y, {
          class: "ds-banner-md__text",
          id: S(a),
          "text-type": s.value,
          "text-style": "medium",
          "html-element": u.textHtmlElement
        }, {
          default: H(() => [
            K(W(u.text), 1)
          ]),
          _: 1
        }, 8, ["id", "text-type", "html-element"]),
        u.buttonText ? (c(), O(be, {
          key: 0,
          class: "ds-banner-md__cta",
          href: u.buttonHref,
          clickHandler: u.buttonClickHandler,
          variant: "primary"
        }, {
          default: H(() => [
            K(W(u.buttonText), 1)
          ]),
          _: 1
        }, 8, ["href", "clickHandler"])) : P("", !0)
      ])) : P("", !0),
      M("div", Tr, [
        z(la, {
          altText: u.iconAltText,
          iconName: u.iconName,
          mode: i.value,
          size: "md",
          type: "line"
        }, null, 8, ["altText", "iconName", "mode"])
      ])
    ], 16, $r));
  }
}), Sr = ["aria-labelledby"], Pr = {
  key: 1,
  class: "ds-banner-lg__content"
}, Lr = { class: "ds-banner-lg__media" }, Cr = ["sizes", "src", "srcset", "alt"], ud = /* @__PURE__ */ q({
  __name: "ds-banner-lg",
  props: {
    background: { default: "brand-subtle" },
    buttonClickHandler: {},
    buttonHref: {},
    buttonText: {},
    mediaAltText: { default: "" },
    mediaFocalPoint: { default: "center" },
    mediaFocalPointMobile: {},
    mediaSrc: {},
    mediaSrcSet: {},
    mediaSizes: {},
    text: {},
    textHtmlElement: { default: "h3" },
    textWrapMode: { default: "balance" }
  },
  setup(n) {
    const e = n, t = I(!1);
    de(() => {
      t.value = !0;
    });
    const a = Ze("banner-lg"), { isMobile: r } = Ie(), s = b(() => r.value ? "heading-md" : "heading-3xl"), i = b(() => e.mediaFocalPointMobile && r.value ? e.mediaFocalPointMobile : e.mediaFocalPoint), o = b(() => {
      const l = [];
      return e.mediaFocalPoint !== "center" && l.push(`object-position: ${i.value};`), l;
    }), u = b(() => {
      const l = [];
      return l.push(`ds-banner-lg--bg-${e.background}`), l.push(`ds-banner-lg--tw-${e.textWrapMode}`), l;
    });
    return (l, f) => (c(), w("section", me({
      "aria-labelledby": S(a),
      class: ["ds-banner-lg", u.value]
    }, l.$attrs), [
      t.value ? P("", !0) : se(l.$slots, "default", { key: 0 }),
      t.value ? (c(), w("div", Pr, [
        z(Y, {
          class: "ds-banner-lg__text",
          id: S(a),
          "text-type": s.value,
          "text-style": "medium",
          "html-element": l.textHtmlElement
        }, {
          default: H(() => [
            K(W(l.text), 1)
          ]),
          _: 1
        }, 8, ["id", "text-type", "html-element"]),
        z(be, {
          class: "ds-banner-lg__cta",
          href: l.buttonHref,
          clickHandler: l.buttonClickHandler,
          variant: "primary"
        }, {
          default: H(() => [
            K(W(l.buttonText), 1)
          ]),
          _: 1
        }, 8, ["href", "clickHandler"])
      ])) : P("", !0),
      M("figure", Lr, [
        M("img", {
          class: "ds-banner-lg__image",
          style: ge(o.value),
          sizes: l.mediaSizes,
          src: l.mediaSrc,
          srcset: l.mediaSrcSet,
          alt: l.mediaAltText
        }, null, 12, Cr)
      ])
    ], 16, Sr));
  }
}), Mr = ["aria-labelledby"], Er = {
  key: 1,
  class: "ds-banner-xl__content"
}, Nr = { class: "ds-banner-xl__text" }, Ar = ["innerHTML"], xr = { class: "ds-banner-xl__media" }, Br = ["sizes", "src", "srcset", "alt"], cd = /* @__PURE__ */ q({
  __name: "ds-banner-xl",
  props: {
    background: { default: "brand-subtle" },
    buttonClickHandler: {},
    buttonHref: {},
    buttonText: {},
    description: {},
    mediaAltText: { default: "" },
    mediaPlacement: { default: "end" },
    mediaPlacementMobile: { default: "useMediaPlacementValue" },
    mediaFocalPoint: { default: "center" },
    mediaFocalPointMobile: {},
    mediaRenderMode: { default: "cover" },
    mediaRenderModeMobile: { default: "useMediaRenderModeValue" },
    mediaSrc: {},
    mediaSrcSet: {},
    mediaSizes: {},
    textWrapMode: { default: "balance" },
    titleSmall: {},
    titleSmallHtmlElement: { default: "h3" },
    titleLarge: {},
    titleLargeHtmlElement: { default: "h2" }
  },
  setup(n) {
    const e = n, t = I(!1);
    de(() => {
      t.value = !0;
    });
    const a = Ze("banner-xl"), { isMobile: r } = Ie(), s = b(() => e.description ? "long" : "short"), i = b(() => s.value === "long" ? "heading-3xl" : "heading-4xl"), o = b(() => e.mediaFocalPointMobile && r.value ? e.mediaFocalPointMobile : e.mediaFocalPoint), u = b(() => {
      const f = [];
      return e.mediaFocalPoint !== "center" && f.push(`--object-position: ${o.value};`), f;
    }), l = b(() => {
      const f = [];
      return f.push(`ds-banner-xl--${s.value}`), f.push(`ds-banner-xl--bg-${e.background}`), f.push(`ds-banner-xl--media-${e.mediaPlacement}`), f.push(`ds-banner-xl--media-rm-${e.mediaRenderMode}`), f.push(`ds-banner-xl--tw-${e.textWrapMode}`), e.mediaPlacementMobile !== "useMediaPlacementValue" && e.mediaPlacementMobile !== e.mediaPlacement && f.push(
        `ds-banner-xl--media-mobile-${e.mediaPlacementMobile}`
      ), e.mediaRenderModeMobile !== "useMediaRenderModeValue" && e.mediaRenderModeMobile !== e.mediaRenderMode && f.push(
        `ds-banner-xl--media-rm-mobile-${e.mediaRenderModeMobile}`
      ), f;
    });
    return (f, v) => (c(), w("section", me({ "aria-labelledby": S(a) }, f.$attrs, {
      class: ["ds-banner-xl", l.value]
    }), [
      t.value ? P("", !0) : se(f.$slots, "default", { key: 0 }),
      t.value ? (c(), w("div", Er, [
        M("div", Nr, [
          s.value === "short" ? (c(), O(Y, {
            key: 0,
            class: "ds-banner-xl__title-small",
            "text-type": "heading-lg",
            "text-style": "medium",
            "html-element": f.titleSmallHtmlElement
          }, {
            default: H(() => [
              K(W(f.titleSmall), 1)
            ]),
            _: 1
          }, 8, ["html-element"])) : P("", !0),
          z(Y, {
            class: "ds-banner-xl__title-large",
            id: S(a),
            "text-type": i.value,
            "text-style": "medium",
            "html-element": f.titleLargeHtmlElement
          }, {
            default: H(() => [
              K(W(f.titleLarge), 1)
            ]),
            _: 1
          }, 8, ["id", "text-type", "html-element"]),
          s.value === "long" ? (c(), O(Y, {
            key: 1,
            class: "ds-banner-xl__description",
            "text-type": "heading-lg",
            "text-style": "medium",
            "html-element": f.titleSmallHtmlElement
          }, {
            default: H(() => [
              M("span", { innerHTML: f.description }, null, 8, Ar)
            ]),
            _: 1
          }, 8, ["html-element"])) : P("", !0)
        ]),
        z(be, {
          href: f.buttonHref,
          clickHandler: f.buttonClickHandler,
          variant: "primary"
        }, {
          default: H(() => [
            K(W(f.buttonText), 1)
          ]),
          _: 1
        }, 8, ["href", "clickHandler"])
      ])) : P("", !0),
      M("figure", xr, [
        M("img", {
          class: "ds-banner-xl__image",
          style: ge(u.value),
          sizes: f.mediaSizes,
          src: f.mediaSrc,
          srcset: f.mediaSrcSet,
          alt: f.mediaAltText
        }, null, 12, Br)
      ])
    ], 16, Mr));
  }
}), Or = { class: "ds-block__content" }, qt = /* @__PURE__ */ q({
  __name: "ds-block",
  props: {
    background: { default: "default" },
    divider: { type: Boolean, default: !1 },
    grid: { type: Boolean, default: !1 },
    paddingTop: { default: "default" },
    paddingBottom: { default: "default" }
  },
  setup(n) {
    const e = n, t = b(() => {
      const a = {
        [`ds-block--bg-${e.background}`]: e.background !== "default",
        [`ds-block--pt-${e.paddingTop}`]: e.paddingTop !== "default",
        [`ds-block--pb-${e.paddingBottom}`]: e.paddingBottom !== "default",
        "ds-block--divider": e.divider,
        "ds-block--grid": e.grid
      };
      return Object.keys(a).filter((r) => a[r]);
    });
    return (a, r) => (c(), w("section", {
      class: U(["ds-block", t.value])
    }, [
      M("div", Or, [
        se(a.$slots, "default")
      ])
    ], 2));
  }
}), Dr = ["href", "aria-current", "title"], Yt = /* @__PURE__ */ q({
  __name: "ds-breadcrumb-item",
  props: {
    iconStartName: {},
    item: {}
  },
  setup(n) {
    const e = n, a = e.item.name.length > 25 ? e.item.name : void 0;
    return (r, s) => (c(), w("a", {
      class: "ds-breadcrumb__link",
      onClick: s[0] || (s[0] = (i) => {
        r.item.isCurrentPage && i.preventDefault();
      }),
      href: r.item.url,
      "aria-current": r.item.isCurrentPage ? "page" : void 0,
      title: S(a)
    }, [
      r.iconStartName ? (c(), O(ae, {
        key: 0,
        class: "ds-breadcrumb__icon",
        "icon-name": r.iconStartName,
        size: "xs"
      }, null, 8, ["icon-name"])) : P("", !0),
      z(Y, {
        "html-element": "span",
        "text-type": "label-sm"
      }, {
        default: H(() => [
          K(W(r.item.name), 1)
        ]),
        _: 1
      })
    ], 8, Dr));
  }
});
function Me(n) {
  if (n == null)
    return window;
  if (n.toString() !== "[object Window]") {
    var e = n.ownerDocument;
    return e && e.defaultView || window;
  }
  return n;
}
function st(n) {
  var e = Me(n).Element;
  return n instanceof e || n instanceof Element;
}
function xe(n) {
  var e = Me(n).HTMLElement;
  return n instanceof e || n instanceof HTMLElement;
}
function cn(n) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = Me(n).ShadowRoot;
  return n instanceof e || n instanceof ShadowRoot;
}
var at = Math.max, Ft = Math.min, dt = Math.round;
function nn() {
  var n = navigator.userAgentData;
  return n != null && n.brands && Array.isArray(n.brands) ? n.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function ia() {
  return !/^((?!chrome|android).)*safari/i.test(nn());
}
function ft(n, e, t) {
  e === void 0 && (e = !1), t === void 0 && (t = !1);
  var a = n.getBoundingClientRect(), r = 1, s = 1;
  e && xe(n) && (r = n.offsetWidth > 0 && dt(a.width) / n.offsetWidth || 1, s = n.offsetHeight > 0 && dt(a.height) / n.offsetHeight || 1);
  var i = st(n) ? Me(n) : window, o = i.visualViewport, u = !ia() && t, l = (a.left + (u && o ? o.offsetLeft : 0)) / r, f = (a.top + (u && o ? o.offsetTop : 0)) / s, v = a.width / r, d = a.height / s;
  return {
    width: v,
    height: d,
    top: f,
    right: l + v,
    bottom: f + d,
    left: l,
    x: l,
    y: f
  };
}
function dn(n) {
  var e = Me(n), t = e.pageXOffset, a = e.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: a
  };
}
function Fr(n) {
  return {
    scrollLeft: n.scrollLeft,
    scrollTop: n.scrollTop
  };
}
function Hr(n) {
  return n === Me(n) || !xe(n) ? dn(n) : Fr(n);
}
function Ke(n) {
  return n ? (n.nodeName || "").toLowerCase() : null;
}
function et(n) {
  return ((st(n) ? n.ownerDocument : (
    // $FlowFixMe[prop-missing]
    n.document
  )) || window.document).documentElement;
}
function fn(n) {
  return ft(et(n)).left + dn(n).scrollLeft;
}
function Xe(n) {
  return Me(n).getComputedStyle(n);
}
function mn(n) {
  var e = Xe(n), t = e.overflow, a = e.overflowX, r = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + r + a);
}
function zr(n) {
  var e = n.getBoundingClientRect(), t = dt(e.width) / n.offsetWidth || 1, a = dt(e.height) / n.offsetHeight || 1;
  return t !== 1 || a !== 1;
}
function Rr(n, e, t) {
  t === void 0 && (t = !1);
  var a = xe(e), r = xe(e) && zr(e), s = et(e), i = ft(n, r, t), o = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = {
    x: 0,
    y: 0
  };
  return (a || !a && !t) && ((Ke(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  mn(s)) && (o = Hr(e)), xe(e) ? (u = ft(e, !0), u.x += e.clientLeft, u.y += e.clientTop) : s && (u.x = fn(s))), {
    x: i.left + o.scrollLeft - u.x,
    y: i.top + o.scrollTop - u.y,
    width: i.width,
    height: i.height
  };
}
function vn(n) {
  var e = ft(n), t = n.offsetWidth, a = n.offsetHeight;
  return Math.abs(e.width - t) <= 1 && (t = e.width), Math.abs(e.height - a) <= 1 && (a = e.height), {
    x: n.offsetLeft,
    y: n.offsetTop,
    width: t,
    height: a
  };
}
function jt(n) {
  return Ke(n) === "html" ? n : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    n.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    n.parentNode || // DOM Element detected
    (cn(n) ? n.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    et(n)
  );
}
function ua(n) {
  return ["html", "body", "#document"].indexOf(Ke(n)) >= 0 ? n.ownerDocument.body : xe(n) && mn(n) ? n : ua(jt(n));
}
function $t(n, e) {
  var t;
  e === void 0 && (e = []);
  var a = ua(n), r = a === ((t = n.ownerDocument) == null ? void 0 : t.body), s = Me(a), i = r ? [s].concat(s.visualViewport || [], mn(a) ? a : []) : a, o = e.concat(i);
  return r ? o : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    o.concat($t(jt(i)))
  );
}
function Vr(n) {
  return ["table", "td", "th"].indexOf(Ke(n)) >= 0;
}
function xn(n) {
  return !xe(n) || // https://github.com/popperjs/popper-core/issues/837
  Xe(n).position === "fixed" ? null : n.offsetParent;
}
function qr(n) {
  var e = /firefox/i.test(nn()), t = /Trident/i.test(nn());
  if (t && xe(n)) {
    var a = Xe(n);
    if (a.position === "fixed")
      return null;
  }
  var r = jt(n);
  for (cn(r) && (r = r.host); xe(r) && ["html", "body"].indexOf(Ke(r)) < 0; ) {
    var s = Xe(r);
    if (s.transform !== "none" || s.perspective !== "none" || s.contain === "paint" || ["transform", "perspective"].indexOf(s.willChange) !== -1 || e && s.willChange === "filter" || e && s.filter && s.filter !== "none")
      return r;
    r = r.parentNode;
  }
  return null;
}
function Ct(n) {
  for (var e = Me(n), t = xn(n); t && Vr(t) && Xe(t).position === "static"; )
    t = xn(t);
  return t && (Ke(t) === "html" || Ke(t) === "body" && Xe(t).position === "static") ? e : t || qr(n) || e;
}
var Pe = "top", ze = "bottom", Re = "right", Le = "left", pn = "auto", Mt = [Pe, ze, Re, Le], mt = "start", St = "end", jr = "clippingParents", ca = "viewport", _t = "popper", Wr = "reference", Bn = /* @__PURE__ */ Mt.reduce(function(n, e) {
  return n.concat([e + "-" + mt, e + "-" + St]);
}, []), da = /* @__PURE__ */ [].concat(Mt, [pn]).reduce(function(n, e) {
  return n.concat([e, e + "-" + mt, e + "-" + St]);
}, []), Ur = "beforeRead", Kr = "read", Gr = "afterRead", Yr = "beforeMain", Qr = "main", Xr = "afterMain", Zr = "beforeWrite", Jr = "write", es = "afterWrite", ts = [Ur, Kr, Gr, Yr, Qr, Xr, Zr, Jr, es];
function ns(n) {
  var e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), a = [];
  n.forEach(function(s) {
    e.set(s.name, s);
  });
  function r(s) {
    t.add(s.name);
    var i = [].concat(s.requires || [], s.requiresIfExists || []);
    i.forEach(function(o) {
      if (!t.has(o)) {
        var u = e.get(o);
        u && r(u);
      }
    }), a.push(s);
  }
  return n.forEach(function(s) {
    t.has(s.name) || r(s);
  }), a;
}
function as(n) {
  var e = ns(n);
  return ts.reduce(function(t, a) {
    return t.concat(e.filter(function(r) {
      return r.phase === a;
    }));
  }, []);
}
function rs(n) {
  var e;
  return function() {
    return e || (e = new Promise(function(t) {
      Promise.resolve().then(function() {
        e = void 0, t(n());
      });
    })), e;
  };
}
function ss(n) {
  var e = n.reduce(function(t, a) {
    var r = t[a.name];
    return t[a.name] = r ? Object.assign({}, r, a, {
      options: Object.assign({}, r.options, a.options),
      data: Object.assign({}, r.data, a.data)
    }) : a, t;
  }, {});
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}
function os(n, e) {
  var t = Me(n), a = et(n), r = t.visualViewport, s = a.clientWidth, i = a.clientHeight, o = 0, u = 0;
  if (r) {
    s = r.width, i = r.height;
    var l = ia();
    (l || !l && e === "fixed") && (o = r.offsetLeft, u = r.offsetTop);
  }
  return {
    width: s,
    height: i,
    x: o + fn(n),
    y: u
  };
}
function ls(n) {
  var e, t = et(n), a = dn(n), r = (e = n.ownerDocument) == null ? void 0 : e.body, s = at(t.scrollWidth, t.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), i = at(t.scrollHeight, t.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), o = -a.scrollLeft + fn(n), u = -a.scrollTop;
  return Xe(r || t).direction === "rtl" && (o += at(t.clientWidth, r ? r.clientWidth : 0) - s), {
    width: s,
    height: i,
    x: o,
    y: u
  };
}
function fa(n, e) {
  var t = e.getRootNode && e.getRootNode();
  if (n.contains(e))
    return !0;
  if (t && cn(t)) {
    var a = e;
    do {
      if (a && n.isSameNode(a))
        return !0;
      a = a.parentNode || a.host;
    } while (a);
  }
  return !1;
}
function an(n) {
  return Object.assign({}, n, {
    left: n.x,
    top: n.y,
    right: n.x + n.width,
    bottom: n.y + n.height
  });
}
function is(n, e) {
  var t = ft(n, !1, e === "fixed");
  return t.top = t.top + n.clientTop, t.left = t.left + n.clientLeft, t.bottom = t.top + n.clientHeight, t.right = t.left + n.clientWidth, t.width = n.clientWidth, t.height = n.clientHeight, t.x = t.left, t.y = t.top, t;
}
function On(n, e, t) {
  return e === ca ? an(os(n, t)) : st(e) ? is(e, t) : an(ls(et(n)));
}
function us(n) {
  var e = $t(jt(n)), t = ["absolute", "fixed"].indexOf(Xe(n).position) >= 0, a = t && xe(n) ? Ct(n) : n;
  return st(a) ? e.filter(function(r) {
    return st(r) && fa(r, a) && Ke(r) !== "body";
  }) : [];
}
function cs(n, e, t, a) {
  var r = e === "clippingParents" ? us(n) : [].concat(e), s = [].concat(r, [t]), i = s[0], o = s.reduce(function(u, l) {
    var f = On(n, l, a);
    return u.top = at(f.top, u.top), u.right = Ft(f.right, u.right), u.bottom = Ft(f.bottom, u.bottom), u.left = at(f.left, u.left), u;
  }, On(n, i, a));
  return o.width = o.right - o.left, o.height = o.bottom - o.top, o.x = o.left, o.y = o.top, o;
}
function je(n) {
  return n.split("-")[0];
}
function vt(n) {
  return n.split("-")[1];
}
function hn(n) {
  return ["top", "bottom"].indexOf(n) >= 0 ? "x" : "y";
}
function ma(n) {
  var e = n.reference, t = n.element, a = n.placement, r = a ? je(a) : null, s = a ? vt(a) : null, i = e.x + e.width / 2 - t.width / 2, o = e.y + e.height / 2 - t.height / 2, u;
  switch (r) {
    case Pe:
      u = {
        x: i,
        y: e.y - t.height
      };
      break;
    case ze:
      u = {
        x: i,
        y: e.y + e.height
      };
      break;
    case Re:
      u = {
        x: e.x + e.width,
        y: o
      };
      break;
    case Le:
      u = {
        x: e.x - t.width,
        y: o
      };
      break;
    default:
      u = {
        x: e.x,
        y: e.y
      };
  }
  var l = r ? hn(r) : null;
  if (l != null) {
    var f = l === "y" ? "height" : "width";
    switch (s) {
      case mt:
        u[l] = u[l] - (e[f] / 2 - t[f] / 2);
        break;
      case St:
        u[l] = u[l] + (e[f] / 2 - t[f] / 2);
        break;
    }
  }
  return u;
}
function va() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function pa(n) {
  return Object.assign({}, va(), n);
}
function ha(n, e) {
  return e.reduce(function(t, a) {
    return t[a] = n, t;
  }, {});
}
function gn(n, e) {
  e === void 0 && (e = {});
  var t = e, a = t.placement, r = a === void 0 ? n.placement : a, s = t.strategy, i = s === void 0 ? n.strategy : s, o = t.boundary, u = o === void 0 ? jr : o, l = t.rootBoundary, f = l === void 0 ? ca : l, v = t.elementContext, d = v === void 0 ? _t : v, m = t.altBoundary, p = m === void 0 ? !1 : m, L = t.padding, x = L === void 0 ? 0 : L, D = pa(typeof x != "number" ? x : ha(x, Mt)), E = d === _t ? Wr : _t, T = n.rects.popper, g = n.elements[p ? E : d], C = cs(st(g) ? g : g.contextElement || et(n.elements.popper), u, f, i), $ = ft(n.elements.reference), k = ma({
    reference: $,
    element: T,
    strategy: "absolute",
    placement: r
  }), y = an(Object.assign({}, T, k)), N = d === _t ? y : $, F = {
    top: C.top - N.top + D.top,
    bottom: N.bottom - C.bottom + D.bottom,
    left: C.left - N.left + D.left,
    right: N.right - C.right + D.right
  }, G = n.modifiersData.offset;
  if (d === _t && G) {
    var h = G[r];
    Object.keys(F).forEach(function(_) {
      var B = [Re, ze].indexOf(_) >= 0 ? 1 : -1, V = [Pe, ze].indexOf(_) >= 0 ? "y" : "x";
      F[_] += h[V] * B;
    });
  }
  return F;
}
var Dn = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Fn() {
  for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
    e[t] = arguments[t];
  return !e.some(function(a) {
    return !(a && typeof a.getBoundingClientRect == "function");
  });
}
function ds(n) {
  n === void 0 && (n = {});
  var e = n, t = e.defaultModifiers, a = t === void 0 ? [] : t, r = e.defaultOptions, s = r === void 0 ? Dn : r;
  return function(o, u, l) {
    l === void 0 && (l = s);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Dn, s),
      modifiersData: {},
      elements: {
        reference: o,
        popper: u
      },
      attributes: {},
      styles: {}
    }, v = [], d = !1, m = {
      state: f,
      setOptions: function(D) {
        var E = typeof D == "function" ? D(f.options) : D;
        L(), f.options = Object.assign({}, s, f.options, E), f.scrollParents = {
          reference: st(o) ? $t(o) : o.contextElement ? $t(o.contextElement) : [],
          popper: $t(u)
        };
        var T = as(ss([].concat(a, f.options.modifiers)));
        return f.orderedModifiers = T.filter(function(g) {
          return g.enabled;
        }), p(), m.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!d) {
          var D = f.elements, E = D.reference, T = D.popper;
          if (Fn(E, T)) {
            f.rects = {
              reference: Rr(E, Ct(T), f.options.strategy === "fixed"),
              popper: vn(T)
            }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function(F) {
              return f.modifiersData[F.name] = Object.assign({}, F.data);
            });
            for (var g = 0; g < f.orderedModifiers.length; g++) {
              if (f.reset === !0) {
                f.reset = !1, g = -1;
                continue;
              }
              var C = f.orderedModifiers[g], $ = C.fn, k = C.options, y = k === void 0 ? {} : k, N = C.name;
              typeof $ == "function" && (f = $({
                state: f,
                options: y,
                name: N,
                instance: m
              }) || f);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: rs(function() {
        return new Promise(function(x) {
          m.forceUpdate(), x(f);
        });
      }),
      destroy: function() {
        L(), d = !0;
      }
    };
    if (!Fn(o, u))
      return m;
    m.setOptions(l).then(function(x) {
      !d && l.onFirstUpdate && l.onFirstUpdate(x);
    });
    function p() {
      f.orderedModifiers.forEach(function(x) {
        var D = x.name, E = x.options, T = E === void 0 ? {} : E, g = x.effect;
        if (typeof g == "function") {
          var C = g({
            state: f,
            name: D,
            instance: m,
            options: T
          }), $ = function() {
          };
          v.push(C || $);
        }
      });
    }
    function L() {
      v.forEach(function(x) {
        return x();
      }), v = [];
    }
    return m;
  };
}
var At = {
  passive: !0
};
function fs(n) {
  var e = n.state, t = n.instance, a = n.options, r = a.scroll, s = r === void 0 ? !0 : r, i = a.resize, o = i === void 0 ? !0 : i, u = Me(e.elements.popper), l = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return s && l.forEach(function(f) {
    f.addEventListener("scroll", t.update, At);
  }), o && u.addEventListener("resize", t.update, At), function() {
    s && l.forEach(function(f) {
      f.removeEventListener("scroll", t.update, At);
    }), o && u.removeEventListener("resize", t.update, At);
  };
}
const ms = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: fs,
  data: {}
};
function vs(n) {
  var e = n.state, t = n.name;
  e.modifiersData[t] = ma({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const ps = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: vs,
  data: {}
};
var hs = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function gs(n, e) {
  var t = n.x, a = n.y, r = e.devicePixelRatio || 1;
  return {
    x: dt(t * r) / r || 0,
    y: dt(a * r) / r || 0
  };
}
function Hn(n) {
  var e, t = n.popper, a = n.popperRect, r = n.placement, s = n.variation, i = n.offsets, o = n.position, u = n.gpuAcceleration, l = n.adaptive, f = n.roundOffsets, v = n.isFixed, d = i.x, m = d === void 0 ? 0 : d, p = i.y, L = p === void 0 ? 0 : p, x = typeof f == "function" ? f({
    x: m,
    y: L
  }) : {
    x: m,
    y: L
  };
  m = x.x, L = x.y;
  var D = i.hasOwnProperty("x"), E = i.hasOwnProperty("y"), T = Le, g = Pe, C = window;
  if (l) {
    var $ = Ct(t), k = "clientHeight", y = "clientWidth";
    if ($ === Me(t) && ($ = et(t), Xe($).position !== "static" && o === "absolute" && (k = "scrollHeight", y = "scrollWidth")), $ = $, r === Pe || (r === Le || r === Re) && s === St) {
      g = ze;
      var N = v && $ === C && C.visualViewport ? C.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        $[k]
      );
      L -= N - a.height, L *= u ? 1 : -1;
    }
    if (r === Le || (r === Pe || r === ze) && s === St) {
      T = Re;
      var F = v && $ === C && C.visualViewport ? C.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        $[y]
      );
      m -= F - a.width, m *= u ? 1 : -1;
    }
  }
  var G = Object.assign({
    position: o
  }, l && hs), h = f === !0 ? gs({
    x: m,
    y: L
  }, Me(t)) : {
    x: m,
    y: L
  };
  if (m = h.x, L = h.y, u) {
    var _;
    return Object.assign({}, G, (_ = {}, _[g] = E ? "0" : "", _[T] = D ? "0" : "", _.transform = (C.devicePixelRatio || 1) <= 1 ? "translate(" + m + "px, " + L + "px)" : "translate3d(" + m + "px, " + L + "px, 0)", _));
  }
  return Object.assign({}, G, (e = {}, e[g] = E ? L + "px" : "", e[T] = D ? m + "px" : "", e.transform = "", e));
}
function bs(n) {
  var e = n.state, t = n.options, a = t.gpuAcceleration, r = a === void 0 ? !0 : a, s = t.adaptive, i = s === void 0 ? !0 : s, o = t.roundOffsets, u = o === void 0 ? !0 : o, l = {
    placement: je(e.placement),
    variation: vt(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: r,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, Hn(Object.assign({}, l, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: i,
    roundOffsets: u
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, Hn(Object.assign({}, l, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: u
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const ys = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: bs,
  data: {}
};
function _s(n) {
  var e = n.state;
  Object.keys(e.elements).forEach(function(t) {
    var a = e.styles[t] || {}, r = e.attributes[t] || {}, s = e.elements[t];
    !xe(s) || !Ke(s) || (Object.assign(s.style, a), Object.keys(r).forEach(function(i) {
      var o = r[i];
      o === !1 ? s.removeAttribute(i) : s.setAttribute(i, o === !0 ? "" : o);
    }));
  });
}
function ks(n) {
  var e = n.state, t = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, t.popper), e.styles = t, e.elements.arrow && Object.assign(e.elements.arrow.style, t.arrow), function() {
    Object.keys(e.elements).forEach(function(a) {
      var r = e.elements[a], s = e.attributes[a] || {}, i = Object.keys(e.styles.hasOwnProperty(a) ? e.styles[a] : t[a]), o = i.reduce(function(u, l) {
        return u[l] = "", u;
      }, {});
      !xe(r) || !Ke(r) || (Object.assign(r.style, o), Object.keys(s).forEach(function(u) {
        r.removeAttribute(u);
      }));
    });
  };
}
const ws = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: _s,
  effect: ks,
  requires: ["computeStyles"]
};
var $s = [ms, ps, ys, ws], Is = /* @__PURE__ */ ds({
  defaultModifiers: $s
});
function Ts(n) {
  return n === "x" ? "y" : "x";
}
function It(n, e, t) {
  return at(n, Ft(e, t));
}
function Ss(n, e, t) {
  var a = It(n, e, t);
  return a > t ? t : a;
}
function Ps(n) {
  var e = n.state, t = n.options, a = n.name, r = t.mainAxis, s = r === void 0 ? !0 : r, i = t.altAxis, o = i === void 0 ? !1 : i, u = t.boundary, l = t.rootBoundary, f = t.altBoundary, v = t.padding, d = t.tether, m = d === void 0 ? !0 : d, p = t.tetherOffset, L = p === void 0 ? 0 : p, x = gn(e, {
    boundary: u,
    rootBoundary: l,
    padding: v,
    altBoundary: f
  }), D = je(e.placement), E = vt(e.placement), T = !E, g = hn(D), C = Ts(g), $ = e.modifiersData.popperOffsets, k = e.rects.reference, y = e.rects.popper, N = typeof L == "function" ? L(Object.assign({}, e.rects, {
    placement: e.placement
  })) : L, F = typeof N == "number" ? {
    mainAxis: N,
    altAxis: N
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, N), G = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, h = {
    x: 0,
    y: 0
  };
  if ($) {
    if (s) {
      var _, B = g === "y" ? Pe : Le, V = g === "y" ? ze : Re, A = g === "y" ? "height" : "width", j = $[g], Z = j + x[B], R = j - x[V], J = m ? -y[A] / 2 : 0, re = E === mt ? k[A] : y[A], te = E === mt ? -y[A] : -k[A], ie = e.elements.arrow, ye = m && ie ? vn(ie) : {
        width: 0,
        height: 0
      }, Te = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : va(), Q = Te[B], oe = Te[V], ce = It(0, k[A], ye[A]), Se = T ? k[A] / 2 - J - ce - Q - F.mainAxis : re - ce - Q - F.mainAxis, Ge = T ? -k[A] / 2 + J + ce + oe + F.mainAxis : te + ce + oe + F.mainAxis, Be = e.elements.arrow && Ct(e.elements.arrow), qe = Be ? g === "y" ? Be.clientTop || 0 : Be.clientLeft || 0 : 0, Je = (_ = G == null ? void 0 : G[g]) != null ? _ : 0, _e = j + Se - Je - qe, Et = j + Ge - Je, ht = It(m ? Ft(Z, _e) : Z, j, m ? at(R, Et) : R);
      $[g] = ht, h[g] = ht - j;
    }
    if (o) {
      var X, ke = g === "x" ? Pe : Le, Oe = g === "x" ? ze : Re, Ee = $[C], De = C === "y" ? "height" : "width", gt = Ee + x[ke], Fe = Ee - x[Oe], Nt = [Pe, Le].indexOf(D) !== -1, Ln = (X = G == null ? void 0 : G[C]) != null ? X : 0, Cn = Nt ? gt : Ee - k[De] - y[De] - Ln + F.altAxis, Mn = Nt ? Ee + k[De] + y[De] - Ln - F.altAxis : Fe, En = m && Nt ? Ss(Cn, Ee, Mn) : It(m ? Cn : gt, Ee, m ? Mn : Fe);
      $[C] = En, h[C] = En - Ee;
    }
    e.modifiersData[a] = h;
  }
}
const Ls = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Ps,
  requiresIfExists: ["offset"]
};
var Cs = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function xt(n) {
  return n.replace(/left|right|bottom|top/g, function(e) {
    return Cs[e];
  });
}
var Ms = {
  start: "end",
  end: "start"
};
function zn(n) {
  return n.replace(/start|end/g, function(e) {
    return Ms[e];
  });
}
function Es(n, e) {
  e === void 0 && (e = {});
  var t = e, a = t.placement, r = t.boundary, s = t.rootBoundary, i = t.padding, o = t.flipVariations, u = t.allowedAutoPlacements, l = u === void 0 ? da : u, f = vt(a), v = f ? o ? Bn : Bn.filter(function(p) {
    return vt(p) === f;
  }) : Mt, d = v.filter(function(p) {
    return l.indexOf(p) >= 0;
  });
  d.length === 0 && (d = v);
  var m = d.reduce(function(p, L) {
    return p[L] = gn(n, {
      placement: L,
      boundary: r,
      rootBoundary: s,
      padding: i
    })[je(L)], p;
  }, {});
  return Object.keys(m).sort(function(p, L) {
    return m[p] - m[L];
  });
}
function Ns(n) {
  if (je(n) === pn)
    return [];
  var e = xt(n);
  return [zn(n), e, zn(e)];
}
function As(n) {
  var e = n.state, t = n.options, a = n.name;
  if (!e.modifiersData[a]._skip) {
    for (var r = t.mainAxis, s = r === void 0 ? !0 : r, i = t.altAxis, o = i === void 0 ? !0 : i, u = t.fallbackPlacements, l = t.padding, f = t.boundary, v = t.rootBoundary, d = t.altBoundary, m = t.flipVariations, p = m === void 0 ? !0 : m, L = t.allowedAutoPlacements, x = e.options.placement, D = je(x), E = D === x, T = u || (E || !p ? [xt(x)] : Ns(x)), g = [x].concat(T).reduce(function(ye, Te) {
      return ye.concat(je(Te) === pn ? Es(e, {
        placement: Te,
        boundary: f,
        rootBoundary: v,
        padding: l,
        flipVariations: p,
        allowedAutoPlacements: L
      }) : Te);
    }, []), C = e.rects.reference, $ = e.rects.popper, k = /* @__PURE__ */ new Map(), y = !0, N = g[0], F = 0; F < g.length; F++) {
      var G = g[F], h = je(G), _ = vt(G) === mt, B = [Pe, ze].indexOf(h) >= 0, V = B ? "width" : "height", A = gn(e, {
        placement: G,
        boundary: f,
        rootBoundary: v,
        altBoundary: d,
        padding: l
      }), j = B ? _ ? Re : Le : _ ? ze : Pe;
      C[V] > $[V] && (j = xt(j));
      var Z = xt(j), R = [];
      if (s && R.push(A[h] <= 0), o && R.push(A[j] <= 0, A[Z] <= 0), R.every(function(ye) {
        return ye;
      })) {
        N = G, y = !1;
        break;
      }
      k.set(G, R);
    }
    if (y)
      for (var J = p ? 3 : 1, re = function(Te) {
        var Q = g.find(function(oe) {
          var ce = k.get(oe);
          if (ce)
            return ce.slice(0, Te).every(function(Se) {
              return Se;
            });
        });
        if (Q)
          return N = Q, "break";
      }, te = J; te > 0; te--) {
        var ie = re(te);
        if (ie === "break") break;
      }
    e.placement !== N && (e.modifiersData[a]._skip = !0, e.placement = N, e.reset = !0);
  }
}
const xs = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: As,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Bs(n, e, t) {
  var a = je(n), r = [Le, Pe].indexOf(a) >= 0 ? -1 : 1, s = typeof t == "function" ? t(Object.assign({}, e, {
    placement: n
  })) : t, i = s[0], o = s[1];
  return i = i || 0, o = (o || 0) * r, [Le, Re].indexOf(a) >= 0 ? {
    x: o,
    y: i
  } : {
    x: i,
    y: o
  };
}
function Os(n) {
  var e = n.state, t = n.options, a = n.name, r = t.offset, s = r === void 0 ? [0, 0] : r, i = da.reduce(function(f, v) {
    return f[v] = Bs(v, e.rects, s), f;
  }, {}), o = i[e.placement], u = o.x, l = o.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += u, e.modifiersData.popperOffsets.y += l), e.modifiersData[a] = i;
}
const Ds = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Os
};
var Fs = function(e, t) {
  return e = typeof e == "function" ? e(Object.assign({}, t.rects, {
    placement: t.placement
  })) : e, pa(typeof e != "number" ? e : ha(e, Mt));
};
function Hs(n) {
  var e, t = n.state, a = n.name, r = n.options, s = t.elements.arrow, i = t.modifiersData.popperOffsets, o = je(t.placement), u = hn(o), l = [Le, Re].indexOf(o) >= 0, f = l ? "height" : "width";
  if (!(!s || !i)) {
    var v = Fs(r.padding, t), d = vn(s), m = u === "y" ? Pe : Le, p = u === "y" ? ze : Re, L = t.rects.reference[f] + t.rects.reference[u] - i[u] - t.rects.popper[f], x = i[u] - t.rects.reference[u], D = Ct(s), E = D ? u === "y" ? D.clientHeight || 0 : D.clientWidth || 0 : 0, T = L / 2 - x / 2, g = v[m], C = E - d[f] - v[p], $ = E / 2 - d[f] / 2 + T, k = It(g, $, C), y = u;
    t.modifiersData[a] = (e = {}, e[y] = k, e.centerOffset = k - $, e);
  }
}
function zs(n) {
  var e = n.state, t = n.options, a = t.element, r = a === void 0 ? "[data-popper-arrow]" : a;
  r != null && (typeof r == "string" && (r = e.elements.popper.querySelector(r), !r) || fa(e.elements.popper, r) && (e.elements.arrow = r));
}
const Rs = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Hs,
  effect: zs,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ga({
  targetNode: n,
  tooltipNode: e,
  placement: t,
  strategy: a,
  showArrow: r = !0
}) {
  const s = I(null), i = I(!1), o = () => {
    i.value = !i.value;
  };
  return Ve(() => {
    var u;
    (u = s.value) == null || u.destroy();
  }), de(() => {
    let u = [];
    r && (u = [
      Rs,
      {
        name: "arrow",
        options: {
          padding: 8
        }
      }
    ]), n.value && e.value && (s.value = Is(
      n.value,
      e.value,
      {
        placement: t,
        strategy: a,
        modifiers: [
          Ls,
          xs,
          Ds,
          {
            name: "offset",
            options: {
              offset: [0, 10]
            }
          },
          ...u
        ]
      }
    ));
  }), le(i, (u) => {
    var l;
    u && ((l = s.value) == null || l.update());
  }), {
    toggle: o,
    isOpen: i
  };
}
const Vs = ["data-show"], qs = ["id"], js = { class: "ds-tooltip__content" }, Ws = ["innerHTML"], Us = /* @__PURE__ */ M("div", {
  class: "ds-tooltip__arrow",
  "data-popper-arrow": ""
}, null, -1), Ks = /* @__PURE__ */ q({
  __name: "ds-tooltip",
  props: {
    placement: { default: "auto" },
    strategy: { default: "absolute" },
    text: {},
    title: {},
    titleElement: { default: "h3" }
  },
  setup(n) {
    const e = n, t = I(null), a = I(null), r = I(null), s = Ze("tooltip"), i = ["A", "BUTTON", "INPUT", "SELECT", "TEXTAREA"], o = (d) => {
      const m = d.target;
      return m ? i.includes(m.tagName) : !1;
    }, u = (d) => {
      o(d) && (v.value = !0);
    }, l = (d) => {
      o(d) && d.target !== document.activeElement && (v.value = !1);
    }, f = (d) => {
      if (o(d)) {
        const m = d.target;
        m && ["BUTTON", "A"].includes(m.tagName) && (d.preventDefault(), m == null || m.click());
      }
    };
    de(() => {
      const d = a.value, m = d == null ? void 0 : d.querySelector("a, button, input, select, textarea");
      if (m)
        t.value = m, t.value.setAttribute("aria-describedby", s);
      else
        throw new Error(
          "The tooltip can only be applied to interactive elements"
        );
    });
    const { isOpen: v } = ga({
      targetNode: t,
      tooltipNode: r,
      placement: e.placement,
      strategy: e.strategy
    });
    return (d, m) => (c(), w("div", {
      class: "ds-tooltip",
      "data-show": S(v)
    }, [
      M("div", {
        class: "ds-tooltip__target-wrapper",
        ref_key: "targetWrapper",
        ref: a,
        onFocusin: u,
        onFocusout: l,
        onMouseover: u,
        onMouseout: l,
        onTouchend: f
      }, [
        se(d.$slots, "default")
      ], 544),
      M("div", {
        id: S(s),
        ref_key: "tooltip",
        ref: r,
        class: "ds-tooltip__tooltip",
        "data-testid": "tooltip"
      }, [
        M("div", js, [
          d.title ? (c(), O(Tt(d.titleElement), {
            key: 0,
            class: "ds-tooltip__title"
          }, {
            default: H(() => [
              K(W(d.title), 1)
            ]),
            _: 1
          })) : P("", !0),
          z(Y, {
            "text-type": "label-sm",
            "html-element": "div"
          }, {
            default: H(() => [
              M("div", { innerHTML: d.text }, null, 8, Ws)
            ]),
            _: 1
          })
        ]),
        Us
      ], 8, qs)
    ], 8, Vs));
  }
}), Gs = ["aria-label"], Ys = {
  key: 0,
  class: "ds-breadcrumb__mobile"
}, Qs = {
  key: 1,
  class: "ds-breadcrumb__list"
}, Xs = {
  key: 0,
  class: "ds-breadcrumb__item ds-breadcrumb__item--expand"
}, dd = /* @__PURE__ */ q({
  __name: "ds-breadcrumb",
  props: {
    ariaLabel: {},
    items: {},
    overflowMenuTooltipText: {}
  },
  setup(n) {
    const e = n, t = I(!1), { isMobile: a } = Ie(), r = {
      ...e.items[0],
      itemClass: "ds-breadcrumb__item"
    }, s = e.items.slice(1), i = b(() => e.items.length > 3), o = e.items.filter((m) => m.isCurrentPage)[0], l = e.items.indexOf(o) - 1, f = l > -1 ? {
      ...e.items[l],
      itemClass: "ds-breadcrumb__item"
    } : null, v = b(() => s.map((m, p) => {
      const L = i.value && p < e.items.length - 3;
      return {
        ...m,
        itemClass: L ? "ds-breadcrumb__item ds-breadcrumb__item--initially-hidden" : "ds-breadcrumb__item"
      };
    })), d = b(() => {
      const m = ["ds-breadcrumb"];
      return t.value && m.push("ds-breadcrumb--expanded"), m;
    });
    return (m, p) => m.items.length > 1 ? (c(), w("nav", {
      key: 0,
      class: U(d.value),
      "aria-label": m.ariaLabel
    }, [
      S(f) && S(a) ? (c(), w("div", Ys, [
        z(Yt, {
          "icon-start-name": "navigate-back",
          item: S(f)
        }, null, 8, ["item"])
      ])) : P("", !0),
      S(a) ? P("", !0) : (c(), w("ol", Qs, [
        M("li", {
          class: U(r.itemClass)
        }, [
          z(Yt, { item: r }),
          v.value.length ? (c(), O(ae, {
            key: 0,
            class: "ds-breadcrumb__divider",
            "icon-name": "chevron-right",
            size: "xs"
          })) : P("", !0)
        ], 2),
        i.value ? (c(), w("li", Xs, [
          z(Ks, {
            ref: "tooltip",
            text: m.overflowMenuTooltipText,
            placement: "top"
          }, {
            default: H(() => [
              M("button", {
                class: "ds-breadcrumb__expand",
                onClick: p[0] || (p[0] = () => t.value = !0)
              }, [
                z(Y, {
                  "text-type": "label-sm",
                  "html-element": "span"
                }, {
                  default: H(() => [
                    K("…")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["text"]),
          v.value.length ? (c(), O(ae, {
            key: 0,
            class: "ds-breadcrumb__divider",
            "icon-name": "chevron-right",
            size: "xs"
          })) : P("", !0)
        ])) : P("", !0),
        (c(!0), w(ne, null, ue(v.value, (L, x) => (c(), w("li", {
          class: U(L.itemClass),
          key: L.url
        }, [
          z(Yt, { item: L }, null, 8, ["item"]),
          x < v.value.length - 1 ? (c(), O(ae, {
            key: 0,
            class: "ds-breadcrumb__divider",
            "icon-name": "chevron-right",
            size: "xs"
          })) : P("", !0)
        ], 2))), 128))
      ]))
    ], 10, Gs)) : P("", !0);
  }
}), ba = /* @__PURE__ */ q({
  __name: "ds-button-group",
  props: {
    buttonSize: { default: "md" },
    desktopAlignment: { default: "end" },
    desktopDirection: { default: "row" },
    mobileAlignment: { default: "stretch" },
    mobileDirection: { default: "column-reverse" }
  },
  setup(n) {
    const e = n, t = b(() => [
      `ds-button-group--${e.buttonSize}`,
      `ds-button-group--${e.desktopAlignment}`,
      `ds-button-group--${e.desktopDirection}`,
      `ds-button-group--m-${e.mobileAlignment}`,
      `ds-button-group--m-${e.mobileDirection}`
    ]);
    return (a, r) => (c(), w("div", {
      class: U(["ds-button-group", t.value])
    }, [
      se(a.$slots, "default", { buttonSize: a.buttonSize })
    ], 2));
  }
}), Zs = ["aria-label", "disabled"], Js = /* @__PURE__ */ M("span", { class: "ds-button-play__bg" }, null, -1), fd = /* @__PURE__ */ q({
  __name: "ds-button-play",
  props: {
    ariaLabelPlay: {},
    ariaLabelPause: {},
    disabled: { type: Boolean, default: !1 },
    initialState: { default: "play" },
    pauseHandler: {},
    playHandler: {},
    size: { default: "md" },
    variant: { default: "primary" }
  },
  setup(n) {
    const e = n, t = b(() => e.playHandler && e.pauseHandler), a = b(() => i.value === "play" && e.playHandler), r = b(() => i.value === "pause" && e.pauseHandler), s = b(() => {
      if (a.value)
        return e.ariaLabelPlay;
      if (r.value)
        return e.ariaLabelPause;
    }), i = I(e.initialState), o = (d) => {
      a.value ? u(d) : r.value && l(d);
    }, u = (d) => {
      t.value && (i.value = "pause");
      try {
        e.playHandler && e.playHandler(d);
      } catch (m) {
        i.value = "play", console.error(m);
      }
    }, l = (d) => {
      t.value && (i.value = "play");
      try {
        e.pauseHandler && e.pauseHandler(d);
      } catch (m) {
        i.value = "pause", console.error(m);
      }
    }, f = b(() => [
      `ds-button-play--${e.variant}`,
      `ds-button-play--${e.size}`
    ]);
    let v = !0;
    return e.playHandler && !e.ariaLabelPlay && (v = !1), e.pauseHandler && !e.ariaLabelPause && (v = !1), v || console.error("The play button requires an accessible label"), (d, m) => (c(), w("button", {
      "aria-label": s.value,
      onClick: o,
      class: U(["ds-button-play", f.value]),
      disabled: d.disabled || void 0
    }, [
      Js,
      z(Ue, {
        mode: "out-in",
        name: "swap"
      }, {
        default: H(() => [
          (c(), O(S(ae), {
            key: i.value,
            "icon-name": i.value,
            size: d.size
          }, null, 8, ["icon-name", "size"]))
        ]),
        _: 1
      })
    ], 10, Zs));
  }
}), eo = ["aria-label", "disabled"], to = {
  class: "ds-button-play-progress__progress",
  viewBox: "0 0 36 36"
}, no = /* @__PURE__ */ M("circle", {
  class: "ds-button-play-progress__progress-bg",
  cx: "18",
  cy: "18",
  r: "16"
}, null, -1), ao = ["stroke-dasharray", "stroke-dashoffset"], ro = 16, so = /* @__PURE__ */ q({
  __name: "ds-button-play-progress",
  props: {
    ariaLabelPlay: {},
    ariaLabelPause: {},
    disabled: { type: Boolean, default: !1 },
    initialState: { default: "play" },
    pauseHandler: {},
    playHandler: {},
    progress: { default: 0 },
    loop: { type: Boolean, default: !0 },
    size: { default: "responsive" },
    variant: { default: "on-dark" }
  },
  setup(n, { expose: e }) {
    const t = n, a = b(() => {
      const g = [];
      return g.push(`ds-button-play-progress--${t.variant}`), g.push(`ds-button-play-progress--${s.value}`), g;
    }), { isMobile: r } = Ie(), s = b(() => t.size === "responsive" ? r.value ? "md" : "sm" : t.size), i = b(() => s.value === "md" ? "sm" : "xs"), o = b(() => t.playHandler && t.pauseHandler), u = b(() => v.value === "play" && t.playHandler), l = b(() => v.value === "pause" && t.pauseHandler), f = b(() => {
      if (u.value)
        return t.ariaLabelPlay;
      if (l.value)
        return t.ariaLabelPause;
    }), v = I(t.initialState), d = b(() => v.value === "play" ? "button-play" : "button-pause");
    e({
      /**
       * Allows parent components to set the play state
       * @param isPlaying - Boolean to indicate whether the media is currently playing
       */
      setButtonState: (g) => {
        v.value = g ? "pause" : "play";
      }
    });
    const p = (g) => {
      u.value ? L(g) : l.value && x(g);
    }, L = (g) => {
      o.value && (v.value = "pause");
      try {
        t.playHandler && t.playHandler(g);
      } catch (C) {
        v.value = "play", console.error(C);
      }
    }, x = (g) => {
      o.value && (v.value = "play");
      try {
        t.pauseHandler && t.pauseHandler(g);
      } catch (C) {
        v.value = "pause", console.error(C);
      }
    };
    let D = !0;
    t.playHandler && !t.ariaLabelPlay && (D = !1), t.pauseHandler && !t.ariaLabelPause && (D = !1);
    const E = b(() => 2 * Math.PI * ro), T = b(() => {
      const g = Math.min(Math.max(t.progress || 0, 0), 1);
      return E.value * (1 - g);
    });
    return t.loop || le(
      () => t.progress,
      (g) => {
        g >= 1 && (v.value = "play");
      }
    ), D || console.error("The play button requires an accessible label"), (g, C) => (c(), w("button", {
      "aria-label": f.value,
      onClick: p,
      class: U(["ds-button-play-progress", a.value]),
      disabled: g.disabled || void 0
    }, [
      (c(), w("svg", to, [
        no,
        M("circle", {
          class: "ds-button-play-progress__progress-indicator",
          cx: "18",
          cy: "18",
          r: "16",
          "stroke-dasharray": E.value,
          "stroke-dashoffset": T.value
        }, null, 8, ao)
      ])),
      z(Ue, {
        mode: "out-in",
        name: "swap"
      }, {
        default: H(() => [
          (c(), O(S(ae), {
            key: d.value,
            "icon-name": d.value,
            size: i.value
          }, null, 8, ["icon-name", "size"]))
        ]),
        _: 1
      })
    ], 10, eo));
  }
}), oo = ["aria-label", "disabled", "form", "name", "type", "value"], lo = {
  key: 1,
  class: "ds-icon-button__notification"
}, io = ["aria-disabled", "aria-label", "download", "href", "target"], he = /* @__PURE__ */ q({
  __name: "ds-icon-button",
  props: {
    ariaLabel: {},
    clickHandler: { type: Function, default: () => {
    } },
    disabled: { type: Boolean, default: !1 },
    download: { type: [Boolean, String, null], default: null },
    form: {},
    href: {},
    iconName: { default: "button-add" },
    name: {},
    notificationCount: {},
    size: { default: "md" },
    target: {},
    type: { default: "button" },
    value: {},
    variant: { default: "secondary-neutral" }
  },
  setup(n) {
    const e = n, t = b(() => e.size === "sm" ? "xs" : "sm"), a = b(() => e.size), r = b(() => e.variant), s = un(
      {
        variant: r,
        size: a
      },
      "ds-icon-button"
    ), i = b(() => {
      if (e.iconName)
        return tn(e.iconName);
    });
    return (o, u) => (c(), w(ne, null, [
      o.href ? P("", !0) : (c(), w("button", me({ key: 0 }, o.$attrs, {
        onClick: u[0] || (u[0] = //@ts-ignore
        (...l) => o.clickHandler && o.clickHandler(...l)),
        class: ["ds-icon-button", S(s)],
        "aria-label": o.ariaLabel,
        disabled: o.disabled || void 0,
        form: o.form,
        name: o.name,
        type: o.type,
        value: o.value
      }), [
        i.value ? (c(), O(ae, {
          key: 0,
          iconName: i.value,
          size: t.value
        }, null, 8, ["iconName", "size"])) : P("", !0),
        o.notificationCount ? (c(), w("span", lo, W(o.notificationCount), 1)) : P("", !0)
      ], 16, oo)),
      o.href ? (c(), w("a", me({ key: 1 }, o.$attrs, {
        onClick: u[1] || (u[1] = //@ts-ignore
        (...l) => o.clickHandler && o.clickHandler(...l)),
        class: ["ds-icon-button", S(s)],
        "aria-disabled": o.disabled || void 0,
        "aria-label": o.ariaLabel,
        download: o.download === !0 ? "" : o.download,
        href: o.href,
        target: o.target
      }), [
        i.value ? (c(), O(ae, {
          key: 0,
          iconName: i.value,
          size: t.value
        }, null, 8, ["iconName", "size"])) : P("", !0)
      ], 16, io)) : P("", !0)
    ], 64));
  }
}), md = /* @__PURE__ */ q({
  __name: "ds-card-action",
  props: {
    action: { default: "favourite" },
    actionFn: {},
    actionLabel: {},
    actionState: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = n, t = async () => {
      e.actionFn && (a.value = e.actionFn());
    }, a = I(e.actionState), r = b(() => e.action === "favourite" ? a.value ? "heart-filled" : "heart" : null), { isMobile: s } = Ie(), i = b(() => s.value ? "md" : "sm");
    return (o, u) => o.action && o.actionLabel && r.value ? (c(), O(he, {
      key: 0,
      class: "ds-card-action",
      type: "button",
      variant: "secondary-neutral",
      "click-handler": t,
      ariaLabel: o.actionLabel,
      iconName: r.value,
      size: i.value
    }, null, 8, ["ariaLabel", "iconName", "size"])) : P("", !0);
  }
}), uo = {
  key: 0,
  class: "ds-card-colours"
}, co = { class: "ds-card-colours__list" }, fo = ["title"], mo = { class: "ds-visually-hidden" }, vo = {
  key: 0,
  class: "ds-card-colours__additional"
}, po = { class: "ds-visually-hidden" }, Qt = 4, ho = /* @__PURE__ */ q({
  __name: "ds-card-colours",
  props: {
    colours: { default: () => [] },
    coloursLabel: {}
  },
  setup(n) {
    const e = n, t = e.colours.slice(0, Qt), a = e.colours.length > Qt ? e.colours.length - Qt : 0, r = a ? `+${a}` : null;
    return (s, i) => S(t).length ? (c(), w("div", uo, [
      M("ul", co, [
        (c(!0), w(ne, null, ue(S(t), (o) => (c(), w("li", {
          class: "ds-card-colours__option",
          key: o.value,
          style: ge(`--colour-bg: ${o.value}`),
          title: o.label
        }, [
          M("span", mo, W(o.label), 1)
        ], 12, fo))), 128)),
        S(a) ? (c(), w("li", vo, [
          z(Y, {
            class: "ds-card-colours__label",
            "html-element": "span",
            "text-type": "body-xs",
            "text-style": "regular"
          }, {
            default: H(() => [
              K(W(S(r)) + " ", 1),
              M("span", po, W(s.coloursLabel), 1)
            ]),
            _: 1
          })
        ])) : P("", !0)
      ])
    ])) : P("", !0);
  }
}), go = ["href"], bo = { class: "ds-visually-hidden" }, yo = { class: "ds-card-product__image-container" }, _o = ["src", "alt"], ko = { class: "ds-card-product__content" }, wo = ["src", "alt"], $o = {
  key: 1,
  class: "ds-card-product__brow-placeholder"
}, Io = ["src", "alt"], To = { class: "ds-card-product__footer" }, So = { class: "ds-card-product__labels" }, vd = /* @__PURE__ */ q({
  __name: "ds-card-product",
  props: {
    badgeText: {},
    badgeVariant: { default: "highlight" },
    browLogo: {},
    browLogoDark: {},
    browLogoAlt: {},
    browText: {},
    colours: {},
    coloursLabel: {},
    description: {},
    image: {},
    imageAlt: {},
    layout: { default: "responsive" },
    mediumLabel: {},
    smallLabel: {},
    title: {},
    url: {}
  },
  setup(n) {
    const e = n, t = b(() => {
      const a = [`ds-card-product--${e.layout}`];
      return e.badgeText && a.push("ds-card-product--badge"), a;
    });
    return (a, r) => (c(), w("article", {
      class: U(["ds-card-product", t.value])
    }, [
      M("a", {
        class: "ds-card-product__link",
        href: a.url
      }, [
        M("span", bo, W(a.title), 1)
      ], 8, go),
      a.badgeText ? (c(), O(lr, {
        class: "ds-card-product__badge",
        key: a.badgeVariant,
        text: a.badgeText,
        variant: a.badgeVariant
      }, null, 8, ["text", "variant"])) : P("", !0),
      M("div", yo, [
        M("img", {
          class: "ds-card-product__image",
          src: a.image,
          alt: a.imageAlt
        }, null, 8, _o),
        se(a.$slots, "action")
      ]),
      M("div", ko, [
        a.browLogo && a.browLogoAlt ? (c(), w("img", {
          key: 0,
          class: "ds-card-product__brow-image ds-card-product__brow-image--light",
          src: a.browLogo,
          alt: a.browLogoAlt
        }, null, 8, wo)) : P("", !0),
        !a.browLogo && !a.browLogoDark && !a.browText ? (c(), w("span", $o)) : P("", !0),
        a.browLogoDark && a.browLogoAlt ? (c(), w("img", {
          key: 2,
          class: "ds-card-product__brow-image ds-card-product__brow-image--dark",
          src: a.browLogoDark,
          alt: a.browLogoAlt
        }, null, 8, Io)) : P("", !0),
        a.browText && !a.browLogo ? (c(), O(Y, {
          key: 3,
          class: "ds-card-product__brow-text",
          "text-type": "body-xs",
          "text-style": "regular"
        }, {
          default: H(() => [
            K(W(a.browText), 1)
          ]),
          _: 1
        })) : P("", !0),
        z(Y, {
          class: "ds-card-product__title",
          "html-element": "h2",
          "text-type": "heading-md",
          "text-style": "medium"
        }, {
          default: H(() => [
            K(W(a.title), 1)
          ]),
          _: 1
        }),
        a.description ? (c(), O(Y, {
          key: 4,
          class: "ds-card-product__description",
          "text-type": "body-sm",
          "text-style": "regular"
        }, {
          default: H(() => [
            K(W(a.description), 1)
          ]),
          _: 1
        })) : P("", !0),
        M("footer", To, [
          M("div", So, [
            a.smallLabel ? (c(), O(Y, {
              key: 0,
              class: "ds-card-product__small-label",
              "text-type": "body-sm",
              "text-style": "bold"
            }, {
              default: H(() => [
                K(W(a.smallLabel), 1)
              ]),
              _: 1
            })) : P("", !0),
            z(ho, {
              coloursLabel: a.coloursLabel,
              colours: a.colours
            }, null, 8, ["coloursLabel", "colours"])
          ]),
          a.mediumLabel ? (c(), O(Y, {
            key: 0,
            class: "ds-card-product__medium-label",
            "text-type": "label-md",
            "text-style": "bold"
          }, {
            default: H(() => [
              K(W(a.mediumLabel), 1)
            ]),
            _: 1
          })) : P("", !0)
        ])
      ])
    ], 2));
  }
});
function ya(n) {
  const e = I("ltr"), t = () => {
    if (n.value) {
      const a = window.getComputedStyle(n.value);
      e.value = a.direction;
    }
  };
  return le(
    n,
    () => {
      t();
    },
    { immediate: !0 }
  ), { direction: e };
}
function bn(n) {
  return Va() ? (qa(n), !0) : !1;
}
function Ae(n) {
  return typeof n == "function" ? n() : S(n);
}
const _a = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Po = (n) => n != null, Lo = Object.prototype.toString, Co = (n) => Lo.call(n) === "[object Object]", Ce = () => {
}, Mo = /* @__PURE__ */ Eo();
function Eo() {
  var n, e;
  return _a && ((n = window == null ? void 0 : window.navigator) == null ? void 0 : n.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function ka(n, e) {
  function t(...a) {
    return new Promise((r, s) => {
      Promise.resolve(n(() => e.apply(this, a), { fn: e, thisArg: this, args: a })).then(r).catch(s);
    });
  }
  return t;
}
function No(n, e = {}) {
  let t, a, r = Ce;
  const s = (o) => {
    clearTimeout(o), r(), r = Ce;
  };
  return (o) => {
    const u = Ae(n), l = Ae(e.maxWait);
    return t && s(t), u <= 0 || l !== void 0 && l <= 0 ? (a && (s(a), a = null), Promise.resolve(o())) : new Promise((f, v) => {
      r = e.rejectOnCancel ? v : f, l && !a && (a = setTimeout(() => {
        t && s(t), a = null, f(o());
      }, l)), t = setTimeout(() => {
        a && s(a), a = null, f(o());
      }, u);
    });
  };
}
function Ao(...n) {
  let e = 0, t, a = !0, r = Ce, s, i, o, u, l;
  !ja(n[0]) && typeof n[0] == "object" ? { delay: i, trailing: o = !0, leading: u = !0, rejectOnCancel: l = !1 } = n[0] : [i, o = !0, u = !0, l = !1] = n;
  const f = () => {
    t && (clearTimeout(t), t = void 0, r(), r = Ce);
  };
  return (d) => {
    const m = Ae(i), p = Date.now() - e, L = () => s = d();
    return f(), m <= 0 ? (e = Date.now(), L()) : (p > m && (u || !a) ? (e = Date.now(), L()) : o && (s = new Promise((x, D) => {
      r = l ? D : x, t = setTimeout(() => {
        e = Date.now(), a = !0, x(L()), f();
      }, Math.max(0, m - p));
    })), !u && !t && (t = setTimeout(() => a = !0, m)), a = !1, s);
  };
}
function xo(n) {
  return n || ea();
}
function yn(n, e = 200, t = {}) {
  return ka(
    No(e, t),
    n
  );
}
function wa(n, e = 200, t = !1, a = !0, r = !1) {
  return ka(
    Ao(e, t, a, r),
    n
  );
}
function Bo(n, e = !0, t) {
  xo() ? de(n, t) : e ? n() : Qe(n);
}
function He(n) {
  var e;
  const t = Ae(n);
  return (e = t == null ? void 0 : t.$el) != null ? e : t;
}
const pt = _a ? window : void 0;
function ut(...n) {
  let e, t, a, r;
  if (typeof n[0] == "string" || Array.isArray(n[0]) ? ([t, a, r] = n, e = pt) : [e, t, a, r] = n, !e)
    return Ce;
  Array.isArray(t) || (t = [t]), Array.isArray(a) || (a = [a]);
  const s = [], i = () => {
    s.forEach((f) => f()), s.length = 0;
  }, o = (f, v, d, m) => (f.addEventListener(v, d, m), () => f.removeEventListener(v, d, m)), u = le(
    () => [He(e), Ae(r)],
    ([f, v]) => {
      if (i(), !f)
        return;
      const d = Co(v) ? { ...v } : v;
      s.push(
        ...t.flatMap((m) => a.map((p) => o(f, m, p, d)))
      );
    },
    { immediate: !0, flush: "post" }
  ), l = () => {
    u(), i();
  };
  return bn(l), l;
}
let Rn = !1;
function _n(n, e, t = {}) {
  const { window: a = pt, ignore: r = [], capture: s = !0, detectIframe: i = !1 } = t;
  if (!a)
    return Ce;
  Mo && !Rn && (Rn = !0, Array.from(a.document.body.children).forEach((d) => d.addEventListener("click", Ce)), a.document.documentElement.addEventListener("click", Ce));
  let o = !0;
  const u = (d) => r.some((m) => {
    if (typeof m == "string")
      return Array.from(a.document.querySelectorAll(m)).some((p) => p === d.target || d.composedPath().includes(p));
    {
      const p = He(m);
      return p && (d.target === p || d.composedPath().includes(p));
    }
  }), f = [
    ut(a, "click", (d) => {
      const m = He(n);
      if (!(!m || m === d.target || d.composedPath().includes(m))) {
        if (d.detail === 0 && (o = !u(d)), !o) {
          o = !0;
          return;
        }
        e(d);
      }
    }, { passive: !0, capture: s }),
    ut(a, "pointerdown", (d) => {
      const m = He(n);
      o = !u(d) && !!(m && !d.composedPath().includes(m));
    }, { passive: !0 }),
    i && ut(a, "blur", (d) => {
      setTimeout(() => {
        var m;
        const p = He(n);
        ((m = a.document.activeElement) == null ? void 0 : m.tagName) === "IFRAME" && !(p != null && p.contains(a.document.activeElement)) && e(d);
      }, 0);
    })
  ].filter(Boolean);
  return () => f.forEach((d) => d());
}
function Oo() {
  const n = I(!1), e = ea();
  return e && de(() => {
    n.value = !0;
  }, e), n;
}
function $a(n) {
  const e = Oo();
  return b(() => (e.value, !!n()));
}
function Ht(n, e, t = {}) {
  const { window: a = pt, ...r } = t;
  let s;
  const i = $a(() => a && "ResizeObserver" in a), o = () => {
    s && (s.disconnect(), s = void 0);
  }, u = b(() => Array.isArray(n) ? n.map((v) => He(v)) : [He(n)]), l = le(
    u,
    (v) => {
      if (o(), i.value && a) {
        s = new ResizeObserver(e);
        for (const d of v)
          d && s.observe(d, r);
      }
    },
    { immediate: !0, flush: "post" }
  ), f = () => {
    o(), l();
  };
  return bn(f), {
    isSupported: i,
    stop: f
  };
}
function wt(n, e, t = {}) {
  const {
    root: a,
    rootMargin: r = "0px",
    threshold: s = 0.1,
    window: i = pt,
    immediate: o = !0
  } = t, u = $a(() => i && "IntersectionObserver" in i), l = b(() => {
    const p = Ae(n);
    return (Array.isArray(p) ? p : [p]).map(He).filter(Po);
  });
  let f = Ce;
  const v = I(o), d = u.value ? le(
    () => [l.value, He(a), v.value],
    ([p, L]) => {
      if (f(), !v.value || !p.length)
        return;
      const x = new IntersectionObserver(
        e,
        {
          root: He(L),
          rootMargin: r,
          threshold: s
        }
      );
      p.forEach((D) => D && x.observe(D)), f = () => {
        x.disconnect(), f = Ce;
      };
    },
    { immediate: o, flush: "post" }
  ) : Ce, m = () => {
    f(), d(), v.value = !1;
  };
  return bn(m), {
    isSupported: u,
    isActive: v,
    pause() {
      f(), v.value = !1;
    },
    resume() {
      v.value = !0;
    },
    stop: m
  };
}
const Vn = 1;
function Ia(n, e = {}) {
  const {
    throttle: t = 0,
    idle: a = 200,
    onStop: r = Ce,
    onScroll: s = Ce,
    offset: i = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    eventListenerOptions: o = {
      capture: !1,
      passive: !0
    },
    behavior: u = "auto",
    window: l = pt,
    onError: f = (k) => {
      console.error(k);
    }
  } = e, v = I(0), d = I(0), m = b({
    get() {
      return v.value;
    },
    set(k) {
      L(k, void 0);
    }
  }), p = b({
    get() {
      return d.value;
    },
    set(k) {
      L(void 0, k);
    }
  });
  function L(k, y) {
    var N, F, G, h;
    if (!l)
      return;
    const _ = Ae(n);
    if (!_)
      return;
    (G = _ instanceof Document ? l.document.body : _) == null || G.scrollTo({
      top: (N = Ae(y)) != null ? N : p.value,
      left: (F = Ae(k)) != null ? F : m.value,
      behavior: Ae(u)
    });
    const B = ((h = _ == null ? void 0 : _.document) == null ? void 0 : h.documentElement) || (_ == null ? void 0 : _.documentElement) || _;
    m != null && (v.value = B.scrollLeft), p != null && (d.value = B.scrollTop);
  }
  const x = I(!1), D = en({
    left: !0,
    right: !1,
    top: !0,
    bottom: !1
  }), E = en({
    left: !1,
    right: !1,
    top: !1,
    bottom: !1
  }), T = (k) => {
    x.value && (x.value = !1, E.left = !1, E.right = !1, E.top = !1, E.bottom = !1, r(k));
  }, g = yn(T, t + a), C = (k) => {
    var y;
    if (!l)
      return;
    const N = ((y = k == null ? void 0 : k.document) == null ? void 0 : y.documentElement) || (k == null ? void 0 : k.documentElement) || He(k), { display: F, flexDirection: G } = getComputedStyle(N), h = N.scrollLeft;
    E.left = h < v.value, E.right = h > v.value;
    const _ = Math.abs(h) <= (i.left || 0), B = Math.abs(h) + N.clientWidth >= N.scrollWidth - (i.right || 0) - Vn;
    F === "flex" && G === "row-reverse" ? (D.left = B, D.right = _) : (D.left = _, D.right = B), v.value = h;
    let V = N.scrollTop;
    k === l.document && !V && (V = l.document.body.scrollTop), E.top = V < d.value, E.bottom = V > d.value;
    const A = Math.abs(V) <= (i.top || 0), j = Math.abs(V) + N.clientHeight >= N.scrollHeight - (i.bottom || 0) - Vn;
    F === "flex" && G === "column-reverse" ? (D.top = j, D.bottom = A) : (D.top = A, D.bottom = j), d.value = V;
  }, $ = (k) => {
    var y;
    if (!l)
      return;
    const N = (y = k.target.documentElement) != null ? y : k.target;
    C(N), x.value = !0, g(k), s(k);
  };
  return ut(
    n,
    "scroll",
    t ? wa($, t, !0, !1) : $,
    o
  ), Bo(() => {
    try {
      const k = Ae(n);
      if (!k)
        return;
      C(k);
    } catch (k) {
      f(k);
    }
  }), ut(
    n,
    "scrollend",
    T,
    o
  ), {
    x: m,
    y: p,
    isScrolling: x,
    arrivedState: D,
    directions: E,
    measure() {
      const k = Ae(n);
      l && k && C(k);
    }
  };
}
function Do(n = {}) {
  const { window: e = pt, behavior: t = "auto" } = n;
  if (!e)
    return {
      x: I(0),
      y: I(0)
    };
  const a = I(e.scrollX), r = I(e.scrollY), s = b({
    get() {
      return a.value;
    },
    set(o) {
      scrollTo({ left: o, behavior: t });
    }
  }), i = b({
    get() {
      return r.value;
    },
    set(o) {
      scrollTo({ top: o, behavior: t });
    }
  });
  return ut(
    e,
    "scroll",
    () => {
      a.value = e.scrollX, r.value = e.scrollY;
    },
    {
      capture: !1,
      passive: !0
    }
  ), { x: s, y: i };
}
const Fo = {
  class: /* @__PURE__ */ U(["ds-carousel__buttons"])
}, Ho = /* @__PURE__ */ q({
  __name: "ds-carousel-buttons",
  props: {
    ariaLabelNext: {},
    ariaLabelPrev: {},
    prevClick: { type: Function },
    nextClick: { type: Function },
    previousButtonDisabled: { type: Boolean },
    nextButtonDisabled: { type: Boolean }
  },
  setup(n) {
    return (e, t) => ve((c(), w("div", Fo, [
      z(S(he), {
        ariaLabel: e.ariaLabelPrev,
        "click-handler": e.prevClick,
        disabled: e.previousButtonDisabled,
        "icon-name": "button-chevron-left",
        variant: "secondary-neutral"
      }, null, 8, ["ariaLabel", "click-handler", "disabled"]),
      z(S(he), {
        ariaLabel: e.ariaLabelNext,
        "click-handler": e.nextClick,
        disabled: e.nextButtonDisabled,
        "icon-name": "button-chevron-right",
        variant: "secondary-neutral"
      }, null, 8, ["ariaLabel", "click-handler", "disabled"])
    ], 512)), [
      [pe, !(e.previousButtonDisabled && e.nextButtonDisabled)]
    ]);
  }
}), zo = { class: "ds-carousel__header" }, Ro = { class: "ds-carousel__header-text" }, Vo = {
  key: 0,
  class: "ds-carousel__link"
}, pd = /* @__PURE__ */ q({
  __name: "ds-carousel",
  props: {
    ariaLabelNext: {},
    ariaLabelPrev: {},
    description: {},
    headingLevel: { default: "h2" },
    linkTarget: {},
    linkText: {},
    linkUrl: {},
    maxItemsPerView: { default: 4 },
    scrollMode: { default: "page" },
    title: {},
    tag: {}
  },
  setup(n) {
    const e = n, a = window.matchMedia("(prefers-reduced-motion: reduce)").matches === !0 ? "auto" : "smooth", r = I(null), s = I(null), i = I(null), o = I(0), u = I(0), l = I(e.maxItemsPerView), f = I(0), v = I(!0), d = I(!0), { direction: m } = ya(s), p = b(() => e.linkUrl && e.linkText), L = b(
      () => `ds-carousel--items-${l.value} ds-carousel--max-items-${x.value}`
    ), x = b(() => e.maxItemsPerView);
    let D;
    const E = () => {
      i.value && (o.value = 0, u.value = i.value.length - 1, f.value = i.value.length, [...i.value].forEach((h, _) => {
        h.dataset.index = _.toString();
      }));
    }, T = () => {
      if (!s.value || !i.value) return;
      const h = i == null ? void 0 : i.value[o.value], _ = i == null ? void 0 : i.value[u.value];
      D = new IntersectionObserver(
        (B) => {
          B.forEach((V) => {
            const A = V.target;
            A.dataset.inView = V.isIntersecting ? "true" : "false", V.target === h && (v.value = V.isIntersecting), V.target === _ && (d.value = V.isIntersecting);
          });
        },
        {
          threshold: 1,
          root: s.value,
          rootMargin: "4px"
        }
      );
    }, g = () => {
      var _;
      const h = (_ = r.value) == null ? void 0 : _.querySelectorAll("[data-in-view='true']");
      h && h.length > 0 && (l.value = h.length || 0);
    }, C = yn(() => {
      g();
    }, 200);
    de(() => {
      s.value && s.value.addEventListener(
        "scroll",
        () => {
          C();
        },
        {
          passive: !0
        }
      );
    }), le(
      r,
      (h) => {
        h !== null && typeof h < "u" && (i.value = h.children);
      },
      { immediate: !0 }
    ), le(
      i,
      (h, _) => {
        D && _ && Array.from(_).forEach((B) => {
          D.unobserve(B);
        }), h && (E(), T(), Array.from(h).forEach((B) => {
          D.observe(B);
        }), g());
      },
      { immediate: !0 }
    ), Ve(() => {
      D && D.disconnect(), s.value && s.value.removeEventListener("scroll", () => {
        C();
      });
    });
    const $ = (h) => m.value === "rtl" ? r.value ? -1 * Math.abs(r.value.offsetWidth) + h.offsetLeft + h.offsetWidth : 0 : h.offsetLeft, k = (h) => {
      if (!r.value) return;
      const _ = r.value.querySelector(
        `[data-index='${h}']`
      );
      _ && s.value && s.value.scrollTo({
        left: $(_),
        behavior: a
      });
    }, y = (h) => {
      if (e.scrollMode === "item") {
        const A = h.length > 1 ? h[1] : h[0];
        return Number(A.dataset.index);
      }
      const _ = h[h.length - 1], B = Number(
        _.dataset.index
      );
      return Math.min(B + 1, f.value);
    }, N = () => {
      var B;
      const h = (B = r.value) == null ? void 0 : B.querySelectorAll(
        "[data-in-view='true']"
      );
      if (h && h.length > 0) {
        const V = y(h);
        k(V);
      }
    }, F = (h) => {
      const _ = h[0], B = Number(
        _.dataset.index
      );
      return e.scrollMode === "item" ? Math.max(B - 1, 0) : Math.max(
        B - l.value,
        0
      );
    }, G = () => {
      var B;
      const h = (B = r.value) == null ? void 0 : B.querySelectorAll(
        "[data-in-view='true']"
      );
      if (h && h.length > 0) {
        const V = F(h);
        k(V);
      }
    };
    return (h, _) => (c(), w("section", {
      class: U(["ds-carousel", L.value])
    }, [
      M("header", zo, [
        M("div", Ro, [
          se(h.$slots, "header", {}, () => [
            h.tag || h.title || h.description ? (c(), w(ne, { key: 0 }, [
              h.tag ? (c(), O(S(Ea), {
                key: 0,
                class: "ds-carousel__tag",
                text: h.tag
              }, null, 8, ["text"])) : P("", !0),
              h.title ? (c(), O(S(Y), {
                key: 1,
                class: "ds-carousel__title",
                "text-type": "heading-3xl",
                "html-element": h.headingLevel
              }, {
                default: H(() => [
                  K(W(h.title), 1)
                ]),
                _: 1
              }, 8, ["html-element"])) : P("", !0),
              h.description ? (c(), O(S(Y), {
                key: 2,
                class: "ds-carousel__description",
                "text-type": "body-md",
                "text-style": "regular",
                "html-element": "p"
              }, {
                default: H(() => [
                  K(W(h.description), 1)
                ]),
                _: 1
              })) : P("", !0)
            ], 64)) : P("", !0)
          ])
        ]),
        p.value ? (c(), w("div", Vo, [
          z(S(be), {
            variant: "link",
            target: h.linkTarget,
            href: h.linkUrl,
            size: "sm",
            "icon-end": "navigate-forward"
          }, {
            default: H(() => [
              K(W(h.linkText), 1)
            ]),
            _: 1
          }, 8, ["target", "href"])
        ])) : P("", !0)
      ]),
      M("div", {
        class: "ds-carousel__scroll",
        ref_key: "scroll",
        ref: s
      }, [
        M("div", {
          class: "ds-carousel__items",
          ref_key: "itemContainer",
          ref: r
        }, [
          se(h.$slots, "default")
        ], 512)
      ], 512),
      z(Ho, {
        ariaLabelNext: h.ariaLabelNext,
        ariaLabelPrev: h.ariaLabelPrev,
        prevClick: G,
        nextClick: N,
        previousButtonDisabled: v.value,
        nextButtonDisabled: d.value
      }, null, 8, ["ariaLabelNext", "ariaLabelPrev", "previousButtonDisabled", "nextButtonDisabled"])
    ], 2));
  }
}), qo = /* @__PURE__ */ q({
  __name: "ds-icon-attention",
  props: {
    ariaLabel: {},
    iconName: { default: "checkmark" },
    size: { default: "md" }
  },
  setup(n) {
    const e = n, t = b(() => {
      const s = [];
      return e.iconName === "error" && s.push("ds-icon-attention--error"), s.push(`ds-icon-attention--${e.size}`), s;
    }), a = b(() => e.iconName === "error" ? "close" : e.iconName), r = b(() => e.size == "md" ? "xl" : "lg");
    return (s, i) => (c(), w("div", {
      class: U(["ds-icon-attention", t.value])
    }, [
      z(S(ae), {
        class: "ds-icon-attention__icon",
        "icon-name": a.value,
        label: s.ariaLabel,
        size: r.value
      }, null, 8, ["icon-name", "label", "size"])
    ], 2));
  }
}), jo = ["aria-labelledby"], Wo = { class: "ds-modal__container" }, Uo = {
  key: 0,
  class: "ds-modal__attention"
}, Ko = {
  key: 1,
  class: "ds-modal__header"
}, Go = 1e3, Yo = /* @__PURE__ */ q({
  inheritAttrs: !1,
  __name: "ds-modal",
  props: {
    attentionIcon: {},
    backdrop: { default: "default" },
    closeLabel: {},
    isOpen: { type: Boolean, default: !1 },
    overflow: { default: "page" },
    size: { default: "md" },
    teleportSelector: {},
    title: {},
    type: { default: "default" }
  },
  emits: ["close-modal"],
  setup(n, { expose: e, emit: t }) {
    const a = n, r = I(null), s = I(null), i = I(null), o = I(!1), { arrivedState: u } = Ia(i, {}), { isMobile: l } = Ie(), f = b(
      () => a.type === "attention" ? "center" : "end"
    ), v = b(() => l.value || a.size === "sm" ? "sm" : "md"), d = b(() => {
      let F = [];
      return !u.top && p.value && F.push("ds-modal__content-inner--fade-top"), !u.bottom && p.value && F.push("ds-modal__content-inner--fade-bottom"), F;
    }), m = Ze("modal-title"), p = I(!1), L = () => {
      i.value && (p.value = i.value.scrollHeight > i.value.clientHeight);
    };
    e({ checkOverflow: L }), _n(r, () => D());
    const x = t, D = () => {
      a.isOpen && E();
    }, E = () => {
      x("close-modal");
    }, g = ta()["data-dialog"] ? "heading-2xl" : "heading-3xl", C = b(() => {
      const F = [];
      return a.backdrop === "blur" && F.push("ds-modal--blur"), F.push(`ds-modal--${a.type}`), F.push(`ds-modal--${a.size}`), F.push(`ds-modal--overflow-${a.overflow}`), F;
    });
    de(() => {
      window.addEventListener("resize", L), L();
    }), na(() => {
      window.removeEventListener("resize", L), N();
    });
    let $ = null, k = null, y = null;
    const N = () => {
      $ && clearTimeout($), k && clearTimeout(k), y && clearTimeout(y);
    };
    return le(
      () => a.isOpen,
      (F, G, h) => {
        if ($ = window.setTimeout(() => {
          o.value = F;
        }, 10), s.value) {
          const _ = s.value;
          if (F) {
            _.showModal();
            const B = _.querySelector("button");
            k = window.setTimeout(() => {
              B == null || B.focus(), L();
            }, 10);
          } else
            y = window.setTimeout(() => {
              _.close();
            }, 700);
        }
        h(N);
      },
      { immediate: !0 }
    ), (F, G) => (c(), O(aa, {
      to: F.teleportSelector,
      disabled: !F.teleportSelector
    }, [
      z(Ue, {
        name: "modal",
        duration: Go
      }, {
        default: H(() => [
          ve(M("dialog", me({
            "aria-labelledby": S(m),
            class: [C.value, "ds-modal"],
            ref_key: "dialog",
            ref: s
          }, F.$attrs, {
            tabindex: "-1",
            onCancel: We(E, ["prevent"])
          }), [
            M("div", Wo, [
              M("div", {
                ref_key: "content",
                ref: r,
                class: "ds-modal__content"
              }, [
                z(S(he), {
                  ariaLabel: F.closeLabel,
                  class: "ds-modal__close",
                  "click-handler": E,
                  "icon-name": "button-close",
                  variant: "ghost-neutral"
                }, null, 8, ["ariaLabel"]),
                F.type === "attention" ? (c(), w("div", Uo, [
                  z(qo, {
                    size: v.value,
                    iconName: F.attentionIcon
                  }, null, 8, ["size", "iconName"])
                ])) : P("", !0),
                F.title ? (c(), w("header", Ko, [
                  F.title ? (c(), O(S(Y), {
                    key: 0,
                    class: "ds-modal__title",
                    "text-type": S(g),
                    "text-style": "regular",
                    "html-element": "h2",
                    id: S(m)
                  }, {
                    default: H(() => [
                      K(W(F.title), 1)
                    ]),
                    _: 1
                  }, 8, ["text-type", "id"])) : P("", !0)
                ])) : P("", !0),
                M("div", {
                  class: U(["ds-modal__content-inner", d.value]),
                  ref_key: "scrollContainer",
                  ref: i
                }, [
                  z(S(Y), {
                    class: "ds-modal__body",
                    "html-element": "div",
                    "text-type": "body-md"
                  }, {
                    default: H(() => [
                      se(F.$slots, "default")
                    ]),
                    _: 3
                  })
                ], 2),
                z(S(ba), {
                  class: "ds-modal__actions",
                  "desktop-alignment": f.value,
                  "desktop-direction": "row",
                  "mobile-alignment": "stretch",
                  "mobile-direction": "column"
                }, {
                  default: H(() => [
                    se(F.$slots, "actions")
                  ]),
                  _: 3
                }, 8, ["desktop-alignment"])
              ], 512)
            ])
          ], 16, jo), [
            [pe, o.value]
          ])
        ]),
        _: 3
      })
    ], 8, ["to", "disabled"]));
  }
}), hd = /* @__PURE__ */ q({
  __name: "ds-dialog",
  props: {
    closeLabel: {},
    isOpen: { type: Boolean, default: !1 },
    overflow: { default: "page" },
    teleportSelector: {},
    title: {},
    type: { default: "default" }
  },
  setup(n) {
    const e = n, t = ta();
    return (a, r) => (c(), O(Yo, me({
      class: ["ds-dialog", a.type === "progressive" ? "ds-dialog--progressive" : ""]
    }, S(t), {
      backdrop: "default",
      closeLabel: e.closeLabel,
      "data-dialog": "true",
      isOpen: e.isOpen,
      overflow: e.overflow,
      size: "sm",
      teleportSelector: e.teleportSelector,
      title: e.title,
      type: e.type === "progressive" ? "default" : e.type
    }), {
      actions: H(() => [
        se(a.$slots, "actions")
      ]),
      default: H(() => [
        se(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["class", "closeLabel", "isOpen", "overflow", "teleportSelector", "title", "type"]));
  }
}), Qo = (n, e, t, a, r, s) => ({
  accept: n,
  fileList: e,
  maxFileSize: t,
  validationMessageDuplicate: a,
  validationMessageFileSize: r,
  validationMessageType: s
}), kn = (n = !0, e = "") => ({
  message: e,
  valid: n
}), wn = (n, e) => n.replace(/\$\{(\w+)\}/g, (t, a) => e[a] ?? t), Xo = (n, e) => {
  const t = e.fileList.value.filter(
    (r) => r.name === n.name
  ), a = wn(
    e.validationMessageDuplicate,
    { filename: n.name }
  );
  return kn(t.length === 0, a);
}, Zo = (n) => n / 1024 / 1024, Jo = (n) => n * 1024 * 1024, el = (n) => Number(n.toFixed(2)), tl = (n, e) => {
  const t = Zo(n.size), a = el(t), r = Jo(e.maxFileSize), s = wn(
    e.validationMessageFileSize,
    {
      filename: n.name,
      filesize: a.toString(),
      maxsize: e.maxFileSize.toString()
    }
  );
  return kn(n.size < r, s);
}, nl = (n, e) => {
  const [t] = e.split("/");
  return n.startsWith(t);
}, al = (n, e) => n === e, rl = (n, e) => {
  const t = e.toLowerCase();
  return n.slice(n.lastIndexOf(".")).toLowerCase() === t;
}, sl = (n, e) => n.type === "" ? !1 : e ? e.split(",").map((a) => a.trim()).some((a) => /^[a-zA-Z]+\/\*$/.test(a) ? nl(n.type, a) : a.includes("/") ? al(n.type, a) : a.startsWith(".") ? rl(n.name, a) : !1) : !0, ol = (n, e) => {
  const t = sl(n, e.accept), a = wn(e.validationMessageType, {
    filename: n.name
  });
  return kn(t, a);
}, ll = [Xo, tl, ol], il = ["src", "width", "height"], ul = /* @__PURE__ */ q({
  __name: "ds-file-thumbnail",
  props: {
    file: {},
    width: { default: 100 },
    height: { default: 100 }
  },
  setup(n) {
    const e = n, t = I("");
    return ln(() => {
      if (e.file) {
        const a = new FileReader();
        a.onload = (r) => {
          var s;
          t.value = (s = r.target) == null ? void 0 : s.result;
        }, a.readAsDataURL(e.file);
      }
    }), (a, r) => (c(), w("div", {
      class: "ds-file-thumbnail",
      style: ge({
        width: a.width + "px",
        height: a.height + "px",
        minWidth: a.width + "px"
      }),
      "aria-hidden": "true"
    }, [
      M("img", {
        class: "ds-file-thumbnail__image",
        src: t.value,
        width: a.width * 2,
        height: a.height * 2,
        alt: ""
      }, null, 8, il)
    ], 4));
  }
}), cl = (n, e) => {
  const t = n.__vccOpts || n;
  for (const [a, r] of e)
    t[a] = r;
  return t;
}, dl = /* @__PURE__ */ cl(ul, [["__scopeId", "data-v-745a06ec"]]), fl = { class: "ds-file-upload" }, ml = ["accept", "aria-describedby", "capture", "disabled", "id", "name", "multiple"], vl = ["id"], pl = {
  key: 0,
  class: "ds-file-upload__list"
}, hl = {
  key: 1,
  class: "ds-file-upload__errors"
}, gd = /* @__PURE__ */ q({
  __name: "ds-file-upload",
  props: {
    context: {}
  },
  setup(n) {
    var Q, oe, ce, Se, Ge, Be, qe, Je, _e, Et, ht;
    const e = n, t = Ze("mobileButton"), { isMobile: a } = Ie(), r = I(null), s = I([]), i = I([]), o = I(!1), u = I(!1), l = I(
      ((Q = e.context) == null ? void 0 : Q.accept) || void 0
    ), f = I(
      ((oe = e.context) == null ? void 0 : oe.maxFileSize) || 10
    ), v = I(
      ((ce = e.context) == null ? void 0 : ce.multiple) || void 0
    ), d = I(
      (Se = e.context) == null ? void 0 : Se.labelAddFilesButton
    ), m = I(
      (Ge = e.context) == null ? void 0 : Ge.labelDropFiles
    ), p = I((Be = e.context) == null ? void 0 : Be.labelRemove), L = I((qe = e.context) == null ? void 0 : qe.labelTapToAdd), x = I(
      (Je = e.context) == null ? void 0 : Je.listMode
    ), D = I(
      (_e = e.context) == null ? void 0 : _e.validationMessageFileSize
    ), E = I(
      (Et = e.context) == null ? void 0 : Et.validationMessageDuplicate
    ), T = I(
      (ht = e.context) == null ? void 0 : ht.validationMessageType
    ), g = (X) => {
      if (X)
        return C[X];
    }, C = {
      true: !0,
      false: !1,
      user: "user",
      environment: "environment"
    }, $ = b(
      () => {
        var X;
        return g((X = e.context) == null ? void 0 : X.capture);
      }
    ), k = b(
      () => {
        var X;
        return u.value || ((X = e.context) == null ? void 0 : X.disabled);
      }
    ), y = b(() => k.value || N.value), N = b(
      () => {
        var X;
        return ((X = e.context) == null ? void 0 : X.multiple) !== !0 && s.value.length > 0;
      }
    ), F = b(
      () => k.value || N.value
    ), G = b(() => {
      const X = [];
      return o.value && X.push("ds-file-upload__target--focus"), u.value && X.push("ds-file-upload__target--dragging"), N.value && X.push("ds-file-upload__target--disabled"), X;
    }), h = b(() => {
      var X;
      return `ds-help-${(X = e.context) == null ? void 0 : X.id}`;
    });
    de(() => {
      var X;
      s.value = ((X = e.context) == null ? void 0 : X.value) ?? [];
    });
    const _ = () => {
      var X;
      if (r.value) {
        const ke = ((X = r.value) == null ? void 0 : X.files) ?? [];
        if (ke)
          for (const Oe of ke)
            R(Oe);
        te();
      }
    }, B = () => {
      u.value = !0;
    }, V = () => {
      u.value = !1;
    }, A = (X) => {
      u.value = !1;
      const ke = X.dataTransfer.files;
      if (ke)
        for (const Oe of ke)
          R(Oe);
    }, j = () => {
      o.value = !0;
    }, Z = () => {
      var X;
      o.value = !1, (X = e.context) == null || X.handlers.blur();
    }, R = (X) => {
      const ke = {
        name: X.name,
        file: X
      };
      Te(X) && s.value.push(ke);
    }, J = (X) => {
      ye(), s.value = s.value.filter(
        (ke) => ke.name !== X.name
      ), te();
    }, re = () => {
      var X;
      r.value && ((X = r.value) == null || X.click());
    }, te = () => {
      var X;
      (X = e.context) == null || X.node.input(s.value);
    }, ie = (X) => X.length > 30 ? `...${X.slice(-27)}` : X, ye = () => {
      i.value = [];
    }, Te = (X) => {
      const ke = [];
      return ll.forEach((Oe) => {
        const Ee = Qo(
          l.value,
          s,
          f.value,
          E.value,
          D.value,
          T.value
        ), De = Oe(X, Ee);
        De.valid || (ke.push(De), i.value.push(De));
      }), ke.length === 0;
    };
    return (X, ke) => {
      var Oe, Ee, De, gt;
      return c(), w("div", fl, [
        M("div", {
          class: U(["ds-file-upload__target", G.value]),
          onDragover: We(B, ["prevent"]),
          onDragleave: V,
          onDrop: We(A, ["prevent"])
        }, [
          S(a) ? P("", !0) : (c(), O(S(ae), {
            key: 0,
            class: "ds-file-upload__icon",
            iconName: "upload"
          })),
          S(a) ? P("", !0) : (c(), O(S(Y), {
            key: 1,
            class: "ds-file-upload__drop-label",
            textType: "label-md"
          }, {
            default: H(() => [
              K(W(m.value), 1)
            ]),
            _: 1
          })),
          M("input", me({
            class: "ds-file-upload__input",
            ref_key: "fileInput",
            ref: r
          }, X.$attrs, {
            accept: l.value,
            "aria-describedby": h.value,
            capture: $.value || void 0,
            disabled: y.value,
            id: (Oe = X.context) == null ? void 0 : Oe.id,
            name: (De = (Ee = X.context) == null ? void 0 : Ee.node) == null ? void 0 : De.name,
            onBlur: Z,
            onClick: ye,
            onFocus: j,
            onInput: _,
            multiple: v.value || void 0,
            type: "file"
          }), null, 16, ml),
          S(a) ? P("", !0) : (c(), O(S(be), {
            key: 2,
            class: "ds-file-upload__button",
            disabled: F.value,
            size: "sm",
            variant: "secondary",
            clickHandler: re
          }, {
            default: H(() => [
              K(W(d.value), 1)
            ]),
            _: 1
          }, 8, ["disabled"])),
          S(a) ? (c(), O(S(he), {
            key: 3,
            ariaLabel: L.value,
            class: "ds-file-upload__icon-button",
            disabled: F.value,
            iconName: "upload",
            id: S(t),
            variant: "secondary",
            onClick: re
          }, null, 8, ["ariaLabel", "disabled", "id"])) : P("", !0),
          S(a) ? (c(), O(S(Y), {
            key: 4,
            textType: "label-lg",
            htmlElement: "label",
            for: S(t)
          }, {
            default: H(() => [
              K(W(L.value), 1)
            ]),
            _: 1
          }, 8, ["for"])) : P("", !0)
        ], 34),
        M("div", {
          class: "formkit-help formkit-help--fileupload",
          id: h.value
        }, W((gt = X.context) == null ? void 0 : gt.help), 9, vl),
        s.value && s.value.length ? (c(), w("ul", pl, [
          (c(!0), w(ne, null, ue(s.value, (Fe) => (c(), w("li", {
            class: "ds-file-upload__item",
            key: Fe.name
          }, [
            x.value === "icon" ? (c(), O(S(ae), {
              key: 0,
              class: "ds-file-upload__item-icon",
              iconName: "document"
            })) : P("", !0),
            x.value === "thumbnail" ? (c(), O(dl, {
              key: 1,
              file: Fe.file,
              height: 28,
              width: 28
            }, null, 8, ["file"])) : P("", !0),
            z(S(Y), {
              class: "ds-file-upload__item-label",
              "html-element": "span",
              textType: "label-md",
              title: Fe.name
            }, {
              default: H(() => [
                K(W(ie(Fe.name)), 1)
              ]),
              _: 2
            }, 1032, ["title"]),
            z(S(be), {
              variant: "link",
              size: "sm",
              class: "ds-file-upload__item-action",
              onClick: (Nt) => J(Fe),
              disabled: k.value
            }, {
              default: H(() => [
                K(W(p.value), 1)
              ]),
              _: 2
            }, 1032, ["onClick", "disabled"])
          ]))), 128))
        ])) : P("", !0),
        i.value.length ? (c(), w("div", hl, [
          (c(!0), w(ne, null, ue(i.value, (Fe) => (c(), O(S(or), {
            appearance: "danger",
            key: Fe.message,
            text: Fe.message
          }, null, 8, ["text"]))), 128))
        ])) : P("", !0)
      ]);
    };
  }
}), gl = /* @__PURE__ */ q({
  __name: "ds-grid",
  props: {
    columns: {},
    columnsSm: {},
    columnsMd: {},
    columnsLg: {},
    columnsXl: {},
    columns2xl: {},
    htmlElement: { default: "div" },
    queryType: { default: "media" }
  },
  setup(n) {
    const e = n, t = b(() => {
      const a = e.queryType === "media" ? "mq-" : "cq-", r = [], s = (o, u) => {
        o && r.push(u);
      };
      return (() => {
        Object.entries({
          columns: "",
          columnsSm: "sm",
          columnsMd: "md",
          columnsLg: "lg",
          columnsXl: "xl",
          columns2xl: "2xl"
        }).forEach(([u, l]) => {
          const f = u, v = l ? `${a}${l}:` : "";
          s(
            !!e[f],
            `${v}ds-grid--cols-${e[f]}`
          );
        });
      })(), r;
    });
    return (a, r) => a.queryType === "media" ? (c(), O(Tt(a.htmlElement), {
      key: 0,
      class: U(["ds-grid", t.value])
    }, {
      default: H(() => [
        se(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"])) : a.queryType === "container" ? (c(), O(Tt(a.htmlElement), {
      key: 1,
      class: "ds-grid-container"
    }, {
      default: H(() => [
        M("div", {
          class: U(["ds-grid", t.value])
        }, [
          se(a.$slots, "default")
        ], 2)
      ]),
      _: 3
    })) : P("", !0);
  }
}), bl = ["aria-label", "disabled", "form", "name", "type", "value"], yl = ["aria-disabled", "aria-label", "download", "href", "target"], _l = /* @__PURE__ */ q({
  __name: "ds-button-initials",
  props: {
    ariaLabel: {},
    clickHandler: { type: Function, default: () => {
    } },
    disabled: { type: Boolean, default: !1 },
    download: { type: [Boolean, String, null], default: null },
    form: {},
    href: {},
    name: {},
    size: { default: "md" },
    target: {},
    type: { default: "button" },
    value: {},
    variant: { default: "secondary-neutral" }
  },
  setup(n) {
    const e = n, t = b(() => e.size), a = b(() => e.variant), r = un(
      {
        variant: a,
        size: t
      },
      "ds-button-initials"
    );
    return (s, i) => (c(), w(ne, null, [
      s.href ? P("", !0) : (c(), w("button", me({ key: 0 }, s.$attrs, {
        onClick: i[0] || (i[0] = //@ts-ignore
        (...o) => s.clickHandler && s.clickHandler(...o)),
        class: ["ds-button-initials", S(r)],
        "aria-label": s.ariaLabel,
        disabled: s.disabled || void 0,
        form: s.form,
        name: s.name,
        type: s.type,
        value: s.value
      }), [
        z(Y, {
          "html-element": "span",
          "text-style": "medium",
          "text-type": "label-md"
        }, {
          default: H(() => [
            se(s.$slots, "default")
          ]),
          _: 3
        })
      ], 16, bl)),
      s.href ? (c(), w("a", me({ key: 1 }, s.$attrs, {
        onClick: i[1] || (i[1] = //@ts-ignore
        (...o) => s.clickHandler && s.clickHandler(...o)),
        class: ["ds-button-initials", S(r)],
        "aria-disabled": s.disabled || void 0,
        "aria-label": s.ariaLabel,
        download: s.download === !0 ? "" : s.download,
        href: s.href,
        target: s.target
      }), [
        z(Y, {
          "html-element": "span",
          "text-style": "medium",
          "text-type": "label-md"
        }, {
          default: H(() => [
            se(s.$slots, "default")
          ]),
          _: 3
        })
      ], 16, yl)) : P("", !0)
    ], 64));
  }
}), kl = { class: "ds-logo__picture" }, wl = ["src", "alt"], $l = ["src", "alt"], Ta = /* @__PURE__ */ q({
  __name: "ds-logo",
  props: {
    href: { default: "/" },
    altText: {},
    imageSrc: {},
    imageSrcDark: {},
    clickHandler: {},
    isCompact: { type: Boolean, default: !0 },
    isInverted: { type: Boolean, default: !1 },
    size: { default: "md" }
  },
  setup(n) {
    const e = n, t = b(() => {
      const a = [];
      return a.push(`ds-logo--${e.size}`), e.isCompact && a.push("ds-logo--compact"), a;
    });
    return (a, r) => (c(), w("div", {
      class: U(["ds-logo", t.value])
    }, [
      M("a", {
        class: "ds-logo__link",
        href: "/",
        onClick: r[0] || (r[0] = //@ts-ignore
        (...s) => a.clickHandler && a.clickHandler(...s))
      }, [
        M("picture", kl, [
          M("img", {
            class: "ds-logo__image ds-logo__image--light",
            src: a.imageSrc,
            alt: a.altText,
            fetchpriority: "high"
          }, null, 8, wl),
          a.imageSrcDark ? (c(), w("img", {
            key: 0,
            class: "ds-logo__image ds-logo__image--dark",
            src: a.imageSrcDark,
            alt: a.altText,
            fetchpriority: "high"
          }, null, 8, $l)) : P("", !0)
        ])
      ])
    ], 2));
  }
}), Sa = (n) => n ? "checkVisibility" in n && typeof n.checkVisibility == "function" ? n.checkVisibility() : n instanceof HTMLElement && !!n.offsetParent : !1, Il = ["href", "target"], Tl = ["aria-expanded", "aria-controls", "id"], Sl = ["aria-expanded", "aria-controls", "id"], Pl = /* @__PURE__ */ M("div", { class: "ds-nav-item__dropdown" }, null, -1), Ll = /* @__PURE__ */ q({
  __name: "ds-nav-item",
  props: {
    navItem: {}
  },
  setup(n) {
    const e = n, t = I(!1), a = I(null), r = I(null), s = b(() => {
      const p = [];
      return e.navItem.isActive && p.push("ds-nav-item--active"), p;
    }), i = b(() => {
      const p = [];
      return t.value && p.push("ds-nav-item-dropdown--open"), p;
    }), o = ee("activeMegaMenuId", I("")), u = b(() => o ? (o == null ? void 0 : o.value) === e.navItem.itemId : !1), l = (p) => {
      u.value && (p.key === "Escape" && v(e.navItem.itemId, a), p.key === "Tab" && !p.shiftKey && (p.preventDefault(), f()));
    }, f = () => {
      const p = document.getElementById(
        o.value
      );
      if (p) {
        const x = [...p.querySelectorAll("a[href], button")].find((D) => Sa(D));
        x && x.focus();
      }
    }, v = ee(
      "togglePrimaryMegaNav",
      (p, L) => {
        console.warn(
          "Missing open mega nav function for ",
          p,
          L
        );
      }
    ), d = () => {
      t.value = !t.value;
    }, m = () => {
      e.navItem.type === "mega" && v(e.navItem.itemId, a), e.navItem.type === "drilldown" && v(e.navItem.itemId, r), e.navItem.type === "dropdown" && d();
    };
    return (p, L) => (c(), w(ne, null, [
      p.navItem.type === "link" ? (c(), w("a", {
        key: 0,
        class: U(["ds-nav-item", s.value]),
        href: p.navItem.linkUrl,
        target: p.navItem.linkTarget
      }, W(p.navItem.text), 11, Il)) : P("", !0),
      p.navItem.type === "drilldown" ? (c(), w("button", {
        key: 1,
        onClick: m,
        onKeydown: l,
        "aria-expanded": u.value,
        "aria-controls": p.navItem.itemId,
        id: `button-${p.navItem.itemId}`,
        class: U(["ds-nav-item", s.value]),
        ref_key: "primaryDrilldownItem",
        ref: r
      }, [
        K(W(p.navItem.text) + " ", 1),
        P("", !0)
      ], 42, Tl)) : P("", !0),
      p.navItem.type === "mega" ? (c(), w("button", {
        key: 2,
        onClick: m,
        onKeydown: l,
        "aria-expanded": u.value,
        "aria-controls": p.navItem.itemId,
        id: `button-${p.navItem.itemId}`,
        class: U(["ds-nav-item", s.value]),
        ref_key: "primaryMegaItem",
        ref: a
      }, [
        K(W(p.navItem.text) + " ", 1),
        P("", !0)
      ], 42, Sl)) : P("", !0),
      p.navItem.type === "dropdown" ? (c(), w("div", {
        key: 3,
        class: U(["ds-nav-item-dropdown", i.value])
      }, [
        M("button", {
          onClick: m,
          class: U(["ds-nav-item ds-nav-item--mega", s.value])
        }, [
          K(W(p.navItem.text) + " ", 1),
          z(ae, {
            class: "ds-nav-item__icon",
            iconName: "chevron-down",
            size: "sm"
          })
        ], 2),
        Pl
      ], 2)) : P("", !0)
    ], 64));
  }
}), Cl = ["aria-label"], Ml = { class: "ds-nav-primary__list" }, qn = /* @__PURE__ */ q({
  __name: "ds-nav-primary",
  props: {
    navItems: {}
  },
  setup(n) {
    const e = ee("labels", {});
    return (t, a) => {
      var r;
      return c(), w("nav", {
        class: "ds-nav-primary",
        "aria-label": ((r = S(e)) == null ? void 0 : r.primaryNavLandmark) ?? "Primary"
      }, [
        M("ul", Ml, [
          (c(!0), w(ne, null, ue(t.navItems, (s) => (c(), w("li", {
            class: "ds-nav-primary__list-item",
            key: s.text
          }, [
            z(Ll, { navItem: s }, null, 8, ["navItem"])
          ]))), 128))
        ])
      ], 8, Cl);
    };
  }
}), El = ["aria-expanded", "id", "data-trigger-id"], Nl = /* @__PURE__ */ q({
  __name: "ds-nav-secondary-item",
  props: {
    id: {},
    isActive: { type: Boolean, default: !1 },
    isLink: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = n, t = ee("activeMegaMenuId", null), a = ee("activePrimaryId", void 0), r = b(() => {
      const u = [];
      return e.isActive && u.push("ds-nav-secondary-item--active"), u;
    }), s = I(null), i = ee(
      "openSecondaryMegaNav",
      (u, l) => {
        console.warn(
          "Missing open secondary mega nav function for ",
          u,
          l
        );
      }
    ), o = (u) => {
      i && i(u, s);
    };
    return (u, l) => u.isLink ? P("", !0) : (c(), w("button", {
      key: 0,
      onClick: l[0] || (l[0] = () => o(u.id)),
      "aria-expanded": S(t) === S(a),
      "aria-controls": "megaNav",
      id: `trigger-${u.id}`,
      "data-trigger-id": u.id,
      class: U(["ds-nav-secondary-item", r.value]),
      ref_key: "secondaryNavItem",
      ref: s
    }, [
      z(Y, {
        "html-element": "span",
        "text-type": "label-md"
      }, {
        default: H(() => [
          se(u.$slots, "default")
        ]),
        _: 3
      }),
      z(ae, {
        class: "ds-nav-secondary-item__icon",
        iconName: "chevron-down",
        size: "xs"
      })
    ], 10, El));
  }
}), Al = ["aria-label"], xl = { class: "ds-nav-secondary__list" }, Bl = /* @__PURE__ */ q({
  __name: "ds-nav-secondary",
  props: {
    navItems: {}
  },
  setup(n) {
    const e = ee("labels", {});
    return (t, a) => {
      var r;
      return c(), w("nav", {
        class: "ds-nav-secondary",
        "aria-label": ((r = S(e)) == null ? void 0 : r.secondaryNavLandmark) ?? "Secondary"
      }, [
        M("ul", xl, [
          (c(!0), w(ne, null, ue(t.navItems, (s) => (c(), w("li", {
            class: "ds-nav-secondary__list-item",
            key: `nav-${s.itemId}`
          }, [
            z(Nl, {
              id: s.itemId,
              isActive: s.isActive
            }, {
              default: H(() => [
                K(W(s.text), 1)
              ]),
              _: 2
            }, 1032, ["id", "isActive"])
          ]))), 128))
        ])
      ], 8, Al);
    };
  }
});
function $n(n) {
  const e = ee("labels", {}), t = ee("hideBackdrop");
  return {
    ariaLabel: b(() => `${n.itemLabel} ${(e == null ? void 0 : e.megaMenuNavLandmark) ?? "Navigation"}`),
    handleKeydown: (s) => {
      s.key === "Escape" && typeof t == "function" && t();
    },
    hideBackdrop: t
  };
}
const Ol = ["href", "target", "rel"], Dl = ["innerHTML"], Fl = /* @__PURE__ */ q({
  __name: "ds-nav-mega-link",
  props: {
    megaMenuLink: {}
  },
  setup(n) {
    const e = n, t = ee("labels", {}), a = b(() => !!e.megaMenuLink.linkIsExternal), r = b(() => {
      if (a.value)
        return "noopener noreferrer";
    }), s = b(() => e.megaMenuLink.linkTarget === "_blank" && (t != null && t.opensNewWindowLabel) ? `${e.megaMenuLink.linkText} <span class="ds-visually-hidden">(${t.opensNewWindowLabel})</span>` : e.megaMenuLink.linkText);
    return (i, o) => (c(), w("a", {
      class: "ds-nav-mega-link",
      href: i.megaMenuLink.linkUrl,
      target: i.megaMenuLink.linkTarget,
      rel: r.value
    }, [
      z(Y, {
        "html-element": "span",
        "text-type": "label-md",
        "text-style": "medium"
      }, {
        default: H(() => [
          M("span", { innerHTML: s.value }, null, 8, Dl)
        ]),
        _: 1
      }),
      a.value ? (c(), O(ae, {
        key: 0,
        class: "ds-nav-mega-link__external",
        iconName: "external-link",
        size: "xs"
      })) : P("", !0)
    ], 8, Ol));
  }
}), Hl = { class: "ds-nav-mega-link-list" }, zl = ["aria-labelledby"], Rl = /* @__PURE__ */ q({
  __name: "ds-nav-mega-link-list",
  props: {
    categoryTitle: {},
    links: {}
  },
  setup(n) {
    const e = Ze("megamenu-linklist");
    return (t, a) => (c(), w("div", Hl, [
      z(Y, {
        id: S(e),
        "html-element": "h2",
        "text-type": "label-sm",
        "text-style": "medium",
        class: "ds-nav-mega-link-list__category"
      }, {
        default: H(() => [
          K(W(t.categoryTitle), 1)
        ]),
        _: 1
      }, 8, ["id"]),
      M("ul", {
        class: "ds-nav-mega-link-list__list",
        "aria-labelledby": S(e)
      }, [
        (c(!0), w(ne, null, ue(t.links, (r) => (c(), w("li", {
          class: "ds-nav-mega-link-list__item",
          key: `${r.linkText}${r.linkUrl}`
        }, [
          z(Fl, { "mega-menu-link": r }, null, 8, ["mega-menu-link"])
        ]))), 128))
      ], 8, zl)
    ]));
  }
}), Vl = { class: "ds-nav-mega-title" }, ql = /* @__PURE__ */ q({
  __name: "ds-nav-mega-title",
  props: {
    title: {},
    linkText: {},
    linkUrl: {}
  },
  setup(n) {
    return (e, t) => (c(), w("div", Vl, [
      z(Y, {
        "text-type": "heading-2xl",
        "text-style": "regular",
        class: "ds-nav-mega-title__title"
      }, {
        default: H(() => [
          K(W(e.title), 1)
        ]),
        _: 1
      }),
      e.linkText ? (c(), O(be, {
        key: 0,
        "icon-end": "button-navigate-forward",
        variant: "link",
        href: e.linkUrl
      }, {
        default: H(() => [
          K(W(e.linkText), 1)
        ]),
        _: 1
      }, 8, ["href"])) : P("", !0)
    ]));
  }
}), jl = ["href", "target"], Wl = { class: "ds-nav-card__figure" }, Ul = ["src", "alt"], Kl = ["innerHTML"], zt = /* @__PURE__ */ q({
  __name: "ds-nav-card",
  props: {
    title: {},
    description: {},
    linkUrl: {},
    linkIsExternal: { type: Boolean },
    linkTarget: {},
    imageSrc: {},
    imageAltText: {}
  },
  setup(n) {
    const e = n, t = b(() => e.linkUrl && e.imageSrc && e.title);
    return (a, r) => t.value ? (c(), w("a", {
      key: 0,
      class: "ds-nav-card",
      href: a.linkUrl,
      target: a.linkTarget
    }, [
      M("figure", Wl, [
        M("img", {
          class: "ds-nav-card__image",
          src: a.imageSrc,
          alt: a.imageAltText
        }, null, 8, Ul)
      ]),
      z(Y, {
        class: "ds-nav-card__title",
        "html-element": "h3",
        "text-style": "medium",
        "text-type": "label-md"
      }, {
        default: H(() => [
          K(W(a.title) + " ", 1),
          a.linkIsExternal ? (c(), O(ae, {
            key: 0,
            class: "ds-nav-card__icon",
            "icon-name": "button-external-link",
            size: "xs"
          })) : P("", !0)
        ]),
        _: 1
      }),
      a.description ? (c(), O(Y, {
        key: 0,
        class: "ds-nav-card__description",
        "html-element": "p",
        "text-type": "label-sm"
      }, {
        default: H(() => [
          M("span", { innerHTML: a.description }, null, 8, Kl)
        ]),
        _: 1
      })) : P("", !0)
    ], 8, jl)) : P("", !0);
  }
}), Gl = { class: "ds-nav-mega-column ds-nav-mega-column--cards" }, Yl = /* @__PURE__ */ q({
  __name: "ds-nav-mega-cards",
  props: {
    cards: {}
  },
  setup(n) {
    return (e, t) => (c(), w("div", Gl, [
      (c(!0), w(ne, null, ue(e.cards, (a) => (c(), O(zt, me({
        key: a.title
      }, a), null, 16))), 128))
    ]));
  }
}), In = /* @__PURE__ */ q({
  __name: "ds-nav-mega-column",
  props: {
    megaNavColumn: {}
  },
  setup(n) {
    return (e, t) => e.megaNavColumn.type === "linkList" ? (c(), O(Rl, {
      key: 0,
      categoryTitle: e.megaNavColumn.content.categoryTitle,
      links: e.megaNavColumn.content.links
    }, null, 8, ["categoryTitle", "links"])) : e.megaNavColumn.type === "titleBlock" ? (c(), O(ql, {
      key: 1,
      title: e.megaNavColumn.content.title,
      linkText: e.megaNavColumn.content.linkText,
      linkUrl: e.megaNavColumn.content.linkUrl
    }, null, 8, ["title", "linkText", "linkUrl"])) : e.megaNavColumn.type === "promo" ? (c(), O(Yl, {
      key: 2,
      cards: e.megaNavColumn.content.cards
    }, null, 8, ["cards"])) : P("", !0);
  }
});
function Tn(n, e = I(null)) {
  const t = I([]), a = I([]), r = I(null), s = I(null), i = I(null), o = ee("hideBackdrop"), u = ee(
    "lastFocusedSecondaryNavItem",
    I(null)
  ), l = ee(
    "lastFocusedPrimaryNavItem",
    I(null)
  ), f = ee(
    "primaryNextPrev",
    b(() => ({
      nextItem: ""
    }))
  ), v = () => {
    n.value && n.value !== null && (a.value = [
      ...n.value.querySelectorAll(
        'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
      )
    ].filter((h) => Sa(h)), r.value = a.value[0] || null, i.value = a.value[a.value.length - 1] || null);
  }, d = () => {
    e.value && (t.value = [
      ...e.value.querySelectorAll(
        'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
      )
    ], s.value = t.value[0] || null);
  }, m = () => {
    v(), d();
  }, p = (h) => {
    var _;
    document.activeElement === r.value && (h.preventDefault(), N.value ? (_ = F.value) == null || _.focus() : D());
  }, L = (h, _, B = !1) => {
    var V;
    B && _ == F.value && ((V = r.value) == null || V.focus(), h.preventDefault());
  }, x = () => {
    typeof o == "function" && o();
  }, D = () => {
    N.value && G.value ? (u.value = G.value, x()) : !N.value && f.value.nextItem && x();
  }, E = (h, _, B) => {
    if (_ === B) {
      h.preventDefault();
      const V = document.querySelector(
        `.ds-nav-item[aria-controls='${f.value.nextItem}']`
      );
      l.value = V, D();
    }
  }, T = (h, _ = !1) => {
    const B = document.activeElement, V = i.value;
    L(h, B, _), E(h, B, V);
  }, g = (h) => {
    !e.value || h.key !== "Tab" || (h.shiftKey ? p(h) : T(h, !0));
  }, C = (h) => {
    !n.value || h.key !== "Tab" || (h.shiftKey ? p(h) : T(h));
  };
  de(() => {
    e.value && e.value.addEventListener("keydown", g), n.value && n.value.addEventListener(
      "keydown",
      C
    ), m();
  }), Ve(() => {
    e.value && e.value.removeEventListener("keydown", g), n.value && n.value.removeEventListener(
      "keydown",
      C
    );
  });
  const $ = () => {
    const h = t.value.find(
      (_) => _.className.includes("ds-nav-mega-tab--active")
    );
    h && h.focus();
  }, k = (h, _ = null) => {
    h && _ ? _.focus() : h && !_ && $();
  }, y = async (h, _ = null) => {
    await Qe(), m(), k(h, _);
  }, N = b(() => e.value !== null), F = b(() => t.value.find(
    (h) => h.className.includes("ds-nav-mega-tab--active")
  )), G = b(() => {
    var h;
    if (N.value) {
      const _ = (h = F.value) == null ? void 0 : h.getAttribute("data-next-id");
      return document.querySelector(
        `.ds-nav-secondary-item[data-trigger-id='${_}']`
      );
    }
    return null;
  });
  return {
    focusableContent: a,
    focusableTabs: t,
    setLastFocusedElement: D,
    updateFocusableElements: y
  };
}
const Ql = ["aria-labelledby", "id"], Xl = { class: "ds-nav-mega__content" }, Zl = /* @__PURE__ */ q({
  __name: "ds-nav-mega",
  props: {
    itemLabel: {},
    itemId: {},
    megaNavColumns: {}
  },
  setup(n) {
    const e = ee("activeOverlayType", I("none")), t = ee("labels", {}), a = n, r = I(null), s = ee("activeMegaMenuId", I("")), i = b(() => e.value === "primaryMega" && (s == null ? void 0 : s.value) === a.itemId), { handleKeydown: o, hideBackdrop: u } = $n({
      itemLabel: a.itemLabel
    }), l = ee(
      "lastFocusedPrimaryNavItem",
      I(null)
    ), f = (d) => {
      typeof u == "function" && u();
    }, { updateFocusableElements: v } = Tn(r);
    return le(i, async (d) => {
      d && r.value !== null ? v(!1) : l && l.value && (await Qe(), l.value.focus());
    }), (d, m) => ve((c(), w("section", {
      "aria-labelledby": `button-${d.itemId}`,
      class: "ds-nav-mega",
      id: d.itemId,
      ref_key: "megaMenu",
      ref: r,
      onClick: m[0] || (m[0] = We(() => {
      }, ["stop"])),
      onKeydown: m[1] || (m[1] = //@ts-ignore
      (...p) => S(o) && S(o)(...p))
    }, [
      M("div", Xl, [
        z(he, {
          class: "ds-nav-mega-close",
          ariaLabel: S(t).megaMenuCloseButtonLabel ?? "Close menu",
          iconName: "button-close",
          clickHandler: f,
          variant: "tertiary"
        }, null, 8, ["ariaLabel"]),
        M("div", {
          class: U(["ds-nav-mega-panel ds-nav-mega-columns", `ds-nav-mega-columns--${d.megaNavColumns.length}`])
        }, [
          (c(!0), w(ne, null, ue(d.megaNavColumns, (p, L) => (c(), w("div", {
            key: `panel-${d.itemId}-col-${L}`,
            class: U(["ds-nav-mega-column", `ds-nav-mega-column--${p.type}`])
          }, [
            z(In, { megaNavColumn: p }, null, 8, ["megaNavColumn"])
          ], 2))), 128))
        ], 2)
      ])
    ], 40, Ql)), [
      [pe, i.value]
    ]);
  }
}), Jl = ["aria-label"], ei = { class: "ds-nav-drilldown-item__label" }, ti = ["href", "target"], ni = { class: "ds-nav-drilldown-item__label" }, jn = "submenu", ai = /* @__PURE__ */ q({
  __name: "ds-nav-drilldown-item",
  props: {
    isActive: { type: Boolean },
    level: { default: 0 },
    navItem: {}
  },
  setup(n) {
    const e = n, t = b(() => typeof e.navItem.children > "u" ? !1 : e.navItem.children.length > 0), a = b(() => !!(t.value && e.level < 2)), r = b(() => !!e.navItem.linkIsExternal), s = ee(
      "clickDrilldownNavItem",
      (o, u) => {
        console.warn("No click handler attached to", o, u);
      }
    ), i = ee("labels", { submenuLabel: jn });
    return (o, u) => o.navItem && a.value ? (c(), w("button", {
      key: 0,
      "aria-label": `${o.navItem.text} ${S(i).submenuLabel || jn}`,
      class: U(["ds-nav-drilldown-item", o.isActive ? "ds-nav-drilldown-item--active" : null]),
      onClick: u[0] || (u[0] = (l) => S(s)(o.navItem, o.level))
    }, [
      M("span", ei, [
        z(Y, {
          "text-type": "label-md",
          "text-style": "medium",
          "html-element": "span"
        }, {
          default: H(() => [
            K(W(o.navItem.text), 1)
          ]),
          _: 1
        })
      ]),
      a.value ? (c(), O(ae, {
        key: 0,
        class: "ds-nav-drilldown-item__chevron",
        size: "sm",
        iconName: "chevron-right"
      })) : P("", !0)
    ], 10, Jl)) : o.navItem && "linkUrl" in o.navItem && !t.value ? (c(), w("a", {
      key: 1,
      class: "ds-nav-drilldown-item",
      href: o.navItem.linkUrl,
      target: o.navItem.linkTarget
    }, [
      M("span", ni, [
        z(Y, {
          "text-type": "label-md",
          "text-style": "medium",
          "html-element": "span"
        }, {
          default: H(() => [
            K(W(o.navItem.text), 1)
          ]),
          _: 1
        }),
        r.value ? (c(), O(ae, {
          key: 0,
          class: "ds-nav-drilldown-item__external",
          iconName: "button-external-link",
          size: "xs"
        })) : P("", !0)
      ])
    ], 8, ti)) : P("", !0);
  }
}), ri = ["aria-label"], si = { class: "ds-nav-drilldown__list" }, Xt = /* @__PURE__ */ q({
  __name: "ds-nav-drilldown",
  props: {
    activeItems: {},
    item: {},
    level: {}
  },
  setup(n) {
    const e = n, t = b(() => e.activeItems[e.level]), a = b(
      () => {
        var i;
        return t.value ? (i = t.value) == null ? void 0 : i.itemId : null;
      }
    ), r = b(
      () => {
        var i;
        return (i = e.item) == null ? void 0 : i.children;
      }
    ), s = ee("labels", { submenuLabel: "submenu" });
    return (i, o) => (c(), O(Ue, { name: "drillfade" }, {
      default: H(() => [
        i.item && r.value ? (c(), w("section", {
          key: 0,
          "aria-label": `${i.item.text} ${S(s).submenuLabel}`,
          class: U(["ds-nav-mega-column", `ds-nav-mega-column--level-${i.level}`])
        }, [
          M("ul", si, [
            (c(!0), w(ne, null, ue(r.value, (u) => (c(), w("li", {
              class: "ds-nav-drilldown__list-item",
              key: u.itemId
            }, [
              u ? (c(), O(ai, {
                key: 0,
                navItem: u,
                level: i.level,
                isActive: u.itemId === a.value
              }, null, 8, ["navItem", "level", "isActive"])) : P("", !0)
            ]))), 128))
          ])
        ], 10, ri)) : P("", !0)
      ]),
      _: 1
    }));
  }
}), oi = ["aria-labelledby", "id"], li = { class: "ds-nav-mega__content" }, ii = { class: "ds-nav-mega-panel" }, ui = /* @__PURE__ */ q({
  __name: "ds-nav-mega-drilldown",
  props: {
    item: {}
  },
  setup(n) {
    const e = ee("activeOverlayType", I("none")), t = ee("labels", {}), a = I([]);
    fe("clickDrilldownNavItem", (g, C) => {
      var y;
      const $ = ((y = a.value[C]) == null ? void 0 : y.itemId) === (g == null ? void 0 : g.itemId), k = a.value.slice(0, C);
      $ || (k[C] = g), a.value = k, T(!1);
    });
    const s = n, i = I(null), o = I(!0), u = ee("activeMegaMenuId", I("")), l = b(() => e.value === "primaryMega" && (u == null ? void 0 : u.value) === s.item.itemId), f = b(() => typeof s.item.titleBlock < "u"), v = (g) => !g.children || g.children.length === 0 ? 0 : 1 + Math.max(...g.children.map(v)), d = b(() => v(s.item)), m = b(() => 4 - d.value - 1), p = b(() => {
      var g;
      return `drilldown--card-slots-${m.value} drilldown--cards-${((g = s.item.cards) == null ? void 0 : g.length) ?? "0"}`;
    }), { handleKeydown: L, hideBackdrop: x } = $n({
      itemLabel: s.item.text
    }), D = ee(
      "lastFocusedPrimaryNavItem",
      I(null)
    ), E = (g) => {
      typeof x == "function" && x();
    }, { updateFocusableElements: T } = Tn(i);
    return le(a, (g) => {
      g.length === 0 ? setTimeout(() => {
        o.value = !0;
      }, 200) : o.value = !1;
    }), le(l, async (g) => {
      g && i.value !== null ? T(!1) : D && D.value && (await Qe(), D.value.focus());
    }), (g, C) => {
      var $;
      return ve((c(), w("section", {
        "aria-labelledby": `button-${g.item.itemId}`,
        class: "ds-nav-mega ds-nav-mega--drilldown",
        id: g.item.itemId,
        ref_key: "megaMenu",
        ref: i,
        onClick: C[0] || (C[0] = We(() => {
        }, ["stop"])),
        onKeydown: C[1] || (C[1] = //@ts-ignore
        (...k) => S(L) && S(L)(...k))
      }, [
        M("div", li, [
          z(he, {
            class: "ds-nav-mega-close",
            ariaLabel: S(t).megaMenuCloseButtonLabel ?? "Close menu",
            iconName: "button-close",
            clickHandler: E,
            variant: "tertiary"
          }, null, 8, ["ariaLabel"]),
          M("div", ii, [
            M("div", {
              class: U(["ds-nav-mega-drilldown-cols", p.value])
            }, [
              f.value ? (c(), w("div", {
                key: 0,
                class: U(["ds-nav-mega-column", `ds-nav-mega-column--${($ = g.item.titleBlock) == null ? void 0 : $.type}`])
              }, [
                g.item.titleBlock ? (c(), O(In, {
                  key: 0,
                  megaNavColumn: g.item.titleBlock
                }, null, 8, ["megaNavColumn"])) : P("", !0)
              ], 2)) : P("", !0),
              z(Xt, {
                activeItems: a.value,
                item: g.item,
                level: 0
              }, null, 8, ["activeItems", "item"]),
              ve(z(Xt, {
                activeItems: a.value,
                item: a.value[0],
                level: 1
              }, null, 8, ["activeItems", "item"]), [
                [pe, a.value.length]
              ]),
              ve(z(Xt, {
                activeItems: a.value,
                item: a.value[1],
                level: 2
              }, null, 8, ["activeItems", "item"]), [
                [pe, a.value.length === 2]
              ]),
              z(Ue, {
                name: "card",
                appear: ""
              }, {
                default: H(() => [
                  g.item.cards && g.item.cards.length > 0 ? ve((c(), O(zt, me({
                    key: 0,
                    class: "ds-nav-card--1"
                  }, g.item.cards[0]), null, 16)), [
                    [pe, o.value || m.value === 1]
                  ]) : P("", !0)
                ]),
                _: 1
              }),
              z(Ue, {
                name: "card",
                appear: ""
              }, {
                default: H(() => [
                  g.item.cards && g.item.cards.length > 1 ? ve((c(), O(zt, me({
                    key: 0,
                    class: "ds-nav-card--2"
                  }, g.item.cards[1]), null, 16)), [
                    [pe, o.value || m.value === 2]
                  ]) : P("", !0)
                ]),
                _: 1
              })
            ], 2)
          ])
        ])
      ], 40, oi)), [
        [pe, l.value]
      ]);
    };
  }
}), ci = { class: "ds-nav-mega-tabs__nav-wrapper" }, di = { class: "ds-nav-mega-tabs__list" }, fi = ["id", "data-itemid", "aria-controls", "data-next-id", "data-prev-id", "data-first-id", "data-last-id", "onClick"], mi = /* @__PURE__ */ M("div", { class: "ds-nav-mega-tabs__indicator" }, [
  /* @__PURE__ */ M("div", { class: "ds-nav-mega-tabs__active-line" })
], -1), vi = ["id", "aria-labelledby", "aria-hidden"], pi = /* @__PURE__ */ q({
  __name: "ds-nav-mega-tabs",
  props: {
    activeTabLabel: {},
    itemLabel: {},
    isVisible: { type: Boolean },
    tabs: { default: () => [] }
  },
  setup(n) {
    const e = n, t = I(null), a = I([]), { handleKeydown: r, hideBackdrop: s } = $n({
      itemLabel: e.itemLabel
    }), { direction: i } = ya(t), o = I(null), u = I(null), { updateFocusableElements: l } = Tn(u, o), f = (T) => {
      p.value !== T ? p.value = T : typeof s == "function" && s();
    }, v = (T) => {
      typeof s == "function" && s();
    }, d = ee("labels", {}), m = ee(
      "lastFocusedSecondaryNavItem",
      I(null)
    ), p = ee("activeTabId", I(null)), L = b(() => {
      let T = null;
      return a.value && (T = a.value.find(
        (g) => g.getAttribute("data-itemid") === p.value
      )), T;
    }), x = I({
      "--scale-factor": "0px",
      "--translate-x": "0px"
    }), D = (T) => {
      var g;
      return i.value === "rtl" ? o.value ? T.offsetLeft - ((g = o.value) == null ? void 0 : g.offsetWidth) : 0 : T.offsetLeft;
    }, E = async () => {
      const T = L.value;
      await Qe(), await l(!0), x.value = {
        "--scale-factor": `${T == null ? void 0 : T.getBoundingClientRect().width}px`,
        "--translate-x": `${D(T)}px`
      };
    };
    return le(
      () => e.isVisible,
      async (T) => {
        T && await E(), T || m && m.value && (await Qe(), m.value.focus());
      }
    ), le(L, async (T) => {
      T && await E();
    }), (T, g) => (c(), w("div", {
      class: "ds-nav-mega-tabs",
      ref_key: "megaMenu",
      ref: t,
      onKeydown: g[0] || (g[0] = //@ts-ignore
      (...C) => S(r) && S(r)(...C)),
      style: ge(x.value)
    }, [
      M("div", ci, [
        z(he, {
          class: "ds-nav-mega-close",
          ariaLabel: S(d).megaMenuCloseButtonLabel ?? "Close menu",
          iconName: "button-close",
          clickHandler: v,
          variant: "tertiary"
        }, null, 8, ["ariaLabel"]),
        M("div", {
          class: "ds-nav-mega-tabs__nav",
          ref_key: "tablist",
          ref: o
        }, [
          M("ul", di, [
            (c(!0), w(ne, null, ue(T.tabs, ({ itemId: C, text: $ }, k) => {
              var y, N, F, G;
              return c(), w("li", {
                class: "ds-nav-mega-tabs__list-item",
                key: `${C}-button`
              }, [
                M("button", {
                  id: `${C}-button`,
                  ref_for: !0,
                  ref_key: "tabButtons",
                  ref: a,
                  class: U([
                    "ds-nav-mega-tab",
                    S(p) === C ? "ds-nav-mega-tab--active" : ""
                  ]),
                  "data-itemid": C,
                  "aria-controls": `panel-${C}`,
                  "data-next-id": (y = T.tabs[(k + 1) % T.tabs.length]) == null ? void 0 : y.itemId,
                  "data-prev-id": (N = T.tabs[(k - 1 + T.tabs.length) % T.tabs.length]) == null ? void 0 : N.itemId,
                  "data-first-id": (F = T.tabs[0]) == null ? void 0 : F.itemId,
                  "data-last-id": (G = T.tabs[T.tabs.length - 1]) == null ? void 0 : G.itemId,
                  onClick: () => f(C)
                }, [
                  z(Y, {
                    class: "ds-nav-mega-tab__text",
                    "html-element": "span",
                    "text-type": "label-md"
                  }, {
                    default: H(() => [
                      K(W($), 1)
                    ]),
                    _: 2
                  }, 1024),
                  z(ae, {
                    class: "ds-nav-mega-tab__icon",
                    iconName: "chevron-down",
                    size: "xs"
                  })
                ], 10, fi)
              ]);
            }), 128))
          ])
        ], 512),
        mi
      ]),
      M("div", {
        class: "ds-nav-mega-tabs__panels",
        ref_key: "tabpanel",
        ref: u
      }, [
        (c(!0), w(ne, null, ue(T.tabs, (C) => ve((c(), w("section", {
          class: "ds-nav-mega-panel ds-nav-mega-columns",
          key: C.itemId,
          id: `panel-${C.itemId}`,
          "aria-labelledby": `trigger-${C.itemId}`,
          "aria-hidden": C.itemId !== S(p)
        }, [
          (c(!0), w(ne, null, ue(C.megaNavColumns, ($, k) => (c(), w("div", {
            key: `panel-${C.itemId}-col-${k}`,
            class: U(["ds-nav-mega-column", `ds-nav-mega-column--${$.type}`])
          }, [
            z(In, { megaNavColumn: $ }, null, 8, ["megaNavColumn"])
          ], 2))), 128))
        ], 8, vi)), [
          [pe, C.itemId === S(p)]
        ])), 128))
      ], 512)
    ], 36));
  }
}), hi = /* @__PURE__ */ q({
  __name: "ds-nav-mega-secondary",
  props: {
    itemLabel: {},
    navItems: {}
  },
  setup(n) {
    const e = ee("activeOverlayType", I("none")), t = b(() => e.value === "secondaryMega");
    return (a, r) => ve((c(), w("div", {
      class: "ds-nav-mega ds-nav-mega--secondary",
      onClick: r[0] || (r[0] = We(() => {
      }, ["stop"]))
    }, [
      z(pi, {
        "is-visible": t.value,
        "item-label": a.itemLabel,
        tabs: a.navItems
      }, null, 8, ["is-visible", "item-label", "tabs"])
    ], 512)), [
      [pe, t.value]
    ]);
  }
}), gi = { class: "ds-nav-mega-search__content" }, bi = /* @__PURE__ */ q({
  __name: "ds-nav-mega-search",
  setup(n) {
    const e = ee("activeOverlayType", I("none"));
    return (t, a) => ve((c(), w("div", {
      onClick: a[0] || (a[0] = We(() => {
      }, ["stop"])),
      class: "ds-nav-mega-search"
    }, [
      M("div", gi, [
        se(t.$slots, "default")
      ])
    ], 512)), [
      [pe, S(e) === "search"]
    ]);
  }
});
function Pa(n, e, t, a) {
  const r = I(!1), s = I("0px"), i = I("unset"), o = b(() => {
    const d = [];
    return n.enableSticky && d.push(`${a}--sticky`), r.value && d.push(`${a}--show`), d;
  }), { y: u } = Do();
  let l = 0;
  le(u, () => {
    const d = document.documentElement.scrollHeight - window.innerHeight, m = Math.min(Math.max(u.value, 0), d);
    m >= l ? r.value = !1 : r.value = !0, l = m;
  });
  const v = (d) => `${d}px`;
  return e !== null && Ht(e, (d) => {
    const m = d[0], { height: p } = m.contentRect;
    s.value = v(p);
  }), t !== null && Ht(t, (d) => {
    const m = d[0], { height: p } = m.contentRect;
    p !== 0 && (i.value = v(p));
  }), de(() => {
    var d, m;
    e.value && (s.value = v(
      (d = e.value) == null ? void 0 : d.clientHeight
    )), t.value && (i.value = v(
      (m = t.value) == null ? void 0 : m.clientHeight
    ));
  }), {
    dynamicClasses: o,
    headerHeight: s,
    secondaryHeight: i
  };
}
const yi = { class: "ds-header__inner" }, _i = { class: "ds-header__logo" }, ki = { class: "ds-header__tools" }, wi = { class: "ds-header__icons" }, $i = {
  key: 0,
  class: "ds-header__cta"
}, Ii = {
  key: 0,
  class: "ds-header__primary-stacked"
}, Ti = { class: "ds-header__inner" }, Si = { class: "ds-header__nav" }, Pi = /* @__PURE__ */ q({
  __name: "ds-header-desktop",
  props: {
    basketCount: {},
    basketFn: {},
    enableBasket: { type: Boolean },
    enableSearch: { type: Boolean },
    enableSticky: { type: Boolean, default: !0 },
    navItems: {},
    searchFn: {}
  },
  setup(n) {
    var Te;
    const e = n, t = I(0), a = I(null), r = I(null), s = I(!1), i = I(null), o = I(null), u = I(null), l = I("none"), f = I(null), v = I(null), d = I(null), m = I(0), p = I(!1), L = I(null), { dynamicClasses: x, headerHeight: D, secondaryHeight: E } = Pa(
      {
        enableSticky: e.enableSticky
      },
      L,
      r,
      "ds-header"
    ), T = b(() => `--header-top-height: ${D.value}; --secondary-height: ${E.value}`), g = b(() => m.value < t.value), C = b(() => e.navItems.find((Q) => Q.isActive)), $ = b(() => {
      const Q = e.navItems.findIndex(
        (Be) => {
          var qe;
          return Be.itemId === ((qe = o.value) == null ? void 0 : qe.getAttribute("aria-controls"));
        }
      ), oe = (e.navItems.length + Q - 1) % e.navItems.length, ce = (Q + 1) % e.navItems.length, Se = e.navItems[oe].itemId, Ge = e.navItems[ce].itemId;
      return { prevItem: Se, nextItem: Ge };
    }), k = b(() => {
      var Q;
      return C.value && C.value.type !== "mega" && C.value.type !== "drilldown" && ((Q = C.value.children) == null ? void 0 : Q.length) && C.value.children.length > 0;
    }), y = b(() => {
      var Q, oe;
      return k.value && ((Q = C.value) == null ? void 0 : Q.type) === "link" ? (oe = C.value) == null ? void 0 : oe.children : [];
    }), N = b(() => e.navItems.filter(
      (Q) => Q.type === "mega"
    )), F = b(() => e.navItems.filter(
      (Q) => Q.type === "drilldown"
    )), G = b(() => {
      const Q = [...x.value];
      return k.value && Q.push("ds-header--secondary"), l.value === "secondaryMega" && Q.push("ds-header--secondary-expanded"), l.value === "primaryMega" && Q.push("ds-header--mega"), Q;
    }), h = (Q) => {
      Q.key === "Escape" && _();
    }, _ = () => {
      s.value = !1, B();
    }, B = () => {
      l.value = "none", u.value = null, i.value = null;
    }, V = () => {
      s.value = !0;
    }, A = (Q, oe) => {
      V(), u.value = Q, l.value = "primaryMega", f.value = oe.value;
    }, j = (Q, oe) => {
      u.value === Q ? _() : (A(Q, oe), o.value = oe.value);
    }, Z = (Q, oe) => {
      var ce;
      V(), u.value = ((ce = C.value) == null ? void 0 : ce.itemId) ?? null, i.value = Q, l.value = "secondaryMega", oe != null && oe.value && (v.value = oe.value);
    }, R = () => {
      l.value != "search" ? (V(), l.value = "search", e.searchFn && e.searchFn(!0)) : l.value === "search" && (_(), e.searchFn && e.searchFn(!1));
    }, J = ee("labels", {}), re = ee("loggedIn", I(!1)), te = ee("ctaButtons"), ie = ee("logo", {
      href: "/",
      altText: "Coloplast",
      imageSrc: "",
      clickHandler: () => {
      }
    }), ye = () => {
      var Q, oe, ce;
      (Q = a.value) != null && Q.parentElement && ((ce = (oe = a.value) == null ? void 0 : oe.parentElement) == null ? void 0 : ce.getAttribute("data-sticky-mount")) === "true" && (p.value = !0);
    };
    return de(() => {
      var oe;
      const Q = (oe = d.value) == null ? void 0 : oe.querySelectorAll(".ds-nav-item");
      if (Q && Q.length) {
        let ce = 0;
        for (const Se of Q)
          ce += Se.clientWidth;
        t.value = ce;
      }
      ye();
    }), Ht(d, (Q) => {
      const oe = Q[0], { width: ce } = oe.contentRect;
      m.value = ce;
    }), le(T, (Q) => {
      p.value && a.value && a.value.parentElement && a.value.parentElement.setAttribute("style", Q);
    }), fe("activeMegaMenuId", u), fe("activePrimaryId", (Te = C.value) == null ? void 0 : Te.itemId), fe("activeTabId", i), fe("activeOverlayType", l), fe("primaryNextPrev", $), fe("hideBackdrop", _), fe("showBackdrop", V), fe("togglePrimaryMegaNav", j), fe("openSecondaryMegaNav", Z), fe("lastFocusedPrimaryNavItem", f), fe("lastFocusedSecondaryNavItem", v), (Q, oe) => {
      var ce, Se, Ge, Be, qe, Je;
      return c(), w(ne, null, [
        M("header", {
          class: U(["ds-header", G.value]),
          ref_key: "header",
          ref: a,
          onShowBackdrop: V,
          onKeydown: h,
          style: ge(T.value)
        }, [
          M("div", {
            class: "ds-header__top",
            ref_key: "headerTop",
            ref: L
          }, [
            M("div", yi, [
              M("div", _i, [
                z(Ta, Wa(Ua(S(ie))), null, 16)
              ]),
              M("div", {
                ref_key: "primaryInline",
                ref: d,
                class: "ds-header__primary-inline"
              }, [
                g.value ? P("", !0) : (c(), O(qn, {
                  key: 0,
                  navItems: Q.navItems
                }, null, 8, ["navItems"]))
              ], 512),
              M("div", ki, [
                M("div", wi, [
                  Q.enableSearch ? (c(), O(he, {
                    key: 0,
                    class: "ds-header-search",
                    onClick: R,
                    ariaLabel: ((ce = S(J)) == null ? void 0 : ce.searchButtonLabel) ?? "Search",
                    iconName: "button-search",
                    variant: "ghost-neutral"
                  }, null, 8, ["ariaLabel"])) : P("", !0),
                  Q.enableBasket ? (c(), O(he, {
                    key: 1,
                    class: "ds-header-basket",
                    ariaLabel: ((Se = S(J)) == null ? void 0 : Se.basketButtonLabel) ?? "Basket",
                    clickHandler: Q.basketFn,
                    iconName: "button-shopping-basket",
                    "notification-count": Q.basketCount,
                    variant: "ghost-neutral"
                  }, null, 8, ["ariaLabel", "clickHandler", "notification-count"])) : P("", !0)
                ]),
                S(te) ? (c(), w("div", $i, [
                  S(re) && ((Ge = S(te).myAccountButtonNavItem) != null && Ge.initials) && ((Be = S(te).myAccountButtonNavItem) != null && Be.initials.length) ? (c(), O(_l, {
                    key: 0,
                    ariaLabel: `'${S(te).myAccountButtonNavItem.text} - ${S(te).myAccountButtonInitials}`,
                    onClick: S(te).myAccountButtonFn,
                    href: S(te).myAccountButtonNavItem.linkUrl,
                    size: "md",
                    variant: "primary"
                  }, {
                    default: H(() => [
                      K(W(S(te).myAccountButtonNavItem.initials), 1)
                    ]),
                    _: 1
                  }, 8, ["ariaLabel", "onClick", "href"])) : S(re) && ((qe = S(te).myAccountButtonNavItem) != null && qe.text) ? (c(), O(be, {
                    key: 1,
                    href: S(te).myAccountButtonNavItem.linkUrl,
                    onClick: S(te).myAccountButtonFn,
                    size: "sm",
                    variant: "primary"
                  }, {
                    default: H(() => {
                      var _e;
                      return [
                        K(W((_e = S(te).myAccountButtonNavItem) == null ? void 0 : _e.text), 1)
                      ];
                    }),
                    _: 1
                  }, 8, ["href", "onClick"])) : P("", !0),
                  !S(re) && S(te).loginButtonLabel ? (c(), O(be, {
                    key: 2,
                    href: S(te).loginButtonLink,
                    onClick: S(te).loginButtonFn,
                    size: "sm",
                    variant: "primary"
                  }, {
                    default: H(() => [
                      K(W(S(te).loginButtonLabel), 1)
                    ]),
                    _: 1
                  }, 8, ["href", "onClick"])) : P("", !0)
                ])) : P("", !0)
              ]),
              g.value ? (c(), w("div", Ii, [
                z(qn, { navItems: Q.navItems }, null, 8, ["navItems"])
              ])) : P("", !0)
            ])
          ], 512),
          k.value ? ve((c(), w("div", {
            key: 0,
            class: "ds-header__bottom",
            ref_key: "secondary",
            ref: r
          }, [
            M("div", Ti, [
              M("div", Si, [
                z(Bl, {
                  navItems: y.value ?? []
                }, null, 8, ["navItems"])
              ])
            ])
          ], 512)), [
            [pe, !s.value]
          ]) : P("", !0),
          ve(M("div", {
            class: "ds-header__mega",
            id: "meganav",
            onClick: _
          }, [
            (c(!0), w(ne, null, ue(N.value, (_e) => (c(), O(Zl, {
              itemId: _e.itemId,
              itemLabel: _e.text,
              "mega-nav-columns": _e.megaNavColumns,
              key: _e.text
            }, null, 8, ["itemId", "itemLabel", "mega-nav-columns"]))), 128)),
            (c(!0), w(ne, null, ue(F.value, (_e) => (c(), O(ui, {
              item: _e,
              key: _e.text
            }, null, 8, ["item"]))), 128)),
            k.value ? (c(), O(hi, {
              key: 0,
              itemLabel: ((Je = C.value) == null ? void 0 : Je.text) ?? "",
              navItems: y.value ?? []
            }, null, 8, ["itemLabel", "navItems"])) : P("", !0),
            z(bi, null, {
              default: H(() => [
                se(Q.$slots, "searchDesktop")
              ]),
              _: 3
            })
          ], 512), [
            [pe, s.value]
          ])
        ], 38),
        (c(), O(aa, { to: "body" }, [
          ve(M("div", {
            onClick: _,
            class: "ds-header-backdrop"
          }, null, 512), [
            [pe, s.value]
          ])
        ]))
      ], 64);
    };
  }
}), Li = { class: "ds-header-mobile__bar" }, Ci = {
  key: 0,
  class: "ds-header-mobile__logo"
}, Mi = {
  key: 1,
  class: "ds-header-mobile__title-bar"
}, Ei = { class: "ds-header-mobile__icons" }, Ni = /* @__PURE__ */ q({
  __name: "ds-header-mobile-bar",
  props: {
    isTopLevel: { type: Boolean },
    logo: {},
    enableSearch: { type: Boolean },
    enableBasket: { type: Boolean },
    basketCount: {},
    basketFn: { type: Function },
    onSearchClick: { type: Function },
    onToggleClick: { type: Function },
    onBackClick: { type: Function },
    labels: {},
    menuState: {},
    menuButtonLabel: {}
  },
  setup(n) {
    return (e, t) => {
      var a, r, s;
      return c(), w("div", Li, [
        e.isTopLevel ? (c(), w("div", Ci, [
          z(Ta, me(e.logo, { size: "sm" }), null, 16)
        ])) : (c(), w("div", Mi, [
          z(he, {
            ariaLabel: ((a = e.labels) == null ? void 0 : a.mobileMenuBackButtonLabel) ?? "Back",
            "click-handler": e.onBackClick,
            variant: "secondary-neutral",
            size: "md",
            iconName: "button-chevron-left"
          }, null, 8, ["ariaLabel", "click-handler"])
        ])),
        M("div", Ei, [
          e.enableSearch && e.isTopLevel ? (c(), O(he, {
            key: 0,
            class: "ds-header-mobile__icon-button",
            "click-handler": e.onSearchClick,
            ariaLabel: ((r = e.labels) == null ? void 0 : r.searchButtonLabel) ?? "Search",
            "data-testid": "searchButton",
            iconName: "button-search",
            variant: "ghost-neutral"
          }, null, 8, ["click-handler", "ariaLabel"])) : P("", !0),
          e.enableBasket && e.isTopLevel ? (c(), O(he, {
            key: 1,
            class: "ds-header-mobile__icon-button",
            ariaLabel: ((s = e.labels) == null ? void 0 : s.basketButtonLabel) ?? "Basket",
            clickHandler: e.basketFn,
            iconName: "button-shopping-basket",
            "notification-count": e.basketCount,
            variant: "ghost-neutral"
          }, null, 8, ["ariaLabel", "clickHandler", "notification-count"])) : P("", !0),
          z(he, {
            class: "ds-header-mobile__toggle",
            "click-handler": e.onToggleClick,
            ariaLabel: e.menuButtonLabel,
            iconName: e.menuState === "open" || e.menuState === "search" ? "button-close" : "button-menu",
            variant: "ghost-neutral"
          }, null, 8, ["click-handler", "ariaLabel", "iconName"])
        ])
      ]);
    };
  }
}), Ai = ["aria-label"], xi = { class: "ds-nav-mobile-item__label" }, Bi = ["href", "target"], Oi = { class: "ds-nav-mobile-item__label" }, Di = {
  key: 2,
  class: "ds-nav-mobile-item ds-nav-mobile-item--section"
}, Fi = { class: "ds-nav-mobile-item__label" }, Hi = 3, rt = /* @__PURE__ */ q({
  __name: "ds-nav-mobile-item",
  props: {
    isSectionPage: { type: Boolean, default: !1 },
    level: {},
    navItem: {}
  },
  setup(n) {
    const e = n, t = ee("labels", {}), a = t.submenuLabel ? t.submenuLabel : "submenu", r = b(() => e.navItem && "linkUrl" in e.navItem && e.navItem.linkUrl !== null && typeof e.navItem.linkUrl < "u"), s = b(() => !!("linkIsExternal" in e.navItem && e.navItem.linkIsExternal)), i = b(() => r.value ? e.isSectionPage ? !0 : !(!e.isSectionPage && o.value) : !1), o = b(() => {
      var d;
      return !!("children" in e.navItem && ((d = e.navItem.children) != null && d.length));
    }), u = b(() => {
      var d;
      return !!("megaNavColumns" in e.navItem && ((d = e.navItem) != null && d.megaNavColumns.length));
    }), l = b(() => u.value || o.value && e.level < Hi), f = ee("navigateLevel", (d, m = 0) => {
      console.warn("navigateLevel not implemented", { navItem: d, level: m });
    }), v = b(() => e.isSectionPage && e.navItem.mobilePageLabel && e.navItem.mobilePageLabel || e.navItem.text);
    return (d, m) => d.navItem && l.value && !d.isSectionPage ? (c(), w("button", {
      key: 0,
      "aria-label": `${d.navItem.text} ${S(a)}`,
      class: "ds-nav-mobile-item",
      onClick: m[0] || (m[0] = (p) => S(f)(d.navItem, d.level + 1))
    }, [
      M("span", xi, [
        d.navItem.iconName ? (c(), O(ae, {
          key: 0,
          class: "ds-nav-mobile-item__icon",
          size: "lg",
          iconName: d.navItem.iconName
        }, null, 8, ["iconName"])) : P("", !0),
        d.navItem.initials ? (c(), O(Y, {
          key: 1,
          class: "ds-nav-mobile-item__initials",
          "html-element": "span",
          "text-style": "medium",
          "text-type": "label-sm"
        }, {
          default: H(() => [
            K(W(d.navItem.initials), 1)
          ]),
          _: 1
        })) : P("", !0),
        z(Y, {
          "text-type": "label-lg",
          "text-style": "medium",
          "html-element": "span"
        }, {
          default: H(() => [
            K(W(d.navItem.text), 1)
          ]),
          _: 1
        })
      ]),
      l.value ? (c(), O(ae, {
        key: 0,
        class: "ds-nav-mobile-item__chevron",
        size: "md",
        iconName: "chevron-right"
      })) : P("", !0)
    ], 8, Ai)) : d.navItem && "linkUrl" in d.navItem && i.value ? (c(), w("a", {
      key: 1,
      class: U(["ds-nav-mobile-item", d.isSectionPage ? "ds-nav-mobile-item--section" : null]),
      href: d.navItem.linkUrl,
      target: d.navItem.linkTarget
    }, [
      M("span", Oi, [
        d.navItem.iconName ? (c(), O(ae, {
          key: 0,
          class: "ds-nav-mobile-item__icon",
          size: "lg",
          iconName: d.navItem.iconName
        }, null, 8, ["iconName"])) : P("", !0),
        d.navItem.initials && !d.isSectionPage ? (c(), O(Y, {
          key: 1,
          class: "ds-nav-mobile-item__initials",
          "html-element": "span",
          "text-style": "medium",
          "text-type": "label-sm"
        }, {
          default: H(() => [
            K(W(d.navItem.initials), 1)
          ]),
          _: 1
        })) : P("", !0),
        z(Y, {
          "text-type": "label-lg",
          "text-style": "medium",
          "html-element": "span"
        }, {
          default: H(() => [
            K(W(v.value), 1)
          ]),
          _: 1
        }),
        !d.isSectionPage && s.value ? (c(), O(ae, {
          key: 2,
          class: "ds-nav-mobile-item__external",
          "icon-name": "button-external-link",
          size: "md"
        })) : P("", !0),
        d.isSectionPage ? (c(), O(ae, {
          key: 3,
          class: "ds-nav-mobile-item__navigate",
          "icon-name": "button-navigate-forward",
          size: "md"
        })) : P("", !0)
      ])
    ], 10, Bi)) : d.navItem && d.isSectionPage ? (c(), w("div", Di, [
      M("span", Fi, [
        d.navItem.iconName ? (c(), O(ae, {
          key: 0,
          class: "ds-nav-mobile-item__icon",
          size: "lg",
          iconName: d.navItem.iconName
        }, null, 8, ["iconName"])) : P("", !0),
        z(Y, {
          "text-type": "label-lg",
          "text-style": "medium",
          "html-element": "span"
        }, {
          default: H(() => [
            K(W(v.value), 1)
          ]),
          _: 1
        })
      ])
    ])) : P("", !0);
  }
}), zi = /* @__PURE__ */ M("div", { class: "ds-nav-mobile__title-bar" }, null, -1), Ri = ["aria-label"], Vi = { class: "ds-nav-mobile__group" }, qi = {
  key: 2,
  class: "ds-nav-mobile__cards"
}, Zt = /* @__PURE__ */ q({
  __name: "ds-nav-mobile-level",
  props: {
    activeParent: {},
    level: {}
  },
  setup(n) {
    const e = n, t = ["link", "dropdown", "service", "drilldown"], a = (o) => {
      var u;
      return !!o && t.includes(o.type) && "children" in o && !!((u = o.children) != null && u.length);
    }, r = b(() => a(e.activeParent) ? e.activeParent : null), s = b(() => r.value !== null && "titleBlock" in r.value && typeof r.value.titleBlock < "u" && r.value.titleBlock !== null), i = b(() => {
      var o, u;
      if (s.value) {
        const l = r.value;
        return {
          itemId: `${l.itemId}-title`,
          linkUrl: ((o = l.titleBlock) == null ? void 0 : o.content.linkUrl) ?? "#",
          text: ((u = l.titleBlock) == null ? void 0 : u.content.linkText) ?? "",
          type: "link"
        };
      }
      return null;
    });
    return (o, u) => (c(), O(Ue, { name: "persist" }, {
      default: H(() => {
        var l;
        return [
          o.activeParent ? (c(), w("div", {
            key: 0,
            class: U(`ds-nav-mobile__level ds-nav-mobile__level${o.level}`)
          }, [
            zi,
            a(o.activeParent) ? (c(), w("section", {
              key: 0,
              "aria-label": o.activeParent.text,
              class: "ds-nav-mobile__nav"
            }, [
              i.value ? (c(), O(rt, {
                key: 0,
                level: o.level,
                navItem: i.value,
                "is-section-page": !0
              }, null, 8, ["level", "navItem"])) : r.value !== null ? (c(), O(rt, {
                key: 1,
                level: o.level,
                navItem: r.value,
                "is-section-page": !0
              }, null, 8, ["level", "navItem"])) : P("", !0),
              M("div", Vi, [
                (c(!0), w(ne, null, ue(o.activeParent.children, (f) => (c(), O(rt, {
                  key: f.text,
                  level: o.level,
                  navItem: f
                }, null, 8, ["level", "navItem"]))), 128))
              ]),
              "cards" in o.activeParent ? (c(), w("div", qi, [
                (c(!0), w(ne, null, ue((l = o.activeParent.cards) == null ? void 0 : l.slice(0, 2), (f) => (c(), O(zt, me(f, {
                  key: f.title
                }), null, 16))), 128))
              ])) : P("", !0)
            ], 8, Ri)) : P("", !0)
          ], 2)) : P("", !0)
        ];
      }),
      _: 1
    }));
  }
}), ji = {
  key: 0,
  class: "ds-nav-mobile-service"
}, Wi = /* @__PURE__ */ q({
  __name: "ds-nav-mobile-service",
  setup(n) {
    const e = ee("loggedIn", !1), t = ee("countrySelector"), a = ee("ctaButtons"), r = ee("serviceNavItems", []), s = a && a.myAccountButtonNavItem ? {
      ...a.myAccountButtonNavItem,
      type: "service"
    } : null, i = b(
      () => {
        var o;
        if (t && "countryList" in t && "headline" in t)
          return {
            iconName: "globe",
            itemId: "select-country",
            children: (o = t == null ? void 0 : t.countryList) == null ? void 0 : o.map(
              (u, l) => ({
                itemId: u.language || `country-${l}`,
                linkUrl: u.url,
                text: u.name,
                type: "service"
              })
            ),
            text: t == null ? void 0 : t.headline,
            type: "service"
          };
      }
    );
    return (o, u) => {
      var l;
      return S(e) || S(r) && ((l = S(r)) != null && l.length) || i.value ? (c(), w("div", ji, [
        S(e) && S(a) && S(s) ? (c(), O(rt, {
          key: 0,
          level: 0,
          navItem: S(s)
        }, null, 8, ["navItem"])) : P("", !0),
        i.value ? (c(), O(rt, {
          key: 1,
          level: 0,
          navItem: i.value
        }, null, 8, ["navItem"])) : P("", !0),
        (c(!0), w(ne, null, ue(S(r), (f) => (c(), O(rt, {
          level: 0,
          key: f == null ? void 0 : f.text,
          navItem: f
        }, null, 8, ["navItem"]))), 128))
      ])) : P("", !0);
    };
  }
}), Ui = { class: "ds-nav-mobile" }, Ki = ["inert"], Gi = { class: "ds-nav-mobile__nav" }, Yi = { class: "ds-nav-mobile__group" }, Qi = { class: "ds-nav-mobile__service" }, Xi = {
  key: 0,
  class: "ds-nav-mobile__cta"
}, Zi = /* @__PURE__ */ q({
  __name: "ds-nav-mobile",
  props: {
    navItems: {}
  },
  setup(n) {
    const e = I(null), t = ee("mobileMenuLevel", I(0)), a = ee("activeItems", I([])), r = ee("ctaButtons"), s = ee("loggedIn", !1), i = b(
      () => (r == null ? void 0 : r.loginButtonLabel) || (r == null ? void 0 : r.logoutButtonLabel) || !1
    );
    return le(a.value, () => {
      e.value && e.value.scrollTo(0, 0);
    }), (o, u) => (c(), w("div", Ui, [
      M("div", {
        class: "ds-nav-mobile__scroll",
        ref_key: "scroll",
        ref: e
      }, [
        M("div", {
          class: U(["ds-nav-mobile__levels", `ds-nav-mobile__levels--level${S(t)}`])
        }, [
          M("div", {
            class: "ds-nav-mobile__level ds-nav-mobile__level0",
            inert: S(t) !== 0 ? "true" : void 0
          }, [
            M("div", Gi, [
              M("div", Yi, [
                (c(!0), w(ne, null, ue(o.navItems, (l) => (c(), O(rt, {
                  level: 0,
                  key: l.text,
                  navItem: l
                }, null, 8, ["navItem"]))), 128))
              ])
            ]),
            M("div", Qi, [
              z(Wi)
            ])
          ], 8, Ki),
          z(Zt, {
            activeParent: S(a)[0],
            inert: S(t) !== 1 ? "true" : void 0,
            level: 1
          }, null, 8, ["activeParent", "inert"]),
          z(Zt, {
            activeParent: S(a)[1],
            inert: S(t) !== 2 ? "true" : void 0,
            level: 2
          }, null, 8, ["activeParent", "inert"]),
          z(Zt, {
            activeParent: S(a)[2],
            inert: S(t) !== 3 ? "true" : void 0,
            level: 3
          }, null, 8, ["activeParent", "inert"])
        ], 2)
      ], 512),
      i.value && S(r) ? (c(), w("div", Xi, [
        z(ba, null, {
          default: H(() => [
            !S(s) && S(r).loginButtonLabel ? (c(), O(be, {
              key: 0,
              "click-handler": S(r).loginButtonFn,
              href: S(r).loginButtonLink,
              variant: "primary"
            }, {
              default: H(() => [
                K(W(S(r).loginButtonLabel), 1)
              ]),
              _: 1
            }, 8, ["click-handler", "href"])) : P("", !0),
            S(s) && S(r).logoutButtonLabel ? (c(), O(be, {
              key: 1,
              "click-handler": S(r).logoutButtonFn,
              href: S(r).logoutButtonLink,
              variant: "secondary"
            }, {
              default: H(() => [
                K(W(S(r).logoutButtonLabel), 1)
              ]),
              _: 1
            }, 8, ["click-handler", "href"])) : P("", !0)
          ]),
          _: 1
        })
      ])) : P("", !0)
    ]));
  }
}), Ji = (n, e) => n.flatMap(
  (t) => t.type === "linkList" ? [
    {
      itemId: `${e}-${t.content.categoryTitle}`,
      text: t.content.categoryTitle,
      linkUrl: void 0,
      type: "link",
      children: t.content.links.map((a) => ({
        itemId: `${e}-${a.linkText}`,
        linkUrl: a.linkUrl,
        linkIsExternal: a.linkIsExternal,
        linkTarget: a.linkTarget,
        text: a.linkText,
        type: "link"
      }))
    }
  ] : []
), eu = (n) => (n == null ? void 0 : n.content.cards) ?? [], La = (n) => {
  const e = Ji(n.megaNavColumns, n.itemId), t = n.megaNavColumns.find(
    (r) => r.type === "titleBlock"
  ), a = n.megaNavColumns.find(
    (r) => r.type === "promo"
  );
  return {
    itemId: n.itemId,
    text: n.text,
    type: "drilldown",
    mobilePageLabel: "mobilePageLabel" in n ? n.mobilePageLabel : void 0,
    children: e,
    titleBlock: t,
    cards: eu(a)
  };
}, tu = (n) => La(n), nu = (n) => La(n), au = ["aria-label", "role"], ru = {
  key: 0,
  class: "ds-header-mobile__nav"
}, su = { class: "ds-header-mobile__search" }, ou = /* @__PURE__ */ q({
  __name: "ds-header-mobile",
  props: {
    basketCount: {},
    basketFn: {},
    countrySelector: {},
    enableBasket: { type: Boolean },
    enableSearch: { type: Boolean },
    enableSticky: { type: Boolean, default: !0 },
    inertTargetSelector: {},
    navItems: {},
    searchFn: {}
  },
  setup(n) {
    const e = n, t = ee("logo", {
      href: "/",
      altText: "Coloplast",
      imageSrc: "",
      clickHandler: () => {
      }
    }), a = I(null), r = I(!1), s = I("closed"), { dynamicClasses: i, headerHeight: o } = Pa(
      {
        enableSticky: e.enableSticky
      },
      a,
      I(null),
      "ds-header-mobile"
    ), u = b(() => s.value !== "closed" ? "dialog" : void 0), l = b(() => `--header-height: ${o.value};`), f = b(() => s.value === "open" ? (g == null ? void 0 : g.mobileMenuButtonCloseLabel) ?? "Close menu" : (g == null ? void 0 : g.mobileMenuButtonOpenLabel) ?? "Open menu"), v = b(() => {
      const y = [];
      s.value === "open" && y.push("ds-header-mobile--open"), s.value === "search" && y.push("ds-header-mobile--search");
      for (const N of i.value)
        y.push(N);
      return y;
    }), d = b(() => e.navItems.map((y) => {
      var F;
      const N = { ...y };
      return N.type === "mega" ? tu(N) : (N.type === "link" && ((F = N.children) != null && F.some((G) => G.type === "secondary")) && (N.children = N.children.map((G) => G.type === "secondary" ? nu(
        G
      ) : G)), N);
    })), m = async (y) => {
      if (y.key === "Escape" && (s.value = "closed", x(), a.value)) {
        const N = a.value.querySelector(
          ".ds-header-mobile__toggle"
        );
        N && (await Qe(), N.focus());
      }
    }, p = () => {
      s.value !== "search" ? (s.value = "search", e.searchFn && e.searchFn(!0)) : s.value === "search" && (s.value = "closed", e.searchFn && e.searchFn(!1));
    }, L = () => {
      s.value === "closed" ? s.value = "open" : (s.value === "open" || s.value === "search") && (s.value = "closed"), x();
    }, x = () => {
      E.value = 0, D.value = [];
    }, D = I([]), E = I(0), T = (y, N = 0) => {
      D.value.length < N && y ? D.value.push(y) : D.value.pop(), E.value = N;
    }, g = ee("labels", {}), C = g.mobileMenuLabel ? g.mobileMenuLabel : "Mobile menu";
    fe("navigateLevel", T), fe("mobileMenuLevel", E), fe("activeItems", D), fe("countrySelector", e.countrySelector);
    const $ = () => {
      var y, N, F;
      (y = a.value) != null && y.parentElement && ((F = (N = a.value) == null ? void 0 : N.parentElement) == null ? void 0 : F.getAttribute("data-sticky-mount")) === "true" && (r.value = !0);
    }, k = (y) => {
      const N = document.querySelectorAll(
        e.inertTargetSelector
      );
      y ? N.forEach((F) => {
        F.setAttribute("inert", "true");
      }) : N.forEach((F) => {
        F.removeAttribute("inert");
      });
    };
    return de(() => {
      $();
    }), Ve(() => {
      document.documentElement.classList.remove("ds-nav-open"), k(!1);
    }), le(s, (y) => {
      y === "open" || y === "search" ? (document.documentElement.classList.add("ds-nav-open"), k(!0)) : (document.documentElement.classList.remove("ds-nav-open"), k(!1));
    }), le(l, (y) => {
      r.value && a.value && a.value.parentElement && a.value.parentElement.setAttribute("style", y);
    }), (y, N) => (c(), w("header", {
      "aria-label": S(C),
      class: U(["ds-header-mobile", v.value]),
      role: u.value,
      ref_key: "header",
      ref: a,
      style: ge(l.value),
      onKeydown: m
    }, [
      z(Ni, {
        isTopLevel: E.value === 0,
        logo: S(t),
        enableSearch: y.enableSearch,
        enableBasket: y.enableBasket,
        basketCount: y.basketCount,
        basketFn: y.basketFn,
        onSearchClick: p,
        onToggleClick: L,
        onBackClick: () => T(null, E.value - 1),
        labels: S(g),
        menuState: s.value,
        menuButtonLabel: f.value
      }, null, 8, ["isTopLevel", "logo", "enableSearch", "enableBasket", "basketCount", "basketFn", "onBackClick", "labels", "menuState", "menuButtonLabel"]),
      s.value === "open" ? (c(), w("div", ru, [
        z(Zi, { navItems: d.value }, null, 8, ["navItems"])
      ])) : P("", !0),
      ve(M("div", su, [
        se(y.$slots, "searchMobile")
      ], 512), [
        [pe, s.value === "search"]
      ])
    ], 46, au));
  }
}), bd = /* @__PURE__ */ q({
  __name: "ds-header",
  props: {
    basketCount: { default: 0 },
    basketFn: {},
    ctaButtons: {},
    enableBasket: { type: Boolean, default: !0 },
    enableSearch: { type: Boolean, default: !0 },
    enableSticky: { type: Boolean, default: !0 },
    inertTargetSelector: { default: "body > main" },
    labels: {},
    logo: {},
    loggedIn: { type: Boolean, default: !1 },
    navItems: {},
    searchFn: {},
    serviceNavItems: {},
    countrySelector: {}
  },
  setup(n) {
    const e = n, t = I(!1);
    de(() => {
      t.value = !0;
    }), fe("ctaButtons", e.ctaButtons), fe("labels", e.labels), fe("loggedIn", e.loggedIn), fe("serviceNavItems", e.serviceNavItems), fe("logo", e.logo);
    const { isMobile: a } = Ie();
    return (r, s) => (c(), w(ne, null, [
      !S(a) && t.value ? (c(), O(Pi, {
        key: 0,
        "basket-count": r.basketCount,
        "basket-fn": r.basketFn,
        "enable-basket": r.enableBasket,
        "enable-search": r.enableSearch,
        "enable-sticky": r.enableSticky,
        "nav-items": r.navItems,
        "search-fn": r.searchFn
      }, {
        searchDesktop: H(() => [
          se(r.$slots, "searchDesktop")
        ]),
        _: 3
      }, 8, ["basket-count", "basket-fn", "enable-basket", "enable-search", "enable-sticky", "nav-items", "search-fn"])) : P("", !0),
      S(a) && t.value ? (c(), O(ou, {
        key: 1,
        "basket-count": r.basketCount,
        "basket-fn": r.basketFn,
        "country-selector": r.countrySelector,
        "enable-basket": r.enableBasket,
        "enable-search": r.enableSearch,
        "inert-target-selector": r.inertTargetSelector,
        "nav-items": r.navItems,
        "search-fn": r.searchFn
      }, {
        searchMobile: H(() => [
          se(r.$slots, "searchMobile")
        ]),
        _: 3
      }, 8, ["basket-count", "basket-fn", "country-selector", "enable-basket", "enable-search", "inert-target-selector", "nav-items", "search-fn"])) : P("", !0),
      t.value ? P("", !0) : se(r.$slots, "default", { key: 2 })
    ], 64));
  }
}), lu = { class: "ds-underscore" }, iu = /* @__PURE__ */ q({
  __name: "ds-underscore",
  setup(n) {
    return (e, t) => (c(), w("span", lu));
  }
}), uu = ["innerHTML"], yd = /* @__PURE__ */ q({
  __name: "ds-page-header",
  props: {
    title: {},
    text: {}
  },
  setup(n) {
    return (e, t) => (c(), O(qt, {
      "padding-bottom": "close",
      class: "ds-page-header"
    }, {
      default: H(() => [
        z(Y, {
          class: "ds-page-header__title",
          "text-style": "medium",
          "text-type": "heading-8xl",
          "html-element": "h1"
        }, {
          default: H(() => [
            K(W(e.title), 1),
            z(iu)
          ]),
          _: 1
        }),
        e.text ? (c(), O(Y, {
          key: 0,
          class: "ds-page-header__text",
          "text-type": "heading-xl"
        }, {
          default: H(() => [
            M("span", { innerHTML: e.text }, null, 8, uu)
          ]),
          _: 1
        })) : P("", !0)
      ]),
      _: 1
    }));
  }
}), cu = {
  key: 0,
  class: "ds-pagination"
}, du = ["aria-label"], fu = { class: "ds-pagination__list" }, mu = { class: "ds-visually-hidden" }, vu = {
  key: 1,
  class: "ds-pagination__truncator"
}, lt = 1, pu = 2, Wn = "...", _d = /* @__PURE__ */ q({
  __name: "ds-pagination",
  props: {
    currentPage: { default: 1 },
    pageSize: { default: 10 },
    totalResults: {},
    labelNext: { default: "Next" },
    labelPage: { default: "page" },
    labelPagination: { default: "Pagination" },
    labelPrevious: { default: "Previous" },
    labelResults: { default: "{startRange} - {endRange} of {total} results" },
    navigationHandler: { type: Function, default: void 0 },
    navigationPreventDefault: { type: Boolean, default: !0 },
    urlStructure: { default: window.location.pathname + "?page={page}" }
  },
  setup(n) {
    const e = n;
    if (typeof e.totalResults != "number" || typeof e.pageSize != "number" || typeof e.currentPage != "number")
      throw new Error(
        "Ensure you're using number type values for totalResults, pageSize and currentPage"
      );
    const t = ($) => {
      e.navigationPreventDefault && $.preventDefault();
    }, a = ($) => $ > 0 && $ <= L.value, r = ($, k) => {
      if (t($), a(k)) {
        if (e.navigationHandler)
          try {
            e.navigationHandler(k);
          } catch (y) {
            console.error(y, "Error calling navigationHandler");
            return;
          }
        u.value = k;
      }
    }, s = ($) => {
      r($, l.value - 1);
    }, i = ($) => {
      r($, l.value + 1);
    };
    let o = !1;
    const u = I(e.currentPage);
    le(
      () => e.currentPage,
      ($) => {
        u.value = $;
      },
      { immediate: !0 }
    );
    const l = b(() => u.value < lt ? lt : u.value > L.value ? L.value : u.value), f = b(() => l.value > lt ? l.value - 1 : lt), v = b(() => l.value < L.value ? l.value + 1 : L.value), d = b(
      () => e.pageSize * (l.value - 1) + 1
    ), m = b(
      () => e.pageSize * l.value < e.totalResults ? e.pageSize * l.value : e.totalResults
    ), p = b(
      () => `${e.labelResults.replace("{startRange}", d.value.toString()).replace("{endRange}", m.value.toString()).replace("{total}", e.totalResults.toString())}`
    ), L = b(() => Math.ceil(e.totalResults / e.pageSize));
    let x = b(() => D.value ? 5 : 9);
    const { isMobile: D } = Ie(), E = ($, k, y, N, F) => {
      for (F = Number(Math.min(F, N)); $.length < F; ) {
        const G = k - y, h = k + y;
        G >= lt && $.unshift(G), h <= N && $.length < F && $.push(h), y++;
      }
      return $;
    }, T = ($, k, y) => {
      if (k < y) return $;
      const N = [...$];
      return N[0] = lt, N[N.length - 1] = k, N[1] !== pu && (N[1] = Wn), N[N.length - 2] !== k - 1 && (N[N.length - 2] = Wn), N;
    }, g = ($, k, y) => T(
      E(
        [$],
        $,
        1,
        k,
        y
      ),
      k,
      y
    ), C = b(() => g(
      l.value,
      L.value,
      x.value
    ));
    return o = !0, ($, k) => $.totalResults && L.value > 1 ? (c(), w("div", cu, [
      S(o) ? P("", !0) : se($.$slots, "default", { key: 0 }),
      S(o) ? (c(), w("nav", {
        key: 1,
        "aria-label": $.labelPagination,
        class: "ds-pagination__nav"
      }, [
        z(S(he), {
          iconName: "button-chevron-left",
          ariaLabel: $.labelPrevious,
          clickHandler: s,
          disabled: l.value === 1,
          href: $.urlStructure.replace(
            "{page}",
            f.value.toString()
          ),
          size: "sm",
          variant: "secondary"
        }, null, 8, ["ariaLabel", "disabled", "href"]),
        M("ul", fu, [
          (c(!0), w(ne, null, ue(C.value, (y, N) => (c(), w("li", {
            key: typeof y == "number" ? y : `trunc-${N}`
          }, [
            typeof y == "number" ? (c(), O(S(be), {
              key: 0,
              class: "ds-pagination__num",
              "aria-current": y === l.value ? !0 : null,
              padding: "padding-compact",
              selected: y === l.value,
              href: $.urlStructure.replace("{page}", y.toString()),
              onClick: (F) => r(F, y),
              variant: "link"
            }, {
              default: H(() => [
                M("span", mu, W($.labelPage), 1),
                K(" " + W(y), 1)
              ]),
              _: 2
            }, 1032, ["aria-current", "selected", "href", "onClick"])) : P("", !0),
            y === "..." ? (c(), w("div", vu, " … ")) : P("", !0)
          ]))), 128))
        ]),
        z(S(he), {
          iconName: "button-chevron-right",
          ariaLabel: $.labelNext,
          clickHandler: i,
          disabled: l.value === L.value,
          href: $.urlStructure.replace("{page}", v.value.toString()),
          size: "sm",
          variant: "secondary"
        }, null, 8, ["ariaLabel", "disabled", "href"])
      ], 8, du)) : P("", !0),
      z(S(Y), {
        "aria-live": "polite",
        "html-element": "div",
        textType: "label-sm",
        class: "ds-pagination__results"
      }, {
        default: H(() => [
          K(W(p.value), 1)
        ]),
        _: 1
      })
    ])) : P("", !0);
  }
}), hu = {
  key: 0,
  class: "ds-progress-dots",
  "aria-hidden": "true"
}, kd = /* @__PURE__ */ q({
  __name: "ds-progress-dots",
  props: {
    numberOfItems: {},
    activeIndex: { default: 0 }
  },
  setup(n) {
    return (e, t) => e.numberOfItems > 1 ? (c(), w("div", hu, [
      (c(!0), w(ne, null, ue(e.numberOfItems, (a, r) => (c(), w("div", {
        key: r,
        class: U([
          "ds-progress-dots__dot",
          e.activeIndex === r ? "ds-progress-dots__dot--active" : void 0
        ])
      }, null, 2))), 128))
    ])) : P("", !0);
  }
}), gu = ["aria-label", "disabled"], bu = ["min", "max", "disabled", "aria-label", "value", "id"], yu = ["aria-label", "disabled"], wd = /* @__PURE__ */ q({
  __name: "ds-quantity-selector",
  props: {
    background: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    outline: { type: Boolean, default: !0 },
    min: { default: 0 },
    max: { default: 99 },
    debounceDuration: { default: 200 },
    modelValue: {},
    id: {},
    ariaLabelInput: {},
    ariaLabelDecreaseQuantity: {},
    ariaLabelIncreaseQuantity: {}
  },
  emits: ["update:modelValue", "change"],
  setup(n, { emit: e }) {
    const t = n, a = e, r = I(null), s = b(() => ({
      "ds-quantity-selector": !0,
      "ds-quantity-selector--background": t.background,
      "ds-quantity-selector--disabled": t.disabled,
      "ds-quantity-selector--outline": t.outline
    })), i = () => {
      f(t.modelValue - 1);
    }, o = () => {
      f(t.modelValue + 1);
    }, u = (v) => {
      const d = v.target, m = Number(d.value.replace(/\D/g, "")), p = parseInt(m.toString(), 10);
      f(p);
    }, l = yn((v) => {
      a("change", v);
    }, t.debounceDuration), f = (v) => {
      const d = Math.max(
        t.min,
        Math.min(t.max, v || t.min)
      );
      r.value !== null && d !== v && (r.value.value = `${d}`), a("update:modelValue", d), l(d);
    };
    return (v, d) => (c(), w("div", {
      class: U(s.value)
    }, [
      M("button", {
        "aria-label": v.ariaLabelDecreaseQuantity,
        class: "ds-quantity-selector__button ds-quantity-selector__button--decrease",
        disabled: v.modelValue <= v.min || v.disabled,
        type: "button",
        onClick: We(i, ["prevent"])
      }, [
        z(S(ae), { "icon-name": "subtract" })
      ], 8, gu),
      M("input", {
        min: v.min,
        max: v.max,
        step: "1",
        class: "ds-quantity-selector__input",
        disabled: v.disabled,
        onInput: u,
        "aria-label": v.ariaLabelInput,
        "aria-live": "polite",
        type: "number",
        autocomplete: "off",
        value: v.modelValue,
        ref_key: "inputEl",
        ref: r,
        id: v.id
      }, null, 40, bu),
      M("button", {
        "aria-label": v.ariaLabelIncreaseQuantity,
        class: "ds-quantity-selector__button ds-quantity-selector__button--increase",
        disabled: v.modelValue >= v.max || v.disabled,
        type: "button",
        onClick: We(o, ["prevent"])
      }, [
        z(S(ae), { "icon-name": "add" })
      ], 8, yu)
    ], 2));
  }
}), _u = {
  class: "ds-scroll-progress-bar",
  "aria-hidden": "true"
}, $d = /* @__PURE__ */ q({
  __name: "ds-scroll-progress-bar",
  props: {
    scrollContainerRef: {}
  },
  setup(n) {
    const e = n, t = I(0), a = I(0), r = I(0), s = b(
      () => r.value / a.value
    );
    let i = new ResizeObserver(() => {
      o(), u();
    });
    const o = () => {
      var d, m;
      a.value = ((d = e.scrollContainerRef) == null ? void 0 : d.scrollWidth) ?? 0, r.value = ((m = e.scrollContainerRef) == null ? void 0 : m.clientWidth) ?? 0;
    }, u = () => {
      e.scrollContainerRef && (t.value = Math.abs(e.scrollContainerRef.scrollLeft) ?? 0);
    }, l = wa(
      () => {
        u();
      },
      100,
      !0
    );
    le(
      () => e.scrollContainerRef,
      (d, m) => {
        m && m.removeEventListener("scroll", () => {
          l();
        }), d && (i.observe(d), d.addEventListener(
          "scroll",
          () => {
            l();
          },
          {
            passive: !0
          }
        ));
      },
      { immediate: !0 }
    ), Ve(() => {
      e.scrollContainerRef && e.scrollContainerRef.removeEventListener("scroll", () => {
        l();
      });
    });
    const f = b(() => {
      if (!e.scrollContainerRef || s.value === 1) return 0;
      let d = Math.min(
        t.value / a.value + s.value,
        1
      );
      return d > 0.98 ? 1 : d;
    }), v = b(() => ({
      "--progress-scale-factor": f.value.toString()
    }));
    return (d, m) => (c(), w("div", _u, [
      M("div", {
        style: ge(v.value),
        class: "ds-scroll-progress-bar__bar"
      }, null, 4)
    ]));
  }
}), ku = ["aria-hidden", "aria-live", "aria-label"], wu = {
  class: "ds-spinner__content",
  "aria-hidden": "true"
}, $u = ["innerHTML"], Id = /* @__PURE__ */ q({
  __name: "ds-spinner",
  props: {
    accessibilityLabel: { default: "Loading" },
    accessibilityLabelCompleted: { default: "Completed" },
    displayMode: { default: "default" },
    label: { default: null },
    status: { default: "hidden" }
  },
  setup(n) {
    const e = n, t = I(null), a = b(() => e.status === "loading" ? e.label && e.label.trim() !== "" ? e.label : e.accessibilityLabel : e.status === "completed" ? e.accessibilityLabelCompleted : "");
    return (r, s) => (c(), w(ne, null, [
      M("output", {
        class: "ds-spinner-status",
        "aria-hidden": r.status === "hidden",
        "aria-live": r.status === "loading" ? "assertive" : "polite",
        "aria-label": a.value
      }, null, 8, ku),
      r.status === "loading" ? (c(), w("div", {
        key: 0,
        class: U(["ds-spinner", r.displayMode === "solid" ? "--solid" : null])
      }, [
        M("div", wu, [
          z(oa),
          r.label ? (c(), O(Y, {
            key: 0,
            "html-element": "p",
            "text-style": "medium",
            "text-type": "heading-md",
            class: "ds-spinner__label"
          }, {
            default: H(() => [
              M("span", {
                innerHTML: r.label,
                ref_key: "textLabel",
                ref: t
              }, null, 8, $u)
            ]),
            _: 1
          })) : P("", !0)
        ])
      ], 2)) : P("", !0)
    ], 64));
  }
}), Iu = (n) => /^[+-]?\d+(\.\d+)?$/.test(`${n}`), rn = (n) => Iu(n) ? `${n}px` : typeof n > "u" ? "auto" : n, Wt = /* @__PURE__ */ q({
  __name: "ds-skeleton-element",
  props: {
    additionalClasses: { default: "" },
    aspectRatio: {},
    height: {},
    width: {}
  },
  setup(n) {
    const e = n, t = b(() => {
      let a = {};
      return e.height && (a = {
        ...a,
        "--skeleton-height": `${rn(e.height)}`
      }), e.width && (a = {
        ...a,
        "--skeleton-width": `${rn(e.width)}`
      }), e.aspectRatio && (a = {
        ...a,
        "--skeleton-aspect-ratio": `${e.aspectRatio}`
      }), a;
    });
    return (a, r) => (c(), w("div", {
      class: U(["ds-skeleton-element", a.additionalClasses]),
      style: ge(t.value)
    }, null, 6));
  }
}), Td = /* @__PURE__ */ q({
  __name: "ds-skeleton-box",
  props: {
    additionalClasses: { default: "" },
    aspectRatio: {},
    height: {},
    presetHeight: {},
    width: {}
  },
  setup(n) {
    const e = n, t = () => {
      switch (e.presetHeight) {
        case "small":
          return 56;
        case "medium":
          return 88;
        case "large":
          return 124;
        case "full":
          return 215;
        default:
          return;
      }
    }, a = b(() => e.height ? e.height : t());
    return (r, s) => (c(), O(Wt, {
      class: U(["ds-skeleton-box", r.additionalClasses]),
      "additional-classes": r.additionalClasses,
      "aspect-ratio": r.aspectRatio,
      height: a.value,
      width: r.width
    }, null, 8, ["class", "additional-classes", "aspect-ratio", "height", "width"]));
  }
}), Sd = /* @__PURE__ */ q({
  __name: "ds-skeleton-button",
  props: {
    additionalClasses: { default: "" },
    height: {},
    presetHeight: {},
    width: {}
  },
  setup(n) {
    const e = n, t = () => {
      switch (e.presetHeight) {
        case "small":
        case "icon-small":
          return 34;
        case "medium":
        case "icon-medium":
          return 46;
        default:
          return;
      }
    }, a = b(() => {
      if (e.presetHeight === "icon-medium" || e.presetHeight === "icon-small")
        return 1;
    }), r = b(() => e.height ? e.height : t()), s = b(() => {
      if (e.width) return e.width;
      if (e.presetHeight === "icon-medium" || e.presetHeight === "icon-small")
        return "auto";
    });
    return (i, o) => (c(), O(Wt, {
      class: U(["ds-skeleton-button", i.additionalClasses]),
      "additional-classes": i.additionalClasses,
      "aspect-ratio": a.value,
      height: r.value,
      width: s.value
    }, null, 8, ["class", "additional-classes", "aspect-ratio", "height", "width"]));
  }
}), Pd = /* @__PURE__ */ q({
  __name: "ds-skeleton-circle",
  props: {
    additionalClasses: { default: "" },
    diameter: {},
    presetDiameter: {}
  },
  setup(n) {
    const e = n, t = () => {
      switch (e.presetDiameter) {
        case "small":
          return 24;
        case "medium":
          return 40;
        case "large":
          return 72;
        default:
          return;
      }
    }, a = b(() => e.diameter ? e.diameter : t());
    return (r, s) => (c(), O(Wt, {
      class: U(["ds-skeleton-circle", r.additionalClasses]),
      aspectRatio: 1,
      height: a.value,
      width: a.value
    }, null, 8, ["class", "height", "width"]));
  }
}), Ca = {
  elevation: "default",
  padding: "none"
}, Ma = /* @__PURE__ */ q({
  __name: "ds-surface",
  props: /* @__PURE__ */ ra({
    elevation: {},
    padding: {}
  }, {
    ...Ca
  }),
  setup(n) {
    const e = n, t = b(() => `ds-surface--${e.elevation}`), a = b(() => `ds-surface--pad-${e.padding}`);
    return (r, s) => (c(), w("div", {
      class: U(["ds-surface", [t.value, a.value]])
    }, [
      se(r.$slots, "default")
    ], 2));
  }
}), Ld = /* @__PURE__ */ q({
  __name: "ds-skeleton-surface",
  props: /* @__PURE__ */ ra({
    elevation: {},
    padding: {}
  }, {
    ...Ca
  }),
  setup(n) {
    const e = n;
    return (t, a) => (c(), O(Ma, me({ class: "ds-skeleton-surface" }, e), {
      default: H(() => [
        se(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Cd = /* @__PURE__ */ q({
  __name: "ds-skeleton-text-line",
  props: {
    additionalClasses: { default: "" },
    height: {},
    presetHeight: {},
    width: { default: "100%" }
  },
  setup(n) {
    const e = n, t = () => {
      switch (e.presetHeight) {
        case "small":
          return 12;
        case "medium":
          return 16;
        case "large":
          return 24;
        default:
          return;
      }
    }, a = b(() => e.height ? e.height : t());
    return (r, s) => (c(), O(Wt, {
      class: U(["ds-skeleton-text", r.additionalClasses]),
      "additional-classes": r.additionalClasses,
      height: a.value,
      width: r.width
    }, null, 8, ["class", "additional-classes", "height", "width"]));
  }
}), Md = /* @__PURE__ */ q({
  __name: "ds-skeleton-wrapper",
  setup(n) {
    var r;
    const e = I(null);
    let t = I((r = e == null ? void 0 : e.value) == null ? void 0 : r.offsetWidth);
    Ht(e, (s) => {
      const i = s[0];
      t.value = i.contentRect.width;
    });
    const a = b(() => typeof t.value < "u" ? {
      "--skeleton-container-width": `${rn(t.value)}`
    } : {});
    return (s, i) => (c(), w("div", {
      class: "ds-skeleton",
      style: ge(a.value),
      "data-testid": "skeleton",
      ref_key: "container",
      ref: e,
      "aria-hidden": "true"
    }, [
      se(s.$slots, "default")
    ], 4));
  }
}), Tu = ["innerHTML"], Su = ["innerHTML"], Pu = /* @__PURE__ */ q({
  __name: "ds-fact",
  props: {
    brandIconName: {},
    stat: {},
    text: {},
    variant: { default: "default" }
  },
  setup(n) {
    return (e, t) => (c(), w("article", {
      class: U(["ds-fact", `ds-fact--${e.variant}`])
    }, [
      e.stat ? (c(), O(Y, {
        key: 0,
        class: "ds-fact__stat",
        "html-element": "h3",
        "text-type": "heading-4xl",
        "text-style": "regular"
      }, {
        default: H(() => [
          M("span", { innerHTML: e.stat }, null, 8, Tu)
        ]),
        _: 1
      })) : P("", !0),
      e.brandIconName ? (c(), O(la, {
        key: 1,
        class: "ds-fact__icon",
        "icon-name": e.brandIconName,
        size: "sm",
        mode: e.variant
      }, null, 8, ["icon-name", "mode"])) : P("", !0),
      z(Y, {
        class: "ds-fact__text",
        "html-element": "p",
        "text-type": "body-xs",
        "text-style": "regular"
      }, {
        default: H(() => [
          M("span", { innerHTML: e.text }, null, 8, Su)
        ]),
        _: 1
      })
    ], 2));
  }
}), Lu = {
  key: 0,
  class: "ds-tag__dot"
}, Ea = /* @__PURE__ */ q({
  __name: "ds-tag",
  props: {
    dot: { type: Boolean, default: !0 },
    text: {},
    type: { default: "ghost" }
  },
  setup(n) {
    const e = n;
    return (t, a) => (c(), O(Y, {
      class: U(["ds-tag", `ds-tag--${e.type}`]),
      "html-element": "p",
      "text-type": "body-sm",
      "text-style": "medium"
    }, {
      default: H(() => [
        t.dot ? (c(), w("span", Lu)) : P("", !0),
        K(W(t.text), 1)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Cu = ["src", "alt"], Na = /* @__PURE__ */ q({
  __name: "ds-sticky-media",
  props: {
    stackingIndex: {},
    isActive: { type: Boolean },
    imageAlt: {},
    imageSrc: {},
    mediaFocalPoint: { default: "center" }
  },
  setup(n) {
    const e = n, t = b(() => {
      const a = [];
      return e.mediaFocalPoint !== "center" && a.push(`--object-position: ${e.mediaFocalPoint};`), a;
    });
    return (a, r) => (c(), w("div", {
      class: U(["ds-sticky-media", { "is-visible": a.isActive }]),
      style: ge({
        zIndex: `${a.stackingIndex}`
      })
    }, [
      a.imageSrc ? (c(), w("img", {
        key: 0,
        class: "ds-sticky-media__image",
        src: a.imageSrc,
        alt: a.imageAlt,
        style: ge(t.value)
      }, null, 12, Cu)) : P("", !0)
    ], 6));
  }
}), Mu = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  "2xl": 1400
}, Eu = (n = ["sm", "md", "lg", "xl", "2xl"]) => {
  const e = en(
    {}
  ), t = {}, a = {};
  return de(() => {
    n.forEach((r) => {
      const s = Mu[r], i = window.matchMedia(`(min-width: ${s}px)`);
      t[r] = i, e[r] = i.matches;
      const o = (u) => {
        e[r] = u.matches;
      };
      a[r] = o, i.addEventListener("change", o);
    });
  }), Ve(() => {
    n.forEach((r) => {
      const s = t[r], i = a[r];
      s && i && s.removeEventListener("change", i);
    });
  }), e;
}, Nu = { class: "ds-sticky-panel__content" }, Au = { class: "ds-sticky-panel__content-top" }, xu = {
  key: 0,
  class: "ds-sticky-panel__content-bottom"
}, Bu = "button-external-link", Ou = "button-navigate-forward", Du = /* @__PURE__ */ q({
  __name: "ds-sticky-panel",
  props: {
    activeBgColour: {},
    activeIndex: {},
    bgColour: {},
    facts: {},
    index: { default: 0 },
    linkIsExternal: { type: Boolean, default: !1 },
    linkText: {},
    linkUrl: {},
    numberOfPanels: { default: 0 },
    mediaFocalPoint: { default: "center" },
    tag: {},
    title: {},
    text: {},
    image: {},
    imageAlt: {}
  },
  setup(n) {
    const e = n, t = Eu(["xl"]), a = b(() => e.linkIsExternal ? Bu : Ou), r = b(() => t.xl ? e.activeBgColour === "inverse" ? "inverse" : "default" : e.bgColour === "inverse" ? "inverse" : "default"), s = b(() => t.xl ? e.activeBgColour === "inverse" ? "link-inverted" : "link" : e.bgColour === "inverse" ? "link-inverted" : "link"), i = b(() => {
      const l = [];
      return e.activeIndex === e.index && l.push("ds-sticky-panel--active"), l.push(`ds-sticky-panel--bg-${e.bgColour}`), l;
    }), o = b(() => e.index), u = b(() => e.numberOfPanels - e.index);
    return (l, f) => (c(), O(qt, {
      class: U(["ds-sticky-panel", i.value]),
      style: ge({
        zIndex: `${o.value}`
      })
    }, {
      default: H(() => {
        var v;
        return [
          M("div", Nu, [
            M("div", Au, [
              S(t).xl ? P("", !0) : (c(), O(Na, {
                key: 0,
                "image-alt": l.imageAlt,
                "image-src": l.image,
                "is-active": !0,
                "stacking-index": u.value,
                "media-focal-point": l.mediaFocalPoint
              }, null, 8, ["image-alt", "image-src", "stacking-index", "media-focal-point"])),
              l.tag ? (c(), O(Ea, {
                key: 1,
                class: "ds-sticky-panel__tag",
                text: l.tag
              }, null, 8, ["text"])) : P("", !0),
              z(Y, {
                class: "ds-sticky-panel__title",
                "html-element": "h2",
                "text-type": "heading-5xl",
                "text-style": "medium"
              }, {
                default: H(() => [
                  K(W(l.title), 1)
                ]),
                _: 1
              }),
              z(Y, {
                class: "ds-sticky-panel__text",
                "text-type": "body-md",
                "text-style": "regular"
              }, {
                default: H(() => [
                  K(W(l.text), 1)
                ]),
                _: 1
              }),
              l.linkText ? (c(), O(be, {
                key: 2,
                variant: s.value,
                href: l.linkUrl,
                "icon-end": a.value,
                target: l.linkIsExternal ? "_blank" : void 0
              }, {
                default: H(() => [
                  K(W(l.linkText), 1)
                ]),
                _: 1
              }, 8, ["variant", "href", "icon-end", "target"])) : P("", !0)
            ]),
            (v = l.facts) != null && v.length ? (c(), w("div", xu, [
              (c(!0), w(ne, null, ue(l.facts, (d) => (c(), O(Pu, {
                key: d.text,
                stat: d.stat,
                "brand-icon-name": d.brandIconName,
                variant: r.value,
                text: d.text
              }, null, 8, ["stat", "brand-icon-name", "variant", "text"]))), 128))
            ])) : P("", !0)
          ])
        ];
      }),
      _: 1
    }, 8, ["class", "style"]));
  }
}), Fu = {
  key: 0,
  class: "ds-sticky-panels__media"
}, Hu = 0.1, zu = 0.8, Ed = /* @__PURE__ */ q({
  __name: "ds-sticky-panels",
  props: {
    panels: { default: () => [] },
    scrollSnap: { default: "mandatory" },
    stickyHeaderOffset: { default: 0 }
  },
  setup(n) {
    const e = n, { isMobile: t } = Ie(), { isMobile: a } = Ie(1200), r = I(null), s = I(null), i = I(null), o = I([]), u = I(0), l = I(!1), f = I(!1), v = I(!1), d = b(
      () => l.value && f.value && v.value
    ), { directions: m } = Ia(window), p = ["inverse", "decorative-2-subtle", "decorative-3-muted"], L = b(() => p[u.value % p.length]), x = b(() => !m.bottom && u.value === 0 || !m.top && u.value === o.value.length - 1 ? !1 : d.value), D = b(() => {
      const $ = [`ds-sticky-panels--bg-${L.value}`];
      return x.value && !a.value && $.push("ds-sticky-panels--active"), e.scrollSnap && !a.value && $.push(`ds-sticky-panels--scroll-snap-${e.scrollSnap}`), $;
    }), E = ($, k) => {
      if ($) {
        const y = ($ == null ? void 0 : $.$el) ?? $;
        o.value[k] = y;
      }
    }, T = () => {
      let $ = 0, k = u.value, y = null;
      for (let N = 0; N < o.value.length; N += 1) {
        const F = o.value[N], G = F.getBoundingClientRect(), _ = (Math.min(G.bottom, window.innerHeight) - Math.max(G.top, 0)) / G.height;
        _ >= Hu && _ > $ && ($ = _, k = N, y = F, u.value = k);
      }
      y && y.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }, g = window.matchMedia("(min-width: 1200px)"), C = ($) => {
      $.matches && T();
    };
    return de(() => {
      s.value && wt(
        s,
        ([$]) => {
          l.value = !$.isIntersecting;
        },
        { threshold: [0] }
      ), i.value && wt(
        i,
        ([$]) => {
          f.value = !$.isIntersecting;
        },
        { threshold: [0] }
      ), r.value && wt(
        r,
        ([$]) => {
          v.value = $.isIntersecting;
        },
        { threshold: [0] }
      ), o.value.forEach(($, k) => {
        wt(
          $,
          ([y]) => {
            d.value && y.isIntersecting && (u.value = k);
          },
          { threshold: zu }
        );
      }), g.addEventListener("change", C);
    }), Ve(() => {
      g.removeEventListener("change", C);
    }), le(a, async ($) => {
      $ === !1 && await Qe(() => {
        T();
      });
    }), le(x, () => {
      l.value === !1 && f.value === !0 && (u.value = 0), f.value === !1 && l.value === !0 && (u.value = o.value.length - 1);
    }), ($, k) => (c(), w("div", {
      class: U(["ds-sticky-panels", D.value]),
      style: ge(`--sticky-header-offset: ${$.stickyHeaderOffset}px`),
      ref_key: "containerRef",
      ref: r
    }, [
      M("div", {
        class: "ds-sticky-panels__bg-top",
        ref_key: "bgPanelTopRef",
        ref: s
      }, null, 512),
      z(qt, { class: "ds-sticky-panels__bg" }, {
        default: H(() => [
          (c(), w(ne, null, ue(p, (y, N) => M("div", {
            key: `${y}-${N}`,
            class: U(["ds-sticky-panels__bg-layer", { "is-visible": N === u.value }]),
            style: ge({ backgroundColor: `var(--ds-color-bg-${y})` })
          }, null, 6)), 64)),
          S(t) ? P("", !0) : (c(), w("div", Fu, [
            (c(!0), w(ne, null, ue($.panels, (y, N) => (c(), O(Na, {
              isActive: u.value === N,
              key: y.image,
              imageAlt: y.imageAlt,
              imageSrc: y.image,
              "stacking-index": $.panels.length - N,
              mediaFocalPoint: y.mediaFocalPoint
            }, null, 8, ["isActive", "imageAlt", "imageSrc", "stacking-index", "mediaFocalPoint"]))), 128))
          ]))
        ]),
        _: 1
      }),
      (c(!0), w(ne, null, ue($.panels, (y, N) => (c(), O(Du, {
        key: y.title,
        ref_for: !0,
        ref: (F) => E(F, N),
        activeIndex: u.value,
        activeBgColour: L.value,
        "bg-colour": p[N % p.length],
        facts: y.facts,
        inlineMedia: S(t),
        "link-is-external": y.linkIsExternal,
        linkText: y.linkText,
        linkUrl: y.linkUrl,
        mediaFocalPoint: y.mediaFocalPoint,
        tag: y.tag,
        title: y.title,
        text: y.text,
        image: y.image,
        imageAlt: y.imageAlt,
        index: N,
        numberOfPanels: $.panels.length,
        class: U({ "is-above": N < u.value })
      }, null, 8, ["activeIndex", "activeBgColour", "bg-colour", "facts", "inlineMedia", "link-is-external", "linkText", "linkUrl", "mediaFocalPoint", "tag", "title", "text", "image", "imageAlt", "index", "numberOfPanels", "class"]))), 128)),
      M("div", {
        class: "ds-sticky-panels__bg-bottom",
        ref_key: "bgPanelBottomRef",
        ref: i
      }, null, 512)
    ], 6));
  }
}), Nd = /* @__PURE__ */ q({
  __name: "ds-table",
  props: {
    caption: {},
    hideCaption: { type: Boolean, default: !1 },
    width: { default: "auto" }
  },
  setup(n) {
    const e = n, t = I(!1), a = I(0), r = b(() => {
      let A = [];
      return A.push(
        e.width === "full" ? "ds-table--full" : "ds-table--auto"
      ), t.value && A.push("ds-table--row-headers"), e.hideCaption && A.push("ds-table--hide-caption"), a.value < 3 ? A.push("ds-table--responsive-simple") : A.push("ds-table--responsive-stacked"), A;
    }), s = I(null);
    let i, o, u, l, f, v, d, m, p, L, x, D, E, T, g = [];
    ln(() => {
      var j;
      const A = (j = s.value) == null ? void 0 : j.querySelector(".ds-table__caption");
      A && (A.innerHTML = e.caption ?? "");
    });
    const $ = ["class", "style", ...[
      "align",
      "bgcolor",
      "border",
      "cellpadding",
      "cellspacing",
      "frame",
      "rules",
      "summary",
      "width"
    ]];
    de(() => {
      if (s.value !== null)
        try {
          k(), l && (N(), B(), V(), y(), s.value.replaceChild(
            u,
            o
          ), a.value = s.value.querySelectorAll("thead > tr > th").length);
        } catch {
          console.error(
            "Failed to process table, you're seeing an unmodified table"
          );
        }
    });
    const k = () => {
      i = document.createDocumentFragment(), s.value !== null && (o = s.value.querySelector("table"), u = o ? o.cloneNode(!0) : null, u && (i.appendChild(u), l = i.querySelector("table"), f = i.querySelector("thead"), m = i.querySelector("tbody"), x = i.querySelectorAll("tr"), D = i.querySelectorAll("th"), E = i.querySelectorAll("td"), L = i.querySelectorAll("colgroup"), p = i.querySelectorAll("col"), v = i.querySelector("tfoot"), d = i.querySelector("caption"), T = i.querySelectorAll("p"), g = [
        l,
        f,
        m,
        v,
        d,
        ...x,
        ...D,
        ...E,
        ...L,
        ...p,
        ...T
      ]));
    }, y = () => {
      l == null || l.classList.add("ds-table__table"), f == null || f.querySelectorAll("th").forEach((j) => {
        j.classList.add("ds-text-heading-xl", "ds-text--medium");
      });
      const A = m == null ? void 0 : m.querySelectorAll("th");
      A == null || A.forEach((j) => {
        j.classList.add("ds-text-body-md", "ds-text--medium");
      }), E == null || E.forEach((j) => {
        j.classList.add("ds-text-body-md", "ds-text--regular");
      }), d && d.classList.add("ds-table__caption", "ds-text-heading-xl"), A != null && A.length && (t.value = !0);
    }, N = () => {
      g.filter((A) => A !== null).forEach((A) => {
        if (A.hasAttribute("style")) {
          const j = A.getAttribute("style") || "", Z = new Map(
            j.split(";").map(
              (re) => re.trim().split(":")
            )
          ), R = [
            "vertical-align",
            "text-align",
            "font-weight",
            "font-style"
          ], J = Array.from(Z).filter(([re]) => R.includes(re.trim())).map(([re, te]) => `${re}: ${te}`).join("; ");
          A.removeAttribute("style"), J && A.setAttribute("style", J);
        }
        $.forEach((j) => {
          j !== "style" && A.removeAttribute(j);
        });
      });
    }, F = (A) => {
      const j = A.parentNode, Z = document.createElement("th");
      Z.innerHTML = A.innerHTML, j == null || j.replaceChild(Z, A);
    }, G = () => {
      const A = l == null ? void 0 : l.querySelector(
        "tr:first-child:has(td strong), tr:first-child:has(td b)"
      );
      A && (A == null ? void 0 : A.querySelectorAll("td")).forEach((R) => {
        F(R);
      });
      const j = l == null ? void 0 : l.querySelectorAll(
        "td:first-child:has(strong, b)"
      );
      j && j.forEach((Z) => {
        F(Z);
      });
    }, h = () => {
      !d && e.caption && (d = l == null ? void 0 : l.createCaption()), d && e.caption && (d.innerHTML = e.caption);
    }, _ = () => {
      if (!f) {
        const A = l == null ? void 0 : l.querySelector(
          "tr:first-child:has(th)"
        );
        if (A) {
          const j = A.parentNode, Z = j == null ? void 0 : j.removeChild(A);
          f = l == null ? void 0 : l.createTHead(), f && Z && f.appendChild(Z), D = l == null ? void 0 : l.querySelectorAll("th");
        }
      }
    }, B = () => {
      G(), _(), h();
    }, V = () => {
      const A = f == null ? void 0 : f.querySelectorAll("th");
      A == null || A.forEach((Z) => Z.scope = "col");
      const j = m == null ? void 0 : m.querySelectorAll("th");
      if (j == null || j.forEach((Z) => Z.scope = "row"), A) {
        const Z = [...A].map((J) => J.textContent ?? ""), R = m == null ? void 0 : m.querySelectorAll("tr");
        R && Z && [...R].map((J) => {
          [...J.childNodes].map((re, te) => {
            re.setAttribute("data-col-header", Z[te]);
          });
        });
      }
    };
    return (A, j) => (c(), w("div", {
      class: U(["ds-table", r.value]),
      ref_key: "table",
      ref: s
    }, [
      se(A.$slots, "default")
    ], 2));
  }
}), Ru = ["aria-labelledby", "id"], Vu = /* @__PURE__ */ q({
  __name: "ds-tab",
  props: {
    name: {},
    id: {}
  },
  setup(n) {
    const e = n, t = ee("activeTab"), a = b(() => e.id === (t == null ? void 0 : t.value));
    return (r, s) => ve((c(), w("div", {
      "aria-labelledby": `${r.id}-button`,
      role: "tabpanel",
      id: r.id,
      class: "ds-tab-panel"
    }, [
      se(r.$slots, "default")
    ], 8, Ru)), [
      [pe, a.value]
    ]);
  }
}), Ut = (n) => {
  const e = document.getElementById(n);
  e == null || e.focus();
}, qu = (n) => {
  var t;
  const e = `${(t = n == null ? void 0 : n.dataset) == null ? void 0 : t.nextId}`;
  Ut(e);
}, ju = (n) => {
  var t;
  const e = `${(t = n == null ? void 0 : n.dataset) == null ? void 0 : t.prevId}`;
  Ut(e);
}, Wu = (n) => {
  var t;
  const e = `${(t = n == null ? void 0 : n.dataset) == null ? void 0 : t.lastId}`;
  Ut(e);
}, Uu = (n) => {
  var t;
  const e = `${(t = n == null ? void 0 : n.dataset) == null ? void 0 : t.firstId}`;
  Ut(e);
}, Ku = {
  ArrowUp: ju,
  ArrowDown: qu,
  Home: Uu,
  End: Wu
}, Un = (n) => {
  const e = Ku[n.key];
  if (e) {
    const t = document.activeElement;
    e(t), n.stopPropagation(), n.preventDefault();
  }
}, Gu = /* @__PURE__ */ q({
  __name: "ds-tabs-menu",
  props: {
    accessibleButtonLabel: {},
    hiddenItems: {},
    setActive: {}
  },
  setup(n) {
    const e = I(null);
    _n(e, () => o.value = !1);
    const t = n, a = Ze("tab-menu"), r = () => {
      o.value = !o.value;
    }, s = (l) => {
      typeof l < "u" && (o.value = !1, t.setActive(l));
    }, i = b(
      () => o.value ? "ds-tabs-menu--active" : null
    ), o = I(!1), u = b(() => {
      const l = [];
      return t.hiddenItems && t.hiddenItems.forEach((f) => {
        var d;
        const v = {
          id: `${f == null ? void 0 : f.id}-hidden`,
          panelId: (d = f == null ? void 0 : f.dataset) == null ? void 0 : d.id,
          text: f == null ? void 0 : f.dataset.label
        };
        l.push(v);
      }), l;
    });
    return (l, f) => {
      var v;
      return c(), w("div", {
        class: U(["ds-tabs-menu", i.value]),
        ref_key: "menu",
        ref: e
      }, [
        z(he, {
          "aria-haspopup": "",
          "aria-expanded": o.value,
          "aria-controls": S(a),
          ariaLabel: l.accessibleButtonLabel,
          clickHandler: r,
          "data-next-id": (v = u.value[0]) == null ? void 0 : v.id,
          onKeydown: S(Un),
          size: "sm",
          variant: "ghost-neutral",
          iconName: "button-more",
          type: "button"
        }, null, 8, ["aria-expanded", "aria-controls", "ariaLabel", "data-next-id", "onKeydown"]),
        z(Ma, {
          class: "ds-tabs-menu__content",
          id: S(a),
          elevation: "overlay",
          padding: "popover",
          role: "menu"
        }, {
          default: H(() => [
            (c(!0), w(ne, null, ue(u.value, (d, m) => {
              var p, L, x, D, E, T;
              return c(), O(be, {
                key: d.id,
                id: `${d.id}`,
                onClick: (g) => s(d == null ? void 0 : d.panelId),
                onKeydown: S(Un),
                "data-next-id": (p = u.value[(m + 1) % u.value.length]) == null ? void 0 : p.id,
                "data-prev-id": (D = u.value[(m + ((L = u.value) == null ? void 0 : L.length) - 1) % ((x = u.value) == null ? void 0 : x.length)]) == null ? void 0 : D.id,
                "data-last-id": (E = u.value[u.value.length - 1]) == null ? void 0 : E.id,
                "data-first-id": (T = u.value[0]) == null ? void 0 : T.id,
                "data-index": m,
                role: "menuitem",
                variant: "link-neutral"
              }, {
                default: H(() => [
                  K(W(d.text), 1)
                ]),
                _: 2
              }, 1032, ["id", "onClick", "onKeydown", "data-next-id", "data-prev-id", "data-last-id", "data-first-id", "data-index"]);
            }), 128))
          ]),
          _: 1
        }, 8, ["id"])
      ], 2);
    };
  }
}), Kt = (n) => {
  const e = document.getElementById(n);
  e == null || e.focus();
}, Yu = (n) => {
  var t;
  const e = `${(t = n == null ? void 0 : n.dataset) == null ? void 0 : t.nextId}-button`;
  Kt(e);
}, Qu = (n) => {
  var t;
  const e = `${(t = n == null ? void 0 : n.dataset) == null ? void 0 : t.prevId}-button`;
  Kt(e);
}, Xu = (n) => {
  var t;
  const e = `${(t = n == null ? void 0 : n.dataset) == null ? void 0 : t.lastId}-button`;
  Kt(e);
}, Zu = (n) => {
  var t;
  const e = `${(t = n == null ? void 0 : n.dataset) == null ? void 0 : t.firstId}-button`;
  Kt(e);
}, Ju = {
  ArrowLeft: Qu,
  ArrowRight: Yu,
  Home: Zu,
  End: Xu
}, Kn = (n) => {
  const e = Ju[n.key];
  if (e) {
    const t = document.activeElement;
    e(t), n.stopPropagation(), n.preventDefault();
  }
};
function ec(n, e, t) {
  let a = null;
  de(() => {
    a = new IntersectionObserver(
      (r) => {
        r.forEach((s) => {
          s.intersectionRatio < 1 ? t(s.target.id, !1) : t(s.target.id, !0);
        });
      },
      {
        root: e.value,
        threshold: [0, 1]
      }
    ), n.value.forEach((r) => {
      a == null || a.observe(r);
    });
  }), Ve(() => {
    a == null || a.disconnect();
  });
}
function tc(n, e, t) {
  const a = (u, l = !0) => {
    const f = s(n, u);
    l ? (o(e, f), i(t, u)) : (o(t, f), i(e, u)), t.value.sort(r), e.value.sort(r);
  }, r = (u, l) => Number(u.dataset.index) - Number(l.dataset.index), s = (u, l) => u.value.find((f) => (f == null ? void 0 : f.id) === l), i = (u, l) => {
    const f = u.value.findIndex((v) => (v == null ? void 0 : v.id) === l);
    f > -1 && u.value.splice(f, 1);
  }, o = (u, l) => {
    l && !u.value.includes(l) && u.value.push(l);
  };
  return {
    moveItemById: a
  };
}
function nc(n, e = 500) {
  let t;
  window.addEventListener("resize", function() {
    t && clearTimeout(t), t = window.setTimeout(function() {
      n();
    }, e);
  });
}
const ac = { class: "ds-tabs__nav-wrapper" }, rc = ["data-next-id", "data-prev-id", "data-last-id", "data-first-id", "data-index", "data-label", "data-id", "id", "aria-controls", "aria-selected", "tabIndex", "onClick"], sc = {
  key: 0,
  class: "ds-tabs__panels"
}, oc = {
  key: 1,
  class: "ds-tabs__panels"
}, lc = ["innerHTML"], Ad = /* @__PURE__ */ q({
  __name: "ds-tabs",
  props: {
    overflowMenuButtonLabel: {},
    tabs: {}
  },
  setup(n) {
    const e = n, t = Ka(), a = (k) => typeof k.type == "symbol" && Array.isArray(k.children), r = (k) => {
      var y, N;
      return typeof k.type == "object" && "props" in k && !!((y = k.props) != null && y.id) && !!((N = k.props) != null && N.name);
    }, s = (k) => k.flatMap((y) => i(y)), i = (k) => k != null && k.type ? a(k) ? s(k.children) : r(k) ? [
      {
        id: k.props.id,
        name: k.props.name,
        content: k
        // Preserve the full VNode
      }
    ] : [] : [], o = b(() => {
      if (!t.default) return [];
      const k = t.default();
      return s(k);
    }), u = b(() => e.tabs && e.tabs.length > 0 ? e.tabs : o.value), l = () => {
      if (E.value) {
        const k = document.getElementById(
          `${L.value}-button`
        );
        k == null || k.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center"
        });
      }
    }, f = (k) => {
      const y = k;
      y && !v.value.includes(y) && v.value.push(y);
    }, v = I([]), d = I([]), m = I([]), p = b(() => u.value.map((k) => ({
      id: k.id,
      name: k.name
    }))), L = I(""), x = I(null);
    nc(l);
    const { moveItemById: D } = tc(v, d, m);
    ec(v, x, D);
    const E = b(() => m.value.length > 0), T = b(
      () => E.value ? "ds-tabs--overflow" : null
    ), g = (k, y, N) => {
      const F = [];
      return k === y && F.push("ds-tab--active"), N.find((G) => G.id === `${k}-button`) && F.push("ds-tab--hidden"), F;
    }, C = (k) => {
      L.value = k, D(L.value, !0), l();
    };
    fe("activeTab", L);
    const $ = b(() => u.value.length > 1);
    return $.value || console.error("Tabs component should have a minimum of 2 tabs"), ln(() => {
      !L.value && p.value.length > 0 && (L.value = p.value[0].id);
    }), (k, y) => $.value ? (c(), w("div", {
      key: 0,
      class: U(["ds-tabs", T.value])
    }, [
      M("div", ac, [
        M("div", {
          class: "ds-tabs__nav",
          role: "tablist",
          ref_key: "tablist",
          ref: x
        }, [
          (c(!0), w(ne, null, ue(p.value, ({ name: N, id: F }, G) => (c(), w("button", {
            "data-next-id": p.value[(G + 1) % p.value.length].id,
            "data-prev-id": p.value[(G + p.value.length - 1) % p.value.length].id,
            "data-last-id": p.value[p.value.length - 1].id,
            "data-first-id": p.value[0].id,
            "data-index": G,
            "data-label": N,
            "data-id": F,
            id: `${F}-button`,
            class: U(["ds-tab", g(F, L.value, m.value)]),
            "aria-controls": F,
            "aria-selected": F === L.value,
            tabIndex: F !== L.value ? "-1" : void 0,
            key: `${F}-button`,
            ref_for: !0,
            ref: f,
            role: "tab",
            onClick: (h) => C(F),
            onKeydown: y[0] || (y[0] = //@ts-ignore
            (...h) => S(Kn) && S(Kn)(...h))
          }, [
            z(Y, {
              class: "ds-tab__text",
              "html-element": "span",
              "text-style": "medium",
              "text-type": "label-md"
            }, {
              default: H(() => [
                K(W(N), 1)
              ]),
              _: 2
            }, 1024)
          ], 42, rc))), 128))
        ], 512),
        E.value ? (c(), O(Gu, {
          key: 0,
          "accessible-button-label": k.overflowMenuButtonLabel,
          hiddenItems: m.value,
          setActive: C
        }, null, 8, ["accessible-button-label", "hiddenItems"])) : P("", !0)
      ]),
      o.value && o.value.length ? (c(), w("div", sc, [
        se(k.$slots, "default")
      ])) : (c(), w("div", oc, [
        (c(!0), w(ne, null, ue(k.tabs, (N) => (c(), O(Vu, {
          key: N.id,
          id: N.id,
          name: N.name
        }, {
          default: H(() => [
            M("div", {
              innerHTML: N.content
            }, null, 8, lc)
          ]),
          _: 2
        }, 1032, ["id", "name"]))), 128))
      ]))
    ], 2)) : P("", !0);
  }
}), ic = ["innerHTML"], uc = /* @__PURE__ */ q({
  __name: "ds-glyph",
  props: {
    glyph: {},
    size: { default: "inherit" }
  },
  setup(n) {
    const e = n, t = {
      "left-double-quote": "&ldquo;",
      underscore: "&lowbar;"
    }, a = b(() => {
      const s = t[e.glyph];
      return s || (console.error(`Glyph "${e.glyph}" not found in glyphMap.`), "");
    }), r = b(() => {
      const s = [`ds-glyph--${e.glyph}`];
      return e.size !== "inherit" && s.push(`ds-glyph--${e.size}`), s;
    });
    return (s, i) => (c(), w("span", {
      class: U(["ds-glyph", r.value]),
      innerHTML: a.value
    }, null, 10, ic));
  }
}), cc = { class: "ds-testimonial__image-wrapper" }, dc = ["src", "alt"], fc = { class: "ds-testimonial__content" }, mc = { class: "ds-testimonial__quote-wrapper" }, vc = { class: "ds-testimonial__quote" }, xd = /* @__PURE__ */ q({
  __name: "ds-testimonial",
  props: {
    imageAltText: {},
    imageUrl: {},
    order: { default: "default" },
    testimonialText: {},
    testimonialName: {},
    testimonialRole: {},
    testimonialProduct: {}
  },
  setup(n) {
    const e = n, t = b(() => {
      let r = [];
      return e.testimonialRole && r.push(e.testimonialRole), e.testimonialProduct && r.push(e.testimonialProduct), r.join(" | ");
    }), a = b(() => {
      const r = [];
      return e.order !== "default" && r.push(`ds-testimonial--order-${e.order}`), r;
    });
    return (r, s) => (c(), O(gl, {
      "columns-md": 2,
      class: U(["ds-testimonial", a.value])
    }, {
      default: H(() => [
        M("div", cc, [
          M("img", {
            class: "ds-testimonial__image",
            src: r.imageUrl,
            alt: r.imageAltText
          }, null, 8, dc)
        ]),
        M("figure", fc, [
          M("div", mc, [
            M("blockquote", vc, [
              z(Y, {
                "html-element": "q",
                "text-type": "heading-4xl",
                class: "ds-testimonial__text"
              }, {
                default: H(() => [
                  K(W(r.testimonialText), 1)
                ]),
                _: 1
              })
            ])
          ]),
          M("figcaption", null, [
            r.testimonialName ? (c(), O(Y, {
              key: 0,
              "html-element": "p",
              "text-type": "body-md",
              "text-style": "medium",
              class: "ds-testimonial__name"
            }, {
              default: H(() => [
                K(W(r.testimonialName), 1),
                z(uc, { glyph: "underscore" })
              ]),
              _: 1
            })) : P("", !0),
            t.value ? (c(), O(Y, {
              key: 1,
              "html-element": "p",
              "text-type": "body-md",
              "text-style": "regular",
              class: "ds-testimonial__role"
            }, {
              default: H(() => [
                K(W(t.value), 1)
              ]),
              _: 1
            })) : P("", !0)
          ])
        ])
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), pc = {
  key: 0,
  role: "alert",
  class: "ds-toast__inner"
}, hc = { class: "ds-toast__content" }, gc = {
  key: 3,
  class: "ds-toast__countdown-track"
}, Bd = /* @__PURE__ */ q({
  __name: "ds-toast",
  props: {
    actionText: {},
    actionFn: {},
    closeButtonAriaLabel: { default: "Close" },
    closeOnActionClick: { type: Boolean, default: !0 },
    description: {},
    showIcon: { type: Boolean, default: !0 },
    showCountdown: { type: Boolean, default: !1 },
    timeout: { default: 0 },
    variant: { default: "default" }
  },
  setup(n) {
    const e = n, t = (m) => {
      e.actionFn && (e.actionFn(m), e.closeOnActionClick && v());
    }, a = I(!1), r = I(e.timeout), s = I(!1), i = I(null), o = I(!1), u = b(() => {
      const m = ["ds-toast"];
      return m.push(`ds-toast--${e.variant}`), s.value === !1 && a.value === !1 && m.push("ds-toast--initial"), e.showCountdown && m.push("ds-toast--countdown"), o.value ? m.push("ds-toast--multiline") : m.push("ds-toast--singleline"), m;
    });
    let l = 0, f = 0;
    const v = () => {
      a.value = !1, l = window.setTimeout(() => {
        d();
      }, 500);
    }, d = () => {
      s.value = !0;
    };
    return de(() => {
      a.value = !0;
      const m = Number(r.value) + 1100;
      r.value > 0 && (f = window.setTimeout(() => {
        v();
      }, m));
    }), Ve(() => {
      window.clearTimeout(l), window.clearTimeout(f);
    }), le(a, async () => {
      if (o.value === !0) return;
      await Qe();
      const m = i.value;
      m && m.scrollHeight > m.offsetHeight && (o.value = !0);
    }), (m, p) => s.value ? P("", !0) : (c(), w("div", {
      key: 0,
      class: U(u.value),
      "data-testid": "toast"
    }, [
      z(Ue, {
        class: "ds-toast__transition",
        name: "toast",
        "enter-from-class": "toast-enter-from",
        "enter-to-class": "toast-enter-to",
        "leave-from-class": "toast-leave-from",
        "leave-to-class": "toast-leave-to"
      }, {
        default: H(() => [
          a.value ? (c(), w("div", pc, [
            m.showIcon ? (c(), O(ae, {
              key: 0,
              class: "ds-toast__icon",
              iconName: "information-circle",
              size: "md"
            })) : P("", !0),
            M("div", hc, [
              m.description ? (c(), O(Y, {
                key: 0,
                "html-element": "div",
                "text-type": "body-lg",
                "text-style": "regular",
                class: "ds-toast__description"
              }, {
                default: H(() => [
                  M("div", {
                    ref_key: "textElem",
                    ref: i
                  }, W(m.description), 513)
                ]),
                _: 1
              })) : P("", !0)
            ]),
            m.actionText ? (c(), O(be, {
              key: 1,
              clickHandler: t,
              size: "sm",
              variant: "functional"
            }, {
              default: H(() => [
                K(W(m.actionText), 1)
              ]),
              _: 1
            })) : P("", !0),
            P("", !0),
            m.showCountdown ? (c(), w("div", gc, [
              M("div", {
                class: "ds-toast__countdown-bar",
                style: ge({ animationDuration: `${r.value / 1e3}s` })
              }, null, 4)
            ])) : P("", !0)
          ])) : P("", !0)
        ]),
        _: 1
      })
    ], 2));
  }
}), bc = ["data-show"], yc = ["aria-label"], _c = ["role"], kc = ["innerHTML"], wc = ["href", "target"], $c = /* @__PURE__ */ M("div", {
  class: "ds-tooltip__arrow",
  "data-popper-arrow": ""
}, null, -1), Od = /* @__PURE__ */ q({
  __name: "ds-toggletip",
  props: {
    accessibleButtonLabel: {},
    iconName: { default: "information-circle" },
    iconSize: { default: "md" },
    linkTarget: {},
    linkText: {},
    linkUrl: {},
    placement: { default: "auto" },
    strategy: { default: "absolute" },
    text: {},
    title: {},
    titleElement: { default: "h3" }
  },
  setup(n) {
    const e = n, t = I(null), a = I(null), r = I(null);
    _n(t, () => {
      i.value = !1;
    });
    const { toggle: s, isOpen: i } = ga({
      targetNode: a,
      tooltipNode: r,
      placement: e.placement,
      strategy: e.strategy
    }), o = b(() => i.value ? "status" : void 0);
    return (u, l) => (c(), w("div", {
      class: "ds-tooltip",
      "data-show": S(i),
      ref_key: "container",
      ref: t
    }, [
      u.iconName ? (c(), w("button", {
        key: 0,
        ref_key: "target",
        ref: a,
        class: "ds-tooltip__target",
        "aria-label": u.accessibleButtonLabel,
        onClick: l[0] || (l[0] = //@ts-ignore
        (...f) => S(s) && S(s)(...f))
      }, [
        z(ae, {
          "icon-name": u.iconName,
          size: u.iconSize
        }, null, 8, ["icon-name", "size"])
      ], 8, yc)) : P("", !0),
      M("div", {
        ref_key: "tooltip",
        ref: r,
        class: "ds-tooltip__tooltip"
      }, [
        M("div", {
          class: "ds-tooltip__content",
          role: o.value
        }, [
          u.title ? (c(), O(Tt(u.titleElement), {
            key: 0,
            class: "ds-tooltip__title"
          }, {
            default: H(() => [
              K(W(u.title), 1)
            ]),
            _: 1
          })) : P("", !0),
          z(Y, {
            "text-type": "label-sm",
            "html-element": "div"
          }, {
            default: H(() => [
              M("div", { innerHTML: u.text }, null, 8, kc)
            ]),
            _: 1
          }),
          u.linkText && u.linkUrl ? (c(), w("a", {
            key: 1,
            class: "ds-tooltip__link",
            href: u.linkUrl,
            target: u.linkTarget
          }, W(u.linkText), 9, wc)) : P("", !0)
        ], 8, _c),
        $c
      ], 512)
    ], 8, bc));
  }
});
/*! @vimeo/player v2.25.0 | (c) 2024 Vimeo | MIT License | https://github.com/vimeo/player.js */
function Gn(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);
    e && (a = a.filter(function(r) {
      return Object.getOwnPropertyDescriptor(n, r).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function Yn(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Gn(Object(t), !0).forEach(function(a) {
      Bt(n, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : Gn(Object(t)).forEach(function(a) {
      Object.defineProperty(n, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return n;
}
function we() {
  we = function() {
    return n;
  };
  var n = {}, e = Object.prototype, t = e.hasOwnProperty, a = Object.defineProperty || function(h, _, B) {
    h[_] = B.value;
  }, r = typeof Symbol == "function" ? Symbol : {}, s = r.iterator || "@@iterator", i = r.asyncIterator || "@@asyncIterator", o = r.toStringTag || "@@toStringTag";
  function u(h, _, B) {
    return Object.defineProperty(h, _, {
      value: B,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), h[_];
  }
  try {
    u({}, "");
  } catch {
    u = function(_, B, V) {
      return _[B] = V;
    };
  }
  function l(h, _, B, V) {
    var A = _ && _.prototype instanceof d ? _ : d, j = Object.create(A.prototype), Z = new N(V || []);
    return a(j, "_invoke", {
      value: C(h, B, Z)
    }), j;
  }
  function f(h, _, B) {
    try {
      return {
        type: "normal",
        arg: h.call(_, B)
      };
    } catch (V) {
      return {
        type: "throw",
        arg: V
      };
    }
  }
  n.wrap = l;
  var v = {};
  function d() {
  }
  function m() {
  }
  function p() {
  }
  var L = {};
  u(L, s, function() {
    return this;
  });
  var x = Object.getPrototypeOf, D = x && x(x(F([])));
  D && D !== e && t.call(D, s) && (L = D);
  var E = p.prototype = d.prototype = Object.create(L);
  function T(h) {
    ["next", "throw", "return"].forEach(function(_) {
      u(h, _, function(B) {
        return this._invoke(_, B);
      });
    });
  }
  function g(h, _) {
    function B(A, j, Z, R) {
      var J = f(h[A], h, j);
      if (J.type !== "throw") {
        var re = J.arg, te = re.value;
        return te && typeof te == "object" && t.call(te, "__await") ? _.resolve(te.__await).then(function(ie) {
          B("next", ie, Z, R);
        }, function(ie) {
          B("throw", ie, Z, R);
        }) : _.resolve(te).then(function(ie) {
          re.value = ie, Z(re);
        }, function(ie) {
          return B("throw", ie, Z, R);
        });
      }
      R(J.arg);
    }
    var V;
    a(this, "_invoke", {
      value: function(A, j) {
        function Z() {
          return new _(function(R, J) {
            B(A, j, R, J);
          });
        }
        return V = V ? V.then(Z, Z) : Z();
      }
    });
  }
  function C(h, _, B) {
    var V = "suspendedStart";
    return function(A, j) {
      if (V === "executing") throw new Error("Generator is already running");
      if (V === "completed") {
        if (A === "throw") throw j;
        return G();
      }
      for (B.method = A, B.arg = j; ; ) {
        var Z = B.delegate;
        if (Z) {
          var R = $(Z, B);
          if (R) {
            if (R === v) continue;
            return R;
          }
        }
        if (B.method === "next") B.sent = B._sent = B.arg;
        else if (B.method === "throw") {
          if (V === "suspendedStart") throw V = "completed", B.arg;
          B.dispatchException(B.arg);
        } else B.method === "return" && B.abrupt("return", B.arg);
        V = "executing";
        var J = f(h, _, B);
        if (J.type === "normal") {
          if (V = B.done ? "completed" : "suspendedYield", J.arg === v) continue;
          return {
            value: J.arg,
            done: B.done
          };
        }
        J.type === "throw" && (V = "completed", B.method = "throw", B.arg = J.arg);
      }
    };
  }
  function $(h, _) {
    var B = _.method, V = h.iterator[B];
    if (V === void 0) return _.delegate = null, B === "throw" && h.iterator.return && (_.method = "return", _.arg = void 0, $(h, _), _.method === "throw") || B !== "return" && (_.method = "throw", _.arg = new TypeError("The iterator does not provide a '" + B + "' method")), v;
    var A = f(V, h.iterator, _.arg);
    if (A.type === "throw") return _.method = "throw", _.arg = A.arg, _.delegate = null, v;
    var j = A.arg;
    return j ? j.done ? (_[h.resultName] = j.value, _.next = h.nextLoc, _.method !== "return" && (_.method = "next", _.arg = void 0), _.delegate = null, v) : j : (_.method = "throw", _.arg = new TypeError("iterator result is not an object"), _.delegate = null, v);
  }
  function k(h) {
    var _ = {
      tryLoc: h[0]
    };
    1 in h && (_.catchLoc = h[1]), 2 in h && (_.finallyLoc = h[2], _.afterLoc = h[3]), this.tryEntries.push(_);
  }
  function y(h) {
    var _ = h.completion || {};
    _.type = "normal", delete _.arg, h.completion = _;
  }
  function N(h) {
    this.tryEntries = [{
      tryLoc: "root"
    }], h.forEach(k, this), this.reset(!0);
  }
  function F(h) {
    if (h) {
      var _ = h[s];
      if (_) return _.call(h);
      if (typeof h.next == "function") return h;
      if (!isNaN(h.length)) {
        var B = -1, V = function A() {
          for (; ++B < h.length; ) if (t.call(h, B)) return A.value = h[B], A.done = !1, A;
          return A.value = void 0, A.done = !0, A;
        };
        return V.next = V;
      }
    }
    return {
      next: G
    };
  }
  function G() {
    return {
      value: void 0,
      done: !0
    };
  }
  return m.prototype = p, a(E, "constructor", {
    value: p,
    configurable: !0
  }), a(p, "constructor", {
    value: m,
    configurable: !0
  }), m.displayName = u(p, o, "GeneratorFunction"), n.isGeneratorFunction = function(h) {
    var _ = typeof h == "function" && h.constructor;
    return !!_ && (_ === m || (_.displayName || _.name) === "GeneratorFunction");
  }, n.mark = function(h) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(h, p) : (h.__proto__ = p, u(h, o, "GeneratorFunction")), h.prototype = Object.create(E), h;
  }, n.awrap = function(h) {
    return {
      __await: h
    };
  }, T(g.prototype), u(g.prototype, i, function() {
    return this;
  }), n.AsyncIterator = g, n.async = function(h, _, B, V, A) {
    A === void 0 && (A = Promise);
    var j = new g(l(h, _, B, V), A);
    return n.isGeneratorFunction(_) ? j : j.next().then(function(Z) {
      return Z.done ? Z.value : j.next();
    });
  }, T(E), u(E, o, "Generator"), u(E, s, function() {
    return this;
  }), u(E, "toString", function() {
    return "[object Generator]";
  }), n.keys = function(h) {
    var _ = Object(h), B = [];
    for (var V in _) B.push(V);
    return B.reverse(), function A() {
      for (; B.length; ) {
        var j = B.pop();
        if (j in _) return A.value = j, A.done = !1, A;
      }
      return A.done = !0, A;
    };
  }, n.values = F, N.prototype = {
    constructor: N,
    reset: function(h) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(y), !h) for (var _ in this) _.charAt(0) === "t" && t.call(this, _) && !isNaN(+_.slice(1)) && (this[_] = void 0);
    },
    stop: function() {
      this.done = !0;
      var h = this.tryEntries[0].completion;
      if (h.type === "throw") throw h.arg;
      return this.rval;
    },
    dispatchException: function(h) {
      if (this.done) throw h;
      var _ = this;
      function B(J, re) {
        return j.type = "throw", j.arg = h, _.next = J, re && (_.method = "next", _.arg = void 0), !!re;
      }
      for (var V = this.tryEntries.length - 1; V >= 0; --V) {
        var A = this.tryEntries[V], j = A.completion;
        if (A.tryLoc === "root") return B("end");
        if (A.tryLoc <= this.prev) {
          var Z = t.call(A, "catchLoc"), R = t.call(A, "finallyLoc");
          if (Z && R) {
            if (this.prev < A.catchLoc) return B(A.catchLoc, !0);
            if (this.prev < A.finallyLoc) return B(A.finallyLoc);
          } else if (Z) {
            if (this.prev < A.catchLoc) return B(A.catchLoc, !0);
          } else {
            if (!R) throw new Error("try statement without catch or finally");
            if (this.prev < A.finallyLoc) return B(A.finallyLoc);
          }
        }
      }
    },
    abrupt: function(h, _) {
      for (var B = this.tryEntries.length - 1; B >= 0; --B) {
        var V = this.tryEntries[B];
        if (V.tryLoc <= this.prev && t.call(V, "finallyLoc") && this.prev < V.finallyLoc) {
          var A = V;
          break;
        }
      }
      A && (h === "break" || h === "continue") && A.tryLoc <= _ && _ <= A.finallyLoc && (A = null);
      var j = A ? A.completion : {};
      return j.type = h, j.arg = _, A ? (this.method = "next", this.next = A.finallyLoc, v) : this.complete(j);
    },
    complete: function(h, _) {
      if (h.type === "throw") throw h.arg;
      return h.type === "break" || h.type === "continue" ? this.next = h.arg : h.type === "return" ? (this.rval = this.arg = h.arg, this.method = "return", this.next = "end") : h.type === "normal" && _ && (this.next = _), v;
    },
    finish: function(h) {
      for (var _ = this.tryEntries.length - 1; _ >= 0; --_) {
        var B = this.tryEntries[_];
        if (B.finallyLoc === h) return this.complete(B.completion, B.afterLoc), y(B), v;
      }
    },
    catch: function(h) {
      for (var _ = this.tryEntries.length - 1; _ >= 0; --_) {
        var B = this.tryEntries[_];
        if (B.tryLoc === h) {
          var V = B.completion;
          if (V.type === "throw") {
            var A = V.arg;
            y(B);
          }
          return A;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(h, _, B) {
      return this.delegate = {
        iterator: F(h),
        resultName: _,
        nextLoc: B
      }, this.method === "next" && (this.arg = void 0), v;
    }
  }, n;
}
function Qn(n, e, t, a, r, s, i) {
  try {
    var o = n[s](i), u = o.value;
  } catch (l) {
    t(l);
    return;
  }
  o.done ? e(u) : Promise.resolve(u).then(a, r);
}
function nt(n) {
  return function() {
    var e = this, t = arguments;
    return new Promise(function(a, r) {
      var s = n.apply(e, t);
      function i(u) {
        Qn(s, a, r, i, o, "next", u);
      }
      function o(u) {
        Qn(s, a, r, i, o, "throw", u);
      }
      i(void 0);
    });
  };
}
function Aa(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Xn(n, e) {
  for (var t = 0; t < e.length; t++) {
    var a = e[t];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(n, Oa(a.key), a);
  }
}
function xa(n, e, t) {
  return e && Xn(n.prototype, e), t && Xn(n, t), Object.defineProperty(n, "prototype", {
    writable: !1
  }), n;
}
function Bt(n, e, t) {
  return e = Oa(e), e in n ? Object.defineProperty(n, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = t, n;
}
function Ic(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: n,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(n, "prototype", {
    writable: !1
  }), e && Lt(n, e);
}
function Pt(n) {
  return Pt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Pt(n);
}
function Lt(n, e) {
  return Lt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, r) {
    return a.__proto__ = r, a;
  }, Lt(n, e);
}
function Ba() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ot(n, e, t) {
  return Ba() ? Ot = Reflect.construct.bind() : Ot = function(r, s, i) {
    var o = [null];
    o.push.apply(o, s);
    var u = Function.bind.apply(r, o), l = new u();
    return i && Lt(l, i.prototype), l;
  }, Ot.apply(null, arguments);
}
function Tc(n) {
  return Function.toString.call(n).indexOf("[native code]") !== -1;
}
function sn(n) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return sn = function(a) {
    if (a === null || !Tc(a)) return a;
    if (typeof a != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof e < "u") {
      if (e.has(a)) return e.get(a);
      e.set(a, r);
    }
    function r() {
      return Ot(a, arguments, Pt(this).constructor);
    }
    return r.prototype = Object.create(a.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Lt(r, a);
  }, sn(n);
}
function Dt(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function Sc(n, e) {
  if (e && (typeof e == "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Dt(n);
}
function Pc(n) {
  var e = Ba();
  return function() {
    var a = Pt(n), r;
    if (e) {
      var s = Pt(this).constructor;
      r = Reflect.construct(a, arguments, s);
    } else
      r = a.apply(this, arguments);
    return Sc(this, r);
  };
}
function Lc(n, e) {
  if (typeof n != "object" || n === null) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(n, e || "default");
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function Oa(n) {
  var e = Lc(n, "string");
  return typeof e == "symbol" ? e : String(e);
}
var Da = typeof global < "u" && {}.toString.call(global) === "[object global]";
function Zn(n, e) {
  return n.indexOf(e.toLowerCase()) === 0 ? n : "".concat(e.toLowerCase()).concat(n.substr(0, 1).toUpperCase()).concat(n.substr(1));
}
function Cc(n) {
  return !!(n && n.nodeType === 1 && "nodeName" in n && n.ownerDocument && n.ownerDocument.defaultView);
}
function Mc(n) {
  return !isNaN(parseFloat(n)) && isFinite(n) && Math.floor(n) == n;
}
function ot(n) {
  return /^(https?:)?\/\/((((player|www)\.)?vimeo\.com)|((player\.)?[a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))(?=$|\/)/.test(n);
}
function Fa(n) {
  var e = /^https:\/\/player\.((vimeo\.com)|([a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))\/video\/\d+/;
  return e.test(n);
}
function Ec(n) {
  for (var e = (n || "").match(/^(?:https?:)?(?:\/\/)?([^/?]+)/), t = (e && e[1] || "").replace("player.", ""), a = [".videoji.hk", ".vimeo.work", ".videoji.cn"], r = 0, s = a; r < s.length; r++) {
    var i = s[r];
    if (t.endsWith(i))
      return t;
  }
  return "vimeo.com";
}
function Ha() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = n.id, t = n.url, a = e || t;
  if (!a)
    throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
  if (Mc(a))
    return "https://vimeo.com/".concat(a);
  if (ot(a))
    return a.replace("http:", "https:");
  throw e ? new TypeError("“".concat(e, "” is not a valid video id.")) : new TypeError("“".concat(a, "” is not a vimeo.com url."));
}
var Jn = function(e, t, a) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "addEventListener", s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "removeEventListener", i = typeof t == "string" ? [t] : t;
  return i.forEach(function(o) {
    e[r](o, a);
  }), {
    cancel: function() {
      return i.forEach(function(u) {
        return e[s](u, a);
      });
    }
  };
}, Nc = typeof Array.prototype.indexOf < "u", Ac = typeof window < "u" && typeof window.postMessage < "u";
if (!Da && (!Nc || !Ac))
  throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
var ct = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function xc(n, e) {
  return e = { exports: {} }, n(e, e.exports), e.exports;
}
/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */
(function(n) {
  if (n.WeakMap)
    return;
  var e = Object.prototype.hasOwnProperty, t = Object.defineProperty && function() {
    try {
      return Object.defineProperty({}, "x", {
        value: 1
      }).x === 1;
    } catch {
    }
  }(), a = function(s, i, o) {
    t ? Object.defineProperty(s, i, {
      configurable: !0,
      writable: !0,
      value: o
    }) : s[i] = o;
  };
  n.WeakMap = function() {
    function s() {
      if (this === void 0)
        throw new TypeError("Constructor WeakMap requires 'new'");
      if (a(this, "_id", o("_WeakMap")), arguments.length > 0)
        throw new TypeError("WeakMap iterable is not supported");
    }
    a(s.prototype, "delete", function(l) {
      if (i(this, "delete"), !r(l))
        return !1;
      var f = l[this._id];
      return f && f[0] === l ? (delete l[this._id], !0) : !1;
    }), a(s.prototype, "get", function(l) {
      if (i(this, "get"), !!r(l)) {
        var f = l[this._id];
        if (f && f[0] === l)
          return f[1];
      }
    }), a(s.prototype, "has", function(l) {
      if (i(this, "has"), !r(l))
        return !1;
      var f = l[this._id];
      return !!(f && f[0] === l);
    }), a(s.prototype, "set", function(l, f) {
      if (i(this, "set"), !r(l))
        throw new TypeError("Invalid value used as weak map key");
      var v = l[this._id];
      return v && v[0] === l ? (v[1] = f, this) : (a(l, this._id, [l, f]), this);
    });
    function i(l, f) {
      if (!r(l) || !e.call(l, "_id"))
        throw new TypeError(f + " method called on incompatible receiver " + typeof l);
    }
    function o(l) {
      return l + "_" + u() + "." + u();
    }
    function u() {
      return Math.random().toString().substring(2);
    }
    return a(s, "_polyfill", !0), s;
  }();
  function r(s) {
    return Object(s) === s;
  }
})(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : ct);
var Ne = xc(function(n) {
  /*! Native Promise Only
      v0.8.1 (c) Kyle Simpson
      MIT License: http://getify.mit-license.org
  */
  (function(t, a, r) {
    a[t] = a[t] || r(), n.exports && (n.exports = a[t]);
  })("Promise", ct, function() {
    var t, a, r, s = Object.prototype.toString, i = typeof setImmediate < "u" ? function(T) {
      return setImmediate(T);
    } : setTimeout;
    try {
      Object.defineProperty({}, "x", {}), t = function(T, g, C, $) {
        return Object.defineProperty(T, g, {
          value: C,
          writable: !0,
          configurable: $ !== !1
        });
      };
    } catch {
      t = function(g, C, $) {
        return g[C] = $, g;
      };
    }
    r = /* @__PURE__ */ function() {
      var T, g, C;
      function $(k, y) {
        this.fn = k, this.self = y, this.next = void 0;
      }
      return {
        add: function(y, N) {
          C = new $(y, N), g ? g.next = C : T = C, g = C, C = void 0;
        },
        drain: function() {
          var y = T;
          for (T = g = a = void 0; y; )
            y.fn.call(y.self), y = y.next;
        }
      };
    }();
    function o(E, T) {
      r.add(E, T), a || (a = i(r.drain));
    }
    function u(E) {
      var T, g = typeof E;
      return E != null && (g == "object" || g == "function") && (T = E.then), typeof T == "function" ? T : !1;
    }
    function l() {
      for (var E = 0; E < this.chain.length; E++)
        f(this, this.state === 1 ? this.chain[E].success : this.chain[E].failure, this.chain[E]);
      this.chain.length = 0;
    }
    function f(E, T, g) {
      var C, $;
      try {
        T === !1 ? g.reject(E.msg) : (T === !0 ? C = E.msg : C = T.call(void 0, E.msg), C === g.promise ? g.reject(TypeError("Promise-chain cycle")) : ($ = u(C)) ? $.call(C, g.resolve, g.reject) : g.resolve(C));
      } catch (k) {
        g.reject(k);
      }
    }
    function v(E) {
      var T, g = this;
      if (!g.triggered) {
        g.triggered = !0, g.def && (g = g.def);
        try {
          (T = u(E)) ? o(function() {
            var C = new p(g);
            try {
              T.call(E, function() {
                v.apply(C, arguments);
              }, function() {
                d.apply(C, arguments);
              });
            } catch ($) {
              d.call(C, $);
            }
          }) : (g.msg = E, g.state = 1, g.chain.length > 0 && o(l, g));
        } catch (C) {
          d.call(new p(g), C);
        }
      }
    }
    function d(E) {
      var T = this;
      T.triggered || (T.triggered = !0, T.def && (T = T.def), T.msg = E, T.state = 2, T.chain.length > 0 && o(l, T));
    }
    function m(E, T, g, C) {
      for (var $ = 0; $ < T.length; $++)
        (function(y) {
          E.resolve(T[y]).then(function(F) {
            g(y, F);
          }, C);
        })($);
    }
    function p(E) {
      this.def = E, this.triggered = !1;
    }
    function L(E) {
      this.promise = E, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
    }
    function x(E) {
      if (typeof E != "function")
        throw TypeError("Not a function");
      if (this.__NPO__ !== 0)
        throw TypeError("Not a promise");
      this.__NPO__ = 1;
      var T = new L(this);
      this.then = function(C, $) {
        var k = {
          success: typeof C == "function" ? C : !0,
          failure: typeof $ == "function" ? $ : !1
        };
        return k.promise = new this.constructor(function(N, F) {
          if (typeof N != "function" || typeof F != "function")
            throw TypeError("Not a function");
          k.resolve = N, k.reject = F;
        }), T.chain.push(k), T.state !== 0 && o(l, T), k.promise;
      }, this.catch = function(C) {
        return this.then(void 0, C);
      };
      try {
        E.call(void 0, function(C) {
          v.call(T, C);
        }, function(C) {
          d.call(T, C);
        });
      } catch (g) {
        d.call(T, g);
      }
    }
    var D = t(
      {},
      "constructor",
      x,
      /*configurable=*/
      !1
    );
    return x.prototype = D, t(
      D,
      "__NPO__",
      0,
      /*configurable=*/
      !1
    ), t(x, "resolve", function(T) {
      var g = this;
      return T && typeof T == "object" && T.__NPO__ === 1 ? T : new g(function($, k) {
        if (typeof $ != "function" || typeof k != "function")
          throw TypeError("Not a function");
        $(T);
      });
    }), t(x, "reject", function(T) {
      return new this(function(C, $) {
        if (typeof C != "function" || typeof $ != "function")
          throw TypeError("Not a function");
        $(T);
      });
    }), t(x, "all", function(T) {
      var g = this;
      return s.call(T) != "[object Array]" ? g.reject(TypeError("Not an array")) : T.length === 0 ? g.resolve([]) : new g(function($, k) {
        if (typeof $ != "function" || typeof k != "function")
          throw TypeError("Not a function");
        var y = T.length, N = Array(y), F = 0;
        m(g, T, function(h, _) {
          N[h] = _, ++F === y && $(N);
        }, k);
      });
    }), t(x, "race", function(T) {
      var g = this;
      return s.call(T) != "[object Array]" ? g.reject(TypeError("Not an array")) : new g(function($, k) {
        if (typeof $ != "function" || typeof k != "function")
          throw TypeError("Not a function");
        m(g, T, function(N, F) {
          $(F);
        }, k);
      });
    }), x;
  });
}), Ye = /* @__PURE__ */ new WeakMap();
function kt(n, e, t) {
  var a = Ye.get(n.element) || {};
  e in a || (a[e] = []), a[e].push(t), Ye.set(n.element, a);
}
function Rt(n, e) {
  var t = Ye.get(n.element) || {};
  return t[e] || [];
}
function Vt(n, e, t) {
  var a = Ye.get(n.element) || {};
  if (!a[e])
    return !0;
  if (!t)
    return a[e] = [], Ye.set(n.element, a), !0;
  var r = a[e].indexOf(t);
  return r !== -1 && a[e].splice(r, 1), Ye.set(n.element, a), a[e] && a[e].length === 0;
}
function Bc(n, e) {
  var t = Rt(n, e);
  if (t.length < 1)
    return !1;
  var a = t.shift();
  return Vt(n, e, a), a;
}
function Oc(n, e) {
  var t = Ye.get(n);
  Ye.set(e, t), Ye.delete(n);
}
function Gt(n) {
  if (typeof n == "string")
    try {
      n = JSON.parse(n);
    } catch (e) {
      return console.warn(e), {};
    }
  return n;
}
function tt(n, e, t) {
  if (!(!n.element.contentWindow || !n.element.contentWindow.postMessage)) {
    var a = {
      method: e
    };
    t !== void 0 && (a.value = t);
    var r = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
    r >= 8 && r < 10 && (a = JSON.stringify(a)), n.element.contentWindow.postMessage(a, n.origin);
  }
}
function Dc(n, e) {
  e = Gt(e);
  var t = [], a;
  if (e.event) {
    if (e.event === "error") {
      var r = Rt(n, e.data.method);
      r.forEach(function(i) {
        var o = new Error(e.data.message);
        o.name = e.data.name, i.reject(o), Vt(n, e.data.method, i);
      });
    }
    t = Rt(n, "event:".concat(e.event)), a = e.data;
  } else if (e.method) {
    var s = Bc(n, e.method);
    s && (t.push(s), a = e.value);
  }
  t.forEach(function(i) {
    try {
      if (typeof i == "function") {
        i.call(n, a);
        return;
      }
      i.resolve(a);
    } catch {
    }
  });
}
var Fc = ["airplay", "audio_tracks", "audiotrack", "autopause", "autoplay", "background", "byline", "cc", "chapter_id", "chapters", "chromecast", "color", "colors", "controls", "dnt", "end_time", "fullscreen", "height", "id", "interactive_params", "keyboard", "loop", "maxheight", "maxwidth", "muted", "play_button_position", "playsinline", "portrait", "progress_bar", "quality_selector", "responsive", "speed", "start_time", "texttrack", "title", "transcript", "transparent", "unmute_button", "url", "vimeo_logo", "volume", "watch_full_video", "width"];
function za(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return Fc.reduce(function(t, a) {
    var r = n.getAttribute("data-vimeo-".concat(a));
    return (r || r === "") && (t[a] = r === "" ? 1 : r), t;
  }, e);
}
function Sn(n, e) {
  var t = n.html;
  if (!e)
    throw new TypeError("An element must be provided");
  if (e.getAttribute("data-vimeo-initialized") !== null)
    return e.querySelector("iframe");
  var a = document.createElement("div");
  return a.innerHTML = t, e.appendChild(a.firstChild), e.setAttribute("data-vimeo-initialized", "true"), e.querySelector("iframe");
}
function Ra(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = arguments.length > 2 ? arguments[2] : void 0;
  return new Promise(function(a, r) {
    if (!ot(n))
      throw new TypeError("“".concat(n, "” is not a vimeo.com url."));
    var s = Ec(n), i = "https://".concat(s, "/api/oembed.json?url=").concat(encodeURIComponent(n));
    for (var o in e)
      e.hasOwnProperty(o) && (i += "&".concat(o, "=").concat(encodeURIComponent(e[o])));
    var u = "XDomainRequest" in window ? new XDomainRequest() : new XMLHttpRequest();
    u.open("GET", i, !0), u.onload = function() {
      if (u.status === 404) {
        r(new Error("“".concat(n, "” was not found.")));
        return;
      }
      if (u.status === 403) {
        r(new Error("“".concat(n, "” is not embeddable.")));
        return;
      }
      try {
        var l = JSON.parse(u.responseText);
        if (l.domain_status_code === 403) {
          Sn(l, t), r(new Error("“".concat(n, "” is not embeddable.")));
          return;
        }
        a(l);
      } catch (f) {
        r(f);
      }
    }, u.onerror = function() {
      var l = u.status ? " (".concat(u.status, ")") : "";
      r(new Error("There was an error fetching the embed code from Vimeo".concat(l, ".")));
    }, u.send();
  });
}
function Hc() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document, e = [].slice.call(n.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")), t = function(r) {
    "console" in window && console.error && console.error("There was an error creating an embed: ".concat(r));
  };
  e.forEach(function(a) {
    try {
      if (a.getAttribute("data-vimeo-defer") !== null)
        return;
      var r = za(a), s = Ha(r);
      Ra(s, r, a).then(function(i) {
        return Sn(i, a);
      }).catch(t);
    } catch (i) {
      t(i);
    }
  });
}
function zc() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoPlayerResizeEmbeds_) {
    window.VimeoPlayerResizeEmbeds_ = !0;
    var e = function(a) {
      if (ot(a.origin) && !(!a.data || a.data.event !== "spacechange")) {
        for (var r = n.querySelectorAll("iframe"), s = 0; s < r.length; s++)
          if (r[s].contentWindow === a.source) {
            var i = r[s].parentElement;
            i.style.paddingBottom = "".concat(a.data.data[0].bottom, "px");
            break;
          }
      }
    };
    window.addEventListener("message", e);
  }
}
function Rc() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoSeoMetadataAppended) {
    window.VimeoSeoMetadataAppended = !0;
    var e = function(a) {
      if (ot(a.origin)) {
        var r = Gt(a.data);
        if (!(!r || r.event !== "ready"))
          for (var s = n.querySelectorAll("iframe"), i = 0; i < s.length; i++) {
            var o = s[i], u = o.contentWindow === a.source;
            if (Fa(o.src) && u) {
              var l = new Pn(o);
              l.callMethod("appendVideoMetadata", window.location.href);
            }
          }
      }
    };
    window.addEventListener("message", e);
  }
}
function Vc() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoCheckedUrlTimeParam) {
    window.VimeoCheckedUrlTimeParam = !0;
    var e = function(r) {
      "console" in window && console.error && console.error("There was an error getting video Id: ".concat(r));
    }, t = function(r) {
      if (ot(r.origin)) {
        var s = Gt(r.data);
        if (!(!s || s.event !== "ready"))
          for (var i = n.querySelectorAll("iframe"), o = function() {
            var f = i[u], v = f.contentWindow === r.source;
            if (Fa(f.src) && v) {
              var d = new Pn(f);
              d.getVideoId().then(function(m) {
                var p = new RegExp("[?&]vimeo_t_".concat(m, "=([^&#]*)")).exec(window.location.href);
                if (p && p[1]) {
                  var L = decodeURI(p[1]);
                  d.setCurrentTime(L);
                }
              }).catch(e);
            }
          }, u = 0; u < i.length; u++)
            o();
      }
    };
    window.addEventListener("message", t);
  }
}
function qc() {
  var n = function() {
    for (var a, r = [
      ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"],
      // New WebKit
      ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"],
      // Old WebKit
      ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"],
      ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"],
      ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]
    ], s = 0, i = r.length, o = {}; s < i; s++)
      if (a = r[s], a && a[1] in document) {
        for (s = 0; s < a.length; s++)
          o[r[0][s]] = a[s];
        return o;
      }
    return !1;
  }(), e = {
    fullscreenchange: n.fullscreenchange,
    fullscreenerror: n.fullscreenerror
  }, t = {
    request: function(r) {
      return new Promise(function(s, i) {
        var o = function l() {
          t.off("fullscreenchange", l), s();
        };
        t.on("fullscreenchange", o), r = r || document.documentElement;
        var u = r[n.requestFullscreen]();
        u instanceof Promise && u.then(o).catch(i);
      });
    },
    exit: function() {
      return new Promise(function(r, s) {
        if (!t.isFullscreen) {
          r();
          return;
        }
        var i = function u() {
          t.off("fullscreenchange", u), r();
        };
        t.on("fullscreenchange", i);
        var o = document[n.exitFullscreen]();
        o instanceof Promise && o.then(i).catch(s);
      });
    },
    on: function(r, s) {
      var i = e[r];
      i && document.addEventListener(i, s);
    },
    off: function(r, s) {
      var i = e[r];
      i && document.removeEventListener(i, s);
    }
  };
  return Object.defineProperties(t, {
    isFullscreen: {
      get: function() {
        return !!document[n.fullscreenElement];
      }
    },
    element: {
      enumerable: !0,
      get: function() {
        return document[n.fullscreenElement];
      }
    },
    isEnabled: {
      enumerable: !0,
      get: function() {
        return !!document[n.fullscreenEnabled];
      }
    }
  }), t;
}
var jc = {
  role: "viewer",
  autoPlayMuted: !0,
  allowedDrift: 0.3,
  maxAllowedDrift: 1,
  minCheckInterval: 0.1,
  maxRateAdjustment: 0.2,
  maxTimeToCatchUp: 1
}, Wc = /* @__PURE__ */ function(n) {
  Ic(t, n);
  var e = Pc(t);
  function t(a, r) {
    var s, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = arguments.length > 3 ? arguments[3] : void 0;
    return Aa(this, t), s = e.call(this), Bt(Dt(s), "logger", void 0), Bt(Dt(s), "speedAdjustment", 0), Bt(Dt(s), "adjustSpeed", /* @__PURE__ */ function() {
      var u = nt(/* @__PURE__ */ we().mark(function l(f, v) {
        var d;
        return we().wrap(function(p) {
          for (; ; ) switch (p.prev = p.next) {
            case 0:
              if (s.speedAdjustment !== v) {
                p.next = 2;
                break;
              }
              return p.abrupt("return");
            case 2:
              return p.next = 4, f.getPlaybackRate();
            case 4:
              return p.t0 = p.sent, p.t1 = s.speedAdjustment, p.t2 = p.t0 - p.t1, p.t3 = v, d = p.t2 + p.t3, s.log("New playbackRate:  ".concat(d)), p.next = 12, f.setPlaybackRate(d);
            case 12:
              s.speedAdjustment = v;
            case 13:
            case "end":
              return p.stop();
          }
        }, l);
      }));
      return function(l, f) {
        return u.apply(this, arguments);
      };
    }()), s.logger = o, s.init(r, a, Yn(Yn({}, jc), i)), s;
  }
  return xa(t, [{
    key: "disconnect",
    value: function() {
      this.dispatchEvent(new Event("disconnect"));
    }
    /**
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "init",
    value: function() {
      var a = nt(/* @__PURE__ */ we().mark(function s(i, o, u) {
        var l = this, f, v, d;
        return we().wrap(function(p) {
          for (; ; ) switch (p.prev = p.next) {
            case 0:
              return p.next = 2, this.waitForTOReadyState(i, "open");
            case 2:
              if (u.role !== "viewer") {
                p.next = 10;
                break;
              }
              return p.next = 5, this.updatePlayer(i, o, u);
            case 5:
              f = Jn(i, "change", function() {
                return l.updatePlayer(i, o, u);
              }), v = this.maintainPlaybackPosition(i, o, u), this.addEventListener("disconnect", function() {
                v.cancel(), f.cancel();
              }), p.next = 14;
              break;
            case 10:
              return p.next = 12, this.updateTimingObject(i, o);
            case 12:
              d = Jn(o, ["seeked", "play", "pause", "ratechange"], function() {
                return l.updateTimingObject(i, o);
              }, "on", "off"), this.addEventListener("disconnect", function() {
                return d.cancel();
              });
            case 14:
            case "end":
              return p.stop();
          }
        }, s, this);
      }));
      function r(s, i, o) {
        return a.apply(this, arguments);
      }
      return r;
    }()
    /**
     * Sets the TimingObject's state to reflect that of the player
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @return {Promise<void>}
     */
  }, {
    key: "updateTimingObject",
    value: function() {
      var a = nt(/* @__PURE__ */ we().mark(function s(i, o) {
        return we().wrap(function(l) {
          for (; ; ) switch (l.prev = l.next) {
            case 0:
              return l.t0 = i, l.next = 3, o.getCurrentTime();
            case 3:
              return l.t1 = l.sent, l.next = 6, o.getPaused();
            case 6:
              if (!l.sent) {
                l.next = 10;
                break;
              }
              l.t2 = 0, l.next = 13;
              break;
            case 10:
              return l.next = 12, o.getPlaybackRate();
            case 12:
              l.t2 = l.sent;
            case 13:
              l.t3 = l.t2, l.t4 = {
                position: l.t1,
                velocity: l.t3
              }, l.t0.update.call(l.t0, l.t4);
            case 16:
            case "end":
              return l.stop();
          }
        }, s);
      }));
      function r(s, i) {
        return a.apply(this, arguments);
      }
      return r;
    }()
    /**
     * Sets the player's timing state to reflect that of the TimingObject
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "updatePlayer",
    value: function() {
      var a = nt(/* @__PURE__ */ we().mark(function s(i, o, u) {
        var l, f, v;
        return we().wrap(function(m) {
          for (; ; ) switch (m.prev = m.next) {
            case 0:
              if (l = i.query(), f = l.position, v = l.velocity, typeof f == "number" && o.setCurrentTime(f), typeof v != "number") {
                m.next = 25;
                break;
              }
              if (v !== 0) {
                m.next = 11;
                break;
              }
              return m.next = 6, o.getPaused();
            case 6:
              if (m.t0 = m.sent, m.t0 !== !1) {
                m.next = 9;
                break;
              }
              o.pause();
            case 9:
              m.next = 25;
              break;
            case 11:
              if (!(v > 0)) {
                m.next = 25;
                break;
              }
              return m.next = 14, o.getPaused();
            case 14:
              if (m.t1 = m.sent, m.t1 !== !0) {
                m.next = 19;
                break;
              }
              return m.next = 18, o.play().catch(/* @__PURE__ */ function() {
                var p = nt(/* @__PURE__ */ we().mark(function L(x) {
                  return we().wrap(function(E) {
                    for (; ; ) switch (E.prev = E.next) {
                      case 0:
                        if (!(x.name === "NotAllowedError" && u.autoPlayMuted)) {
                          E.next = 5;
                          break;
                        }
                        return E.next = 3, o.setMuted(!0);
                      case 3:
                        return E.next = 5, o.play().catch(function(T) {
                          return console.error("Couldn't play the video from TimingSrcConnector. Error:", T);
                        });
                      case 5:
                      case "end":
                        return E.stop();
                    }
                  }, L);
                }));
                return function(L) {
                  return p.apply(this, arguments);
                };
              }());
            case 18:
              this.updatePlayer(i, o, u);
            case 19:
              return m.next = 21, o.getPlaybackRate();
            case 21:
              if (m.t2 = m.sent, m.t3 = v, m.t2 === m.t3) {
                m.next = 25;
                break;
              }
              o.setPlaybackRate(v);
            case 25:
            case "end":
              return m.stop();
          }
        }, s, this);
      }));
      function r(s, i, o) {
        return a.apply(this, arguments);
      }
      return r;
    }()
    /**
     * Since video players do not play with 100% time precision, we need to closely monitor
     * our player to be sure it remains in sync with the TimingObject.
     *
     * If out of sync, we use the current conditions and the options provided to determine
     * whether to re-sync via setting currentTime or adjusting the playbackRate
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {{cancel: (function(): void)}}
     */
  }, {
    key: "maintainPlaybackPosition",
    value: function(r, s, i) {
      var o = this, u = i.allowedDrift, l = i.maxAllowedDrift, f = i.minCheckInterval, v = i.maxRateAdjustment, d = i.maxTimeToCatchUp, m = Math.min(d, Math.max(f, l)) * 1e3, p = /* @__PURE__ */ function() {
        var x = nt(/* @__PURE__ */ we().mark(function D() {
          var E, T, g, C, $;
          return we().wrap(function(y) {
            for (; ; ) switch (y.prev = y.next) {
              case 0:
                if (y.t0 = r.query().velocity === 0, y.t0) {
                  y.next = 6;
                  break;
                }
                return y.next = 4, s.getPaused();
              case 4:
                y.t1 = y.sent, y.t0 = y.t1 === !0;
              case 6:
                if (!y.t0) {
                  y.next = 8;
                  break;
                }
                return y.abrupt("return");
              case 8:
                return y.t2 = r.query().position, y.next = 11, s.getCurrentTime();
              case 11:
                if (y.t3 = y.sent, E = y.t2 - y.t3, T = Math.abs(E), o.log("Drift: ".concat(E)), !(T > l)) {
                  y.next = 22;
                  break;
                }
                return y.next = 18, o.adjustSpeed(s, 0);
              case 18:
                s.setCurrentTime(r.query().position), o.log("Resync by currentTime"), y.next = 29;
                break;
              case 22:
                if (!(T > u)) {
                  y.next = 29;
                  break;
                }
                return g = T / d, C = v, $ = g < C ? (C - g) / 2 : C, y.next = 28, o.adjustSpeed(s, $ * Math.sign(E));
              case 28:
                o.log("Resync by playbackRate");
              case 29:
              case "end":
                return y.stop();
            }
          }, D);
        }));
        return function() {
          return x.apply(this, arguments);
        };
      }(), L = setInterval(function() {
        return p();
      }, m);
      return {
        cancel: function() {
          return clearInterval(L);
        }
      };
    }
    /**
     * @param {string} msg
     */
  }, {
    key: "log",
    value: function(r) {
      var s;
      (s = this.logger) === null || s === void 0 || s.call(this, "TimingSrcConnector: ".concat(r));
    }
  }, {
    key: "waitForTOReadyState",
    value: (
      /**
       * @param {TimingObject} timingObject
       * @param {TConnectionState} state
       * @return {Promise<void>}
       */
      function(r, s) {
        return new Promise(function(i) {
          var o = function u() {
            r.readyState === s ? i() : r.addEventListener("readystatechange", u, {
              once: !0
            });
          };
          o();
        });
      }
    )
  }]), t;
}(/* @__PURE__ */ sn(EventTarget)), it = /* @__PURE__ */ new WeakMap(), Jt = /* @__PURE__ */ new WeakMap(), $e = {}, Pn = /* @__PURE__ */ function() {
  function n(e) {
    var t = this, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (Aa(this, n), window.jQuery && e instanceof jQuery && (e.length > 1 && window.console && console.warn && console.warn("A jQuery object with multiple elements was passed, using the first element."), e = e[0]), typeof document < "u" && typeof e == "string" && (e = document.getElementById(e)), !Cc(e))
      throw new TypeError("You must pass either a valid element or a valid id.");
    if (e.nodeName !== "IFRAME") {
      var r = e.querySelector("iframe");
      r && (e = r);
    }
    if (e.nodeName === "IFRAME" && !ot(e.getAttribute("src") || ""))
      throw new Error("The player element passed isn’t a Vimeo embed.");
    if (it.has(e))
      return it.get(e);
    this._window = e.ownerDocument.defaultView, this.element = e, this.origin = "*";
    var s = new Ne(function(o, u) {
      if (t._onMessage = function(v) {
        if (!(!ot(v.origin) || t.element.contentWindow !== v.source)) {
          t.origin === "*" && (t.origin = v.origin);
          var d = Gt(v.data), m = d && d.event === "error", p = m && d.data && d.data.method === "ready";
          if (p) {
            var L = new Error(d.data.message);
            L.name = d.data.name, u(L);
            return;
          }
          var x = d && d.event === "ready", D = d && d.method === "ping";
          if (x || D) {
            t.element.setAttribute("data-ready", "true"), o();
            return;
          }
          Dc(t, d);
        }
      }, t._window.addEventListener("message", t._onMessage), t.element.nodeName !== "IFRAME") {
        var l = za(e, a), f = Ha(l);
        Ra(f, l, e).then(function(v) {
          var d = Sn(v, e);
          return t.element = d, t._originalElement = e, Oc(e, d), it.set(t.element, t), v;
        }).catch(u);
      }
    });
    if (Jt.set(this, s), it.set(this.element, this), this.element.nodeName === "IFRAME" && tt(this, "ping"), $e.isEnabled) {
      var i = function() {
        return $e.exit();
      };
      this.fullscreenchangeHandler = function() {
        $e.isFullscreen ? kt(t, "event:exitFullscreen", i) : Vt(t, "event:exitFullscreen", i), t.ready().then(function() {
          tt(t, "fullscreenchange", $e.isFullscreen);
        });
      }, $e.on("fullscreenchange", this.fullscreenchangeHandler);
    }
    return this;
  }
  return xa(n, [{
    key: "callMethod",
    value: function(t) {
      var a = this, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return new Ne(function(s, i) {
        return a.ready().then(function() {
          kt(a, t, {
            resolve: s,
            reject: i
          }), tt(a, t, r);
        }).catch(i);
      });
    }
    /**
     * Get a promise for the value of a player property.
     *
     * @param {string} name The property name
     * @return {Promise}
     */
  }, {
    key: "get",
    value: function(t) {
      var a = this;
      return new Ne(function(r, s) {
        return t = Zn(t, "get"), a.ready().then(function() {
          kt(a, t, {
            resolve: r,
            reject: s
          }), tt(a, t);
        }).catch(s);
      });
    }
    /**
     * Get a promise for setting the value of a player property.
     *
     * @param {string} name The API method to call.
     * @param {mixed} value The value to set.
     * @return {Promise}
     */
  }, {
    key: "set",
    value: function(t, a) {
      var r = this;
      return new Ne(function(s, i) {
        if (t = Zn(t, "set"), a == null)
          throw new TypeError("There must be a value to set.");
        return r.ready().then(function() {
          kt(r, t, {
            resolve: s,
            reject: i
          }), tt(r, t, a);
        }).catch(i);
      });
    }
    /**
     * Add an event listener for the specified event. Will call the
     * callback with a single parameter, `data`, that contains the data for
     * that event.
     *
     * @param {string} eventName The name of the event.
     * @param {function(*)} callback The function to call when the event fires.
     * @return {void}
     */
  }, {
    key: "on",
    value: function(t, a) {
      if (!t)
        throw new TypeError("You must pass an event name.");
      if (!a)
        throw new TypeError("You must pass a callback function.");
      if (typeof a != "function")
        throw new TypeError("The callback must be a function.");
      var r = Rt(this, "event:".concat(t));
      r.length === 0 && this.callMethod("addEventListener", t).catch(function() {
      }), kt(this, "event:".concat(t), a);
    }
    /**
     * Remove an event listener for the specified event. Will remove all
     * listeners for that event if a `callback` isn’t passed, or only that
     * specific callback if it is passed.
     *
     * @param {string} eventName The name of the event.
     * @param {function} [callback] The specific callback to remove.
     * @return {void}
     */
  }, {
    key: "off",
    value: function(t, a) {
      if (!t)
        throw new TypeError("You must pass an event name.");
      if (a && typeof a != "function")
        throw new TypeError("The callback must be a function.");
      var r = Vt(this, "event:".concat(t), a);
      r && this.callMethod("removeEventListener", t).catch(function(s) {
      });
    }
    /**
     * A promise to load a new video.
     *
     * @promise LoadVideoPromise
     * @fulfill {number} The video with this id or url successfully loaded.
     * @reject {TypeError} The id was not a number.
     */
    /**
     * Load a new video into this embed. The promise will be resolved if
     * the video is successfully loaded, or it will be rejected if it could
     * not be loaded.
     *
     * @param {number|string|object} options The id of the video, the url of the video, or an object with embed options.
     * @return {LoadVideoPromise}
     */
  }, {
    key: "loadVideo",
    value: function(t) {
      return this.callMethod("loadVideo", t);
    }
    /**
     * A promise to perform an action when the Player is ready.
     *
     * @todo document errors
     * @promise LoadVideoPromise
     * @fulfill {void}
     */
    /**
     * Trigger a function when the player iframe has initialized. You do not
     * need to wait for `ready` to trigger to begin adding event listeners
     * or calling other methods.
     *
     * @return {ReadyPromise}
     */
  }, {
    key: "ready",
    value: function() {
      var t = Jt.get(this) || new Ne(function(a, r) {
        r(new Error("Unknown player. Probably unloaded."));
      });
      return Ne.resolve(t);
    }
    /**
     * A promise to add a cue point to the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point to use for removeCuePoint.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Add a cue point to the player.
     *
     * @param {number} time The time for the cue point.
     * @param {object} [data] Arbitrary data to be returned with the cue point.
     * @return {AddCuePointPromise}
     */
  }, {
    key: "addCuePoint",
    value: function(t) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this.callMethod("addCuePoint", {
        time: t,
        data: a
      });
    }
    /**
     * A promise to remove a cue point from the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point that was removed.
     * @reject {InvalidCuePoint} The cue point with the specified id was not
     *         found.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Remove a cue point from the video.
     *
     * @param {string} id The id of the cue point to remove.
     * @return {RemoveCuePointPromise}
     */
  }, {
    key: "removeCuePoint",
    value: function(t) {
      return this.callMethod("removeCuePoint", t);
    }
    /**
     * A representation of a text track on a video.
     *
     * @typedef {Object} VimeoTextTrack
     * @property {string} language The ISO language code.
     * @property {string} kind The kind of track it is (captions or subtitles).
     * @property {string} label The human‐readable label for the track.
     */
    /**
     * A promise to enable a text track.
     *
     * @promise EnableTextTrackPromise
     * @fulfill {VimeoTextTrack} The text track that was enabled.
     * @reject {InvalidTrackLanguageError} No track was available with the
     *         specified language.
     * @reject {InvalidTrackError} No track was available with the specified
     *         language and kind.
     */
    /**
     * Enable the text track with the specified language, and optionally the
     * specified kind (captions or subtitles).
     *
     * When set via the API, the track language will not change the viewer’s
     * stored preference.
     *
     * @param {string} language The two‐letter language code.
     * @param {string} [kind] The kind of track to enable (captions or subtitles).
     * @return {EnableTextTrackPromise}
     */
  }, {
    key: "enableTextTrack",
    value: function(t, a) {
      if (!t)
        throw new TypeError("You must pass a language.");
      return this.callMethod("enableTextTrack", {
        language: t,
        kind: a
      });
    }
    /**
     * A promise to disable the active text track.
     *
     * @promise DisableTextTrackPromise
     * @fulfill {void} The track was disabled.
     */
    /**
     * Disable the currently-active text track.
     *
     * @return {DisableTextTrackPromise}
     */
  }, {
    key: "disableTextTrack",
    value: function() {
      return this.callMethod("disableTextTrack");
    }
    /**
     * A promise to pause the video.
     *
     * @promise PausePromise
     * @fulfill {void} The video was paused.
     */
    /**
     * Pause the video if it’s playing.
     *
     * @return {PausePromise}
     */
  }, {
    key: "pause",
    value: function() {
      return this.callMethod("pause");
    }
    /**
     * A promise to play the video.
     *
     * @promise PlayPromise
     * @fulfill {void} The video was played.
     */
    /**
     * Play the video if it’s paused. **Note:** on iOS and some other
     * mobile devices, you cannot programmatically trigger play. Once the
     * viewer has tapped on the play button in the player, however, you
     * will be able to use this function.
     *
     * @return {PlayPromise}
     */
  }, {
    key: "play",
    value: function() {
      return this.callMethod("play");
    }
    /**
     * Request that the player enters fullscreen.
     * @return {Promise}
     */
  }, {
    key: "requestFullscreen",
    value: function() {
      return $e.isEnabled ? $e.request(this.element) : this.callMethod("requestFullscreen");
    }
    /**
     * Request that the player exits fullscreen.
     * @return {Promise}
     */
  }, {
    key: "exitFullscreen",
    value: function() {
      return $e.isEnabled ? $e.exit() : this.callMethod("exitFullscreen");
    }
    /**
     * Returns true if the player is currently fullscreen.
     * @return {Promise}
     */
  }, {
    key: "getFullscreen",
    value: function() {
      return $e.isEnabled ? Ne.resolve($e.isFullscreen) : this.get("fullscreen");
    }
    /**
     * Request that the player enters picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "requestPictureInPicture",
    value: function() {
      return this.callMethod("requestPictureInPicture");
    }
    /**
     * Request that the player exits picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "exitPictureInPicture",
    value: function() {
      return this.callMethod("exitPictureInPicture");
    }
    /**
     * Returns true if the player is currently picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "getPictureInPicture",
    value: function() {
      return this.get("pictureInPicture");
    }
    /**
     * A promise to prompt the viewer to initiate remote playback.
     *
     * @promise RemotePlaybackPromptPromise
     * @fulfill {void}
     * @reject {NotFoundError} No remote playback device is available.
     */
    /**
     * Request to prompt the user to initiate remote playback.
     *
     * @return {RemotePlaybackPromptPromise}
     */
  }, {
    key: "remotePlaybackPrompt",
    value: function() {
      return this.callMethod("remotePlaybackPrompt");
    }
    /**
     * A promise to unload the video.
     *
     * @promise UnloadPromise
     * @fulfill {void} The video was unloaded.
     */
    /**
     * Return the player to its initial state.
     *
     * @return {UnloadPromise}
     */
  }, {
    key: "unload",
    value: function() {
      return this.callMethod("unload");
    }
    /**
     * Cleanup the player and remove it from the DOM
     *
     * It won't be usable and a new one should be constructed
     *  in order to do any operations.
     *
     * @return {Promise}
     */
  }, {
    key: "destroy",
    value: function() {
      var t = this;
      return new Ne(function(a) {
        if (Jt.delete(t), it.delete(t.element), t._originalElement && (it.delete(t._originalElement), t._originalElement.removeAttribute("data-vimeo-initialized")), t.element && t.element.nodeName === "IFRAME" && t.element.parentNode && (t.element.parentNode.parentNode && t._originalElement && t._originalElement !== t.element.parentNode ? t.element.parentNode.parentNode.removeChild(t.element.parentNode) : t.element.parentNode.removeChild(t.element)), t.element && t.element.nodeName === "DIV" && t.element.parentNode) {
          t.element.removeAttribute("data-vimeo-initialized");
          var r = t.element.querySelector("iframe");
          r && r.parentNode && (r.parentNode.parentNode && t._originalElement && t._originalElement !== r.parentNode ? r.parentNode.parentNode.removeChild(r.parentNode) : r.parentNode.removeChild(r));
        }
        t._window.removeEventListener("message", t._onMessage), $e.isEnabled && $e.off("fullscreenchange", t.fullscreenchangeHandler), a();
      });
    }
    /**
     * A promise to get the autopause behavior of the video.
     *
     * @promise GetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Get the autopause behavior for this player.
     *
     * @return {GetAutopausePromise}
     */
  }, {
    key: "getAutopause",
    value: function() {
      return this.get("autopause");
    }
    /**
     * A promise to set the autopause behavior of the video.
     *
     * @promise SetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Enable or disable the autopause behavior of this player.
     *
     * By default, when another video is played in the same browser, this
     * player will automatically pause. Unless you have a specific reason
     * for doing so, we recommend that you leave autopause set to the
     * default (`true`).
     *
     * @param {boolean} autopause
     * @return {SetAutopausePromise}
     */
  }, {
    key: "setAutopause",
    value: function(t) {
      return this.set("autopause", t);
    }
    /**
     * A promise to get the buffered property of the video.
     *
     * @promise GetBufferedPromise
     * @fulfill {Array} Buffered Timeranges converted to an Array.
     */
    /**
     * Get the buffered property of the video.
     *
     * @return {GetBufferedPromise}
     */
  }, {
    key: "getBuffered",
    value: function() {
      return this.get("buffered");
    }
    /**
     * @typedef {Object} CameraProperties
     * @prop {number} props.yaw - Number between 0 and 360.
     * @prop {number} props.pitch - Number between -90 and 90.
     * @prop {number} props.roll - Number between -180 and 180.
     * @prop {number} props.fov - The field of view in degrees.
     */
    /**
     * A promise to get the camera properties of the player.
     *
     * @promise GetCameraPromise
     * @fulfill {CameraProperties} The camera properties.
     */
    /**
     * For 360° videos get the camera properties for this player.
     *
     * @return {GetCameraPromise}
     */
  }, {
    key: "getCameraProps",
    value: function() {
      return this.get("cameraProps");
    }
    /**
     * A promise to set the camera properties of the player.
     *
     * @promise SetCameraPromise
     * @fulfill {Object} The camera was successfully set.
     * @reject {RangeError} The range was out of bounds.
     */
    /**
     * For 360° videos set the camera properties for this player.
     *
     * @param {CameraProperties} camera The camera properties
     * @return {SetCameraPromise}
     */
  }, {
    key: "setCameraProps",
    value: function(t) {
      return this.set("cameraProps", t);
    }
    /**
     * A representation of a chapter.
     *
     * @typedef {Object} VimeoChapter
     * @property {number} startTime The start time of the chapter.
     * @property {object} title The title of the chapter.
     * @property {number} index The place in the order of Chapters. Starts at 1.
     */
    /**
     * A promise to get chapters for the video.
     *
     * @promise GetChaptersPromise
     * @fulfill {VimeoChapter[]} The chapters for the video.
     */
    /**
     * Get an array of all the chapters for the video.
     *
     * @return {GetChaptersPromise}
     */
  }, {
    key: "getChapters",
    value: function() {
      return this.get("chapters");
    }
    /**
     * A promise to get the currently active chapter.
     *
     * @promise GetCurrentChaptersPromise
     * @fulfill {VimeoChapter|undefined} The current chapter for the video.
     */
    /**
     * Get the currently active chapter for the video.
     *
     * @return {GetCurrentChaptersPromise}
     */
  }, {
    key: "getCurrentChapter",
    value: function() {
      return this.get("currentChapter");
    }
    /**
     * A promise to get the accent color of the player.
     *
     * @promise GetColorPromise
     * @fulfill {string} The hex color of the player.
     */
    /**
     * Get the accent color for this player. Note this is deprecated in place of `getColorTwo`.
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColor",
    value: function() {
      return this.get("color");
    }
    /**
     * A promise to get all colors for the player in an array.
     *
     * @promise GetColorsPromise
     * @fulfill {string[]} The hex colors of the player.
     */
    /**
     * Get all the colors for this player in an array: [colorOne, colorTwo, colorThree, colorFour]
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColors",
    value: function() {
      return Ne.all([this.get("colorOne"), this.get("colorTwo"), this.get("colorThree"), this.get("colorFour")]);
    }
    /**
     * A promise to set the accent color of the player.
     *
     * @promise SetColorPromise
     * @fulfill {string} The color was successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the accent color of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * Note this is deprecated in place of `setColorTwo`.
     *
     * @param {string} color The hex or rgb color string to set.
     * @return {SetColorPromise}
     */
  }, {
    key: "setColor",
    value: function(t) {
      return this.set("color", t);
    }
    /**
     * A promise to set all colors for the player.
     *
     * @promise SetColorsPromise
     * @fulfill {string[]} The colors were successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the colors of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * The colors should be passed in as an array: [colorOne, colorTwo, colorThree, colorFour].
     * If a color should not be set, the index in the array can be left as null.
     *
     * @param {string[]} colors Array of the hex or rgb color strings to set.
     * @return {SetColorsPromise}
     */
  }, {
    key: "setColors",
    value: function(t) {
      if (!Array.isArray(t))
        return new Ne(function(s, i) {
          return i(new TypeError("Argument must be an array."));
        });
      var a = new Ne(function(s) {
        return s(null);
      }), r = [t[0] ? this.set("colorOne", t[0]) : a, t[1] ? this.set("colorTwo", t[1]) : a, t[2] ? this.set("colorThree", t[2]) : a, t[3] ? this.set("colorFour", t[3]) : a];
      return Ne.all(r);
    }
    /**
     * A representation of a cue point.
     *
     * @typedef {Object} VimeoCuePoint
     * @property {number} time The time of the cue point.
     * @property {object} data The data passed when adding the cue point.
     * @property {string} id The unique id for use with removeCuePoint.
     */
    /**
     * A promise to get the cue points of a video.
     *
     * @promise GetCuePointsPromise
     * @fulfill {VimeoCuePoint[]} The cue points added to the video.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Get an array of the cue points added to the video.
     *
     * @return {GetCuePointsPromise}
     */
  }, {
    key: "getCuePoints",
    value: function() {
      return this.get("cuePoints");
    }
    /**
     * A promise to get the current time of the video.
     *
     * @promise GetCurrentTimePromise
     * @fulfill {number} The current time in seconds.
     */
    /**
     * Get the current playback position in seconds.
     *
     * @return {GetCurrentTimePromise}
     */
  }, {
    key: "getCurrentTime",
    value: function() {
      return this.get("currentTime");
    }
    /**
     * A promise to set the current time of the video.
     *
     * @promise SetCurrentTimePromise
     * @fulfill {number} The actual current time that was set.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     */
    /**
     * Set the current playback position in seconds. If the player was
     * paused, it will remain paused. Likewise, if the player was playing,
     * it will resume playing once the video has buffered.
     *
     * You can provide an accurate time and the player will attempt to seek
     * to as close to that time as possible. The exact time will be the
     * fulfilled value of the promise.
     *
     * @param {number} currentTime
     * @return {SetCurrentTimePromise}
     */
  }, {
    key: "setCurrentTime",
    value: function(t) {
      return this.set("currentTime", t);
    }
    /**
     * A promise to get the duration of the video.
     *
     * @promise GetDurationPromise
     * @fulfill {number} The duration in seconds.
     */
    /**
     * Get the duration of the video in seconds. It will be rounded to the
     * nearest second before playback begins, and to the nearest thousandth
     * of a second after playback begins.
     *
     * @return {GetDurationPromise}
     */
  }, {
    key: "getDuration",
    value: function() {
      return this.get("duration");
    }
    /**
     * A promise to get the ended state of the video.
     *
     * @promise GetEndedPromise
     * @fulfill {boolean} Whether or not the video has ended.
     */
    /**
     * Get the ended state of the video. The video has ended if
     * `currentTime === duration`.
     *
     * @return {GetEndedPromise}
     */
  }, {
    key: "getEnded",
    value: function() {
      return this.get("ended");
    }
    /**
     * A promise to get the loop state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the player is set to loop.
     */
    /**
     * Get the loop state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getLoop",
    value: function() {
      return this.get("loop");
    }
    /**
     * A promise to set the loop state of the player.
     *
     * @promise SetLoopPromise
     * @fulfill {boolean} The loop state that was set.
     */
    /**
     * Set the loop state of the player. When set to `true`, the player
     * will start over immediately once playback ends.
     *
     * @param {boolean} loop
     * @return {SetLoopPromise}
     */
  }, {
    key: "setLoop",
    value: function(t) {
      return this.set("loop", t);
    }
    /**
     * A promise to set the muted state of the player.
     *
     * @promise SetMutedPromise
     * @fulfill {boolean} The muted state that was set.
     */
    /**
     * Set the muted state of the player. When set to `true`, the player
     * volume will be muted.
     *
     * @param {boolean} muted
     * @return {SetMutedPromise}
     */
  }, {
    key: "setMuted",
    value: function(t) {
      return this.set("muted", t);
    }
    /**
     * A promise to get the muted state of the player.
     *
     * @promise GetMutedPromise
     * @fulfill {boolean} Whether or not the player is muted.
     */
    /**
     * Get the muted state of the player.
     *
     * @return {GetMutedPromise}
     */
  }, {
    key: "getMuted",
    value: function() {
      return this.get("muted");
    }
    /**
     * A promise to get the paused state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the video is paused.
     */
    /**
     * Get the paused state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getPaused",
    value: function() {
      return this.get("paused");
    }
    /**
     * A promise to get the playback rate of the player.
     *
     * @promise GetPlaybackRatePromise
     * @fulfill {number} The playback rate of the player on a scale from 0 to 2.
     */
    /**
     * Get the playback rate of the player on a scale from `0` to `2`.
     *
     * @return {GetPlaybackRatePromise}
     */
  }, {
    key: "getPlaybackRate",
    value: function() {
      return this.get("playbackRate");
    }
    /**
     * A promise to set the playbackrate of the player.
     *
     * @promise SetPlaybackRatePromise
     * @fulfill {number} The playback rate was set.
     * @reject {RangeError} The playback rate was less than 0 or greater than 2.
     */
    /**
     * Set the playback rate of the player on a scale from `0` to `2`. When set
     * via the API, the playback rate will not be synchronized to other
     * players or stored as the viewer's preference.
     *
     * @param {number} playbackRate
     * @return {SetPlaybackRatePromise}
     */
  }, {
    key: "setPlaybackRate",
    value: function(t) {
      return this.set("playbackRate", t);
    }
    /**
     * A promise to get the played property of the video.
     *
     * @promise GetPlayedPromise
     * @fulfill {Array} Played Timeranges converted to an Array.
     */
    /**
     * Get the played property of the video.
     *
     * @return {GetPlayedPromise}
     */
  }, {
    key: "getPlayed",
    value: function() {
      return this.get("played");
    }
    /**
     * A promise to get the qualities available of the current video.
     *
     * @promise GetQualitiesPromise
     * @fulfill {Array} The qualities of the video.
     */
    /**
     * Get the qualities of the current video.
     *
     * @return {GetQualitiesPromise}
     */
  }, {
    key: "getQualities",
    value: function() {
      return this.get("qualities");
    }
    /**
     * A promise to get the current set quality of the video.
     *
     * @promise GetQualityPromise
     * @fulfill {string} The current set quality.
     */
    /**
     * Get the current set quality of the video.
     *
     * @return {GetQualityPromise}
     */
  }, {
    key: "getQuality",
    value: function() {
      return this.get("quality");
    }
    /**
     * A promise to set the video quality.
     *
     * @promise SetQualityPromise
     * @fulfill {number} The quality was set.
     * @reject {RangeError} The quality is not available.
     */
    /**
     * Set a video quality.
     *
     * @param {string} quality
     * @return {SetQualityPromise}
     */
  }, {
    key: "setQuality",
    value: function(t) {
      return this.set("quality", t);
    }
    /**
     * A promise to get the remote playback availability.
     *
     * @promise RemotePlaybackAvailabilityPromise
     * @fulfill {boolean} Whether remote playback is available.
     */
    /**
     * Get the availability of remote playback.
     *
     * @return {RemotePlaybackAvailabilityPromise}
     */
  }, {
    key: "getRemotePlaybackAvailability",
    value: function() {
      return this.get("remotePlaybackAvailability");
    }
    /**
     * A promise to get the current remote playback state.
     *
     * @promise RemotePlaybackStatePromise
     * @fulfill {string} The state of the remote playback: connecting, connected, or disconnected.
     */
    /**
     * Get the current remote playback state.
     *
     * @return {RemotePlaybackStatePromise}
     */
  }, {
    key: "getRemotePlaybackState",
    value: function() {
      return this.get("remotePlaybackState");
    }
    /**
     * A promise to get the seekable property of the video.
     *
     * @promise GetSeekablePromise
     * @fulfill {Array} Seekable Timeranges converted to an Array.
     */
    /**
     * Get the seekable property of the video.
     *
     * @return {GetSeekablePromise}
     */
  }, {
    key: "getSeekable",
    value: function() {
      return this.get("seekable");
    }
    /**
     * A promise to get the seeking property of the player.
     *
     * @promise GetSeekingPromise
     * @fulfill {boolean} Whether or not the player is currently seeking.
     */
    /**
     * Get if the player is currently seeking.
     *
     * @return {GetSeekingPromise}
     */
  }, {
    key: "getSeeking",
    value: function() {
      return this.get("seeking");
    }
    /**
     * A promise to get the text tracks of a video.
     *
     * @promise GetTextTracksPromise
     * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
     */
    /**
     * Get an array of the text tracks that exist for the video.
     *
     * @return {GetTextTracksPromise}
     */
  }, {
    key: "getTextTracks",
    value: function() {
      return this.get("textTracks");
    }
    /**
     * A promise to get the embed code for the video.
     *
     * @promise GetVideoEmbedCodePromise
     * @fulfill {string} The `<iframe>` embed code for the video.
     */
    /**
     * Get the `<iframe>` embed code for the video.
     *
     * @return {GetVideoEmbedCodePromise}
     */
  }, {
    key: "getVideoEmbedCode",
    value: function() {
      return this.get("videoEmbedCode");
    }
    /**
     * A promise to get the id of the video.
     *
     * @promise GetVideoIdPromise
     * @fulfill {number} The id of the video.
     */
    /**
     * Get the id of the video.
     *
     * @return {GetVideoIdPromise}
     */
  }, {
    key: "getVideoId",
    value: function() {
      return this.get("videoId");
    }
    /**
     * A promise to get the title of the video.
     *
     * @promise GetVideoTitlePromise
     * @fulfill {number} The title of the video.
     */
    /**
     * Get the title of the video.
     *
     * @return {GetVideoTitlePromise}
     */
  }, {
    key: "getVideoTitle",
    value: function() {
      return this.get("videoTitle");
    }
    /**
     * A promise to get the native width of the video.
     *
     * @promise GetVideoWidthPromise
     * @fulfill {number} The native width of the video.
     */
    /**
     * Get the native width of the currently‐playing video. The width of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoWidthPromise}
     */
  }, {
    key: "getVideoWidth",
    value: function() {
      return this.get("videoWidth");
    }
    /**
     * A promise to get the native height of the video.
     *
     * @promise GetVideoHeightPromise
     * @fulfill {number} The native height of the video.
     */
    /**
     * Get the native height of the currently‐playing video. The height of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoHeightPromise}
     */
  }, {
    key: "getVideoHeight",
    value: function() {
      return this.get("videoHeight");
    }
    /**
     * A promise to get the vimeo.com url for the video.
     *
     * @promise GetVideoUrlPromise
     * @fulfill {number} The vimeo.com url for the video.
     * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
     */
    /**
     * Get the vimeo.com url for the video.
     *
     * @return {GetVideoUrlPromise}
     */
  }, {
    key: "getVideoUrl",
    value: function() {
      return this.get("videoUrl");
    }
    /**
     * A promise to get the volume level of the player.
     *
     * @promise GetVolumePromise
     * @fulfill {number} The volume level of the player on a scale from 0 to 1.
     */
    /**
     * Get the current volume level of the player on a scale from `0` to `1`.
     *
     * Most mobile devices do not support an independent volume from the
     * system volume. In those cases, this method will always return `1`.
     *
     * @return {GetVolumePromise}
     */
  }, {
    key: "getVolume",
    value: function() {
      return this.get("volume");
    }
    /**
     * A promise to set the volume level of the player.
     *
     * @promise SetVolumePromise
     * @fulfill {number} The volume was set.
     * @reject {RangeError} The volume was less than 0 or greater than 1.
     */
    /**
     * Set the volume of the player on a scale from `0` to `1`. When set
     * via the API, the volume level will not be synchronized to other
     * players or stored as the viewer’s preference.
     *
     * Most mobile devices do not support setting the volume. An error will
     * *not* be triggered in that situation.
     *
     * @param {number} volume
     * @return {SetVolumePromise}
     */
  }, {
    key: "setVolume",
    value: function(t) {
      return this.set("volume", t);
    }
    /** @typedef {import('./lib/timing-object.types').TimingObject} TimingObject */
    /** @typedef {import('./lib/timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */
    /** @typedef {import('./lib/timing-src-connector').TimingSrcConnector} TimingSrcConnector */
    /**
     * Connects a TimingObject to the video player (https://webtiming.github.io/timingobject/)
     *
     * @param {TimingObject} timingObject
     * @param {TimingSrcConnectorOptions} options
     *
     * @return {Promise<TimingSrcConnector>}
     */
  }, {
    key: "setTimingSrc",
    value: function() {
      var e = nt(/* @__PURE__ */ we().mark(function a(r, s) {
        var i = this, o;
        return we().wrap(function(l) {
          for (; ; ) switch (l.prev = l.next) {
            case 0:
              if (r) {
                l.next = 2;
                break;
              }
              throw new TypeError("A Timing Object must be provided.");
            case 2:
              return l.next = 4, this.ready();
            case 4:
              return o = new Wc(this, r, s), tt(this, "notifyTimingObjectConnect"), o.addEventListener("disconnect", function() {
                return tt(i, "notifyTimingObjectDisconnect");
              }), l.abrupt("return", o);
            case 8:
            case "end":
              return l.stop();
          }
        }, a, this);
      }));
      function t(a, r) {
        return e.apply(this, arguments);
      }
      return t;
    }()
  }]), n;
}();
Da || ($e = qc(), Hc(), zc(), Rc(), Vc());
function Uc(n) {
  var e = n.player, t = n.event, a = n.emit;
  e.on(t, function(r) {
    return a(t, r, e);
  });
}
var Kc = ["play", "playing", "pause", "ended", "timeupdate", "progress", "seeking", "seeked", "texttrackchange", "chapterchange", "cuechange", "cuepoint", "volumechange", "playbackratechange", "bufferstart", "bufferend", "error", "loaded", "durationchange", "fullscreenchange", "qualitychange", "camerachange", "resize"], on = {
  name: "VimeoPlayer",
  props: {
    playerHeight: {
      type: Number,
      default: 320
    },
    playerWidth: {
      type: Number,
      default: 640
    },
    options: {
      type: Object,
      default: function() {
        return {};
      }
    },
    videoId: {
      type: String,
      default: ""
    },
    videoUrl: {
      type: String,
      default: ""
    },
    loop: {
      type: Boolean,
      default: !1
    },
    autoplay: {
      type: Boolean,
      default: !1
    },
    controls: {
      type: Boolean,
      default: !0
    },
    eventsToEmit: {
      type: Array,
      default: function() {
        return Kc;
      }
    }
  },
  setup: function(e, t) {
    var a = t.emit, r, s = I(null), i = Ga(e), o = i.videoId, u = i.videoUrl;
    !e.videoId && !e.videoUrl && console.warn("[VueVimeoPlayer: You mist provide at least a videoId or a videoUrl prop]");
    var l = function(D) {
      var E = D.id, T = D.url, g = {
        width: e.playerWidth,
        height: e.playerHeight,
        loop: e.loop,
        autoplay: e.autoplay,
        controls: e.controls
      };
      return S(T) && (g.url = S(T)), S(E) && (g.id = S(E)), Object.assign(g, e.options);
    }, f = function() {
      return r.play();
    }, v = function() {
      return r.pause();
    }, d = function() {
      return r.setVolume(0);
    }, m = function() {
      var D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0.5;
      return r.setVolume(D);
    }, p = function() {
      r.ready().then(function() {
        a("ready", r);
      }).catch(function(D) {
        a("error", D, r);
      }), e.eventsToEmit.forEach(function(D) {
        return Uc({
          player: r,
          event: D,
          emit: a
        });
      });
    };
    de(function() {
      r = new Pn(s.value, l({
        id: e.videoId,
        url: e.videoUrl
      })), p();
    }), Ve(function() {
      return r.unload();
    }), le(o, function(x) {
      return r.loadVideo(l({
        id: x
      }));
    }), le(u, function(x) {
      return r.loadVideo(l({
        url: x
      }));
    }), le(Ya(e, "controls"), function() {
      return r.loadVideo(l({
        url: u,
        id: o
      }));
    });
    var L = function(D) {
      return r.loadVideo(l({
        id: D
      }));
    };
    return {
      update: L,
      play: f,
      pause: v,
      mute: d,
      unmute: m,
      elementRef: s,
      player: r
    };
  }
}, Gc = {
  ref: "elementRef"
};
function Yc(n, e, t, a, r, s) {
  return c(), w(
    "div",
    Gc,
    null,
    512
    /* NEED_PATCH */
  );
}
on.render = Yc;
const Qc = ["data-state"], Xc = { class: "ds-video-takeover__container" }, Zc = ["inert"], Jc = { class: "ds-video-takeover__testimonial" }, ed = ["inert"], td = /* @__PURE__ */ M("div", { class: "ds-video-takeover__video-overlay" }, null, -1), nd = ["src"], ad = ["inert"], Dd = /* @__PURE__ */ q({
  __name: "ds-video-takeover",
  props: {
    ariaLabelPlay: { default: "Play" },
    ariaLabelPause: { default: "Pause" },
    ariaLabelClose: { default: "Close" },
    buttonText: {},
    posterImageSrc: {},
    quoteName: {},
    quoteRole: {},
    quoteText: {},
    videoFullVimeoUrl: {},
    videoBgVimeoUrl: {}
  },
  setup(n) {
    const e = I(null), t = I(!1), a = I(!1), r = I(null), s = I(null), i = I(!1), o = I(!1), u = I("bg"), l = I(
      null
    ), f = I("play"), v = I(0), d = I("pause"), m = I(!1), p = (R, J, re, te) => {
      const ie = [];
      return R && ie.push("ds-video-takeover__video-wrapper--ready"), J === re && ie.push("ds-video-takeover__video-wrapper--active"), te && ie.push("ds-video-takeover__video-wrapper--hide-poster"), ie;
    }, L = b(
      () => p(
        o.value,
        "bg",
        u.value,
        m.value
      )
    ), x = b(
      () => p(
        i.value,
        "full",
        u.value,
        m.value
      )
    ), D = () => {
      i.value = !0;
    }, E = async () => {
      o.value = !0;
    }, T = () => {
      m.value === !1 && (m.value = !0);
    }, g = [];
    let C = !1;
    const $ = async () => {
      if (!C) {
        C = !0;
        try {
          for (; g.length > 0; ) {
            const R = g.shift();
            if (!R) break;
            await R();
          }
        } catch (R) {
          console.error("Action failed", R);
        } finally {
          C = !1;
        }
      }
    }, k = (R) => {
      g.push(R), $();
    };
    de(() => {
      window.addEventListener("keydown", Z);
    }), na(() => {
      window.removeEventListener("keydown", Z);
    }), wt(
      e,
      ([R]) => {
        t.value = (R == null ? void 0 : R.isIntersecting) || !1;
      },
      { threshold: 0.75 }
    );
    const y = async (R, J = 1e3) => new Promise((re, te) => {
      let ie = setTimeout(() => {
        console.warn("Vimeo play() timed out"), te(new Error("Vimeo play() timed out"));
      }, J);
      R.play().then(() => {
        clearTimeout(ie), re();
      }).catch((ye) => {
        clearTimeout(ie), te(ye);
      });
    }), N = async (R, J = 500) => new Promise((re, te) => {
      let ie = setTimeout(() => {
        console.warn("Vimeo pause() timed out"), te(new Error("Vimeo pause() timed out"));
      }, J);
      R.pause().then(() => {
        clearTimeout(ie), re();
      }).catch((ye) => {
        clearTimeout(ie), te(ye);
      });
    }), F = async (R = !0) => {
      k(async () => {
        try {
          s.value && "play" in s.value && await y(s.value);
        } catch (J) {
          console.error(J);
        }
        B(!0), R && (f.value = "play");
      });
    }, G = async (R = !0) => {
      k(async () => {
        try {
          s.value && "pause" in s.value && await N(s.value);
        } catch (J) {
          console.error(J);
        }
        B(!1), R && (f.value = "pause");
      });
    }, h = () => {
      u.value = "full";
    }, _ = (R) => {
      v.value = R.percent;
    }, B = (R) => {
      var J;
      (J = l.value) == null || J.setButtonState(R);
    }, V = async () => {
      var R;
      r.value && ((R = r.value) == null || R.pause()), u.value = "bg", f.value !== "pause" && await F(!1);
    }, A = async () => {
      var R;
      await G(!1), (R = r.value) == null || R.pause(), u.value = "bg";
    }, j = async () => {
      var R, J, re;
      await G(!1), (R = r.value) == null || R.mute(), (J = r.value) == null || J.play(), (re = r.value) == null || re.unmute();
    }, Z = (R) => {
      R.key === "Escape" && u.value === "full" && V();
    };
    return le(t, async (R) => {
      s.value && (R ? (a.value = !0, V()) : A());
    }), le(u, (R) => {
      R === "full" && j();
    }), (R, J) => (c(), w("div", {
      class: "ds-video-takeover",
      "data-state": t.value ? "visible" : "hidden",
      ref_key: "takeoverRef",
      ref: e
    }, [
      z(qt, {
        background: "neutral",
        class: "ds-video-takeover__block"
      }, {
        default: H(() => [
          M("div", Xc, [
            z(Ue, { name: "content" }, {
              default: H(() => [
                ve(M("div", {
                  class: "ds-video-takeover__content",
                  inert: u.value === "full"
                }, [
                  M("blockquote", Jc, [
                    R.quoteText ? (c(), O(Y, {
                      key: 0,
                      class: "ds-video-takeover__quote",
                      "text-style": "medium",
                      "text-type": "heading-2xl"
                    }, {
                      default: H(() => [
                        K(W(R.quoteText), 1)
                      ]),
                      _: 1
                    })) : P("", !0),
                    R.quoteName ? (c(), O(Y, {
                      key: 1,
                      class: "ds-video-takeover__name",
                      "text-style": "medium",
                      "text-type": "heading-lg"
                    }, {
                      default: H(() => [
                        K(W(R.quoteName), 1)
                      ]),
                      _: 1
                    })) : P("", !0),
                    R.quoteRole ? (c(), O(Y, {
                      key: 2,
                      class: "ds-video-takeover__role",
                      "text-type": "body-xs"
                    }, {
                      default: H(() => [
                        K(W(R.quoteRole), 1)
                      ]),
                      _: 1
                    })) : P("", !0)
                  ]),
                  z(be, {
                    "icon-start": "button-play",
                    variant: "primary-inverted",
                    "click-handler": h,
                    "data-testid": "watchButton"
                  }, {
                    default: H(() => [
                      K(W(R.buttonText), 1)
                    ]),
                    _: 1
                  })
                ], 8, Zc), [
                  [pe, t.value && u.value === "bg"]
                ])
              ]),
              _: 1
            }),
            z(Ue, { name: "content" }, {
              default: H(() => [
                R.videoBgVimeoUrl ? ve((c(), O(so, {
                  key: 0,
                  class: "ds-video-takeover__progress-button",
                  "aria-label-play": R.ariaLabelPlay,
                  playHandler: (re) => F(),
                  "aria-label-pause": R.ariaLabelPause,
                  initialState: d.value,
                  progress: v.value,
                  pauseHandler: (re) => G(),
                  ref_key: "progressButton",
                  ref: l
                }, null, 8, ["aria-label-play", "playHandler", "aria-label-pause", "initialState", "progress", "pauseHandler"])), [
                  [pe, t.value && u.value === "bg"]
                ]) : P("", !0)
              ]),
              _: 1
            }),
            M("div", {
              class: U(["ds-video-takeover__video-wrapper ds-video-takeover__video-wrapper--bg", L.value]),
              "data-testid": "video-wrapper-bg",
              inert: u.value === "full",
              style: ge(`--poster-img: url(${R.posterImageSrc})`)
            }, [
              td,
              R.videoBgVimeoUrl ? (c(), O(S(on), {
                key: 0,
                "data-testid": "video-bg-player",
                tabindex: "-1",
                class: "ds-video-takeover__video",
                ref_key: "vimeoBgPlayer",
                ref: s,
                onReady: E,
                onPlaying: T,
                onTimeupdate: _,
                videoUrl: `${R.videoBgVimeoUrl}`,
                options: {
                  autopause: !0,
                  autoplay: !1,
                  controls: !1,
                  dnt: !0,
                  loop: !0,
                  muted: !0
                }
              }, null, 8, ["videoUrl"])) : P("", !0),
              R.posterImageSrc ? (c(), w("img", {
                key: 1,
                class: "ds-video-takeover__poster-img",
                src: R.posterImageSrc,
                alt: ""
              }, null, 8, nd)) : P("", !0)
            ], 14, ed),
            M("div", {
              class: U(["ds-video-takeover__video-wrapper ds-video-takeover__video-wrapper--full", x.value]),
              "data-testid": "video-wrapper-full",
              inert: u.value === "bg"
            }, [
              z(he, {
                class: "ds-video-takeover__close",
                "click-handler": V,
                ariaLabel: R.ariaLabelClose,
                "icon-name": "button-close",
                variant: "ghost-inverted"
              }, null, 8, ["ariaLabel"]),
              z(S(on), {
                class: "ds-video-takeover__vimeo",
                ref_key: "vimeoPlayer",
                ref: r,
                onReady: D,
                videoUrl: `${R.videoFullVimeoUrl}`,
                options: {
                  autopause: !0,
                  background: !1,
                  controls: !0,
                  dnt: !0,
                  loop: !1,
                  muted: !0,
                  autoplay: !1
                }
              }, null, 8, ["videoUrl"])
            ], 10, ad)
          ])
        ]),
        _: 1
      })
    ], 8, Qc));
  }
}), Fd = [
  "accept",
  "capture",
  "labelAddFilesButton",
  "labelDropFiles",
  "labelRemove",
  "labelTapToAdd",
  "listMode",
  "maxFileSize",
  "multiple",
  "validationMessageFileSize",
  "validationMessageDuplicate",
  "validationMessageType"
];
export {
  sd as DsAccordion,
  od as DsAccordionItem,
  or as DsAlert,
  lr as DsBadge,
  ld as DsBanner,
  ud as DsBannerLg,
  id as DsBannerMd,
  ld as DsBannerSm,
  cd as DsBannerXl,
  qt as DsBlock,
  la as DsBrandIcon,
  dd as DsBreadcrumb,
  be as DsButton,
  ba as DsButtonGroup,
  fd as DsButtonPlay,
  so as DsButtonPlayProgress,
  md as DsCardAction,
  vd as DsCardProduct,
  pd as DsCarousel,
  hd as DsDialog,
  gd as DsFileUpload,
  gl as DsGrid,
  bd as DsHeader,
  ae as DsIcon,
  qo as DsIconAttention,
  he as DsIconButton,
  Yo as DsModal,
  yd as DsPageHeader,
  _d as DsPagination,
  kd as DsProgressDots,
  wd as DsQuantitySelector,
  $d as DsScrollProgressBar,
  Td as DsSkeletonBox,
  Sd as DsSkeletonButton,
  Pd as DsSkeletonCircle,
  Ld as DsSkeletonSurface,
  Cd as DsSkeletonTextLine,
  Md as DsSkeletonWrapper,
  Id as DsSpinner,
  Ed as DsStickyPanels,
  Vu as DsTab,
  Nd as DsTable,
  Ad as DsTabs,
  Ea as DsTag,
  xd as DsTestimonial,
  Y as DsText,
  Bd as DsToast,
  Od as DsToggletip,
  Ks as DsTooltip,
  iu as DsUnderscore,
  Dd as DsVideoTakeover,
  Ie as dsUseIsMobile,
  Ze as dsUseUniqueId,
  Fd as fkFileUploadProps
};
